var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"],
  _excluded2 = ["tag", "children", "className", "swiper", "zoom", "lazy", "virtualIndex", "swiperSlideIndex"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e102) { throw _e102; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e103) { didErr = true; err = _e103; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import e, { forwardRef as t, useState as r, useRef as n, useEffect as i, useLayoutEffect as a, createContext as s, useMemo as o, useImperativeHandle as l, Children as c, useReducer as d, useCallback as p, useContext as u } from "react";
import { createPortal as m } from "react-dom";
import { Loader as f, FlashMessage as g } from "@reactiveonline/frontend_shared_components";
function h(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function b(e, t, r, n, i, a, s) {
  try {
    var o = e[a](s),
      l = o.value;
  } catch (e) {
    return void r(e);
  }
  o.done ? t(l) : Promise.resolve(l).then(n, i);
}
function v(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (n, i) {
      var a = e.apply(t, r);
      function s(e) {
        b(a, n, i, s, o, "next", e);
      }
      function o(e) {
        b(a, n, i, s, o, "throw", e);
      }
      s(void 0);
    });
  };
}
function w(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != _typeof(e) || !e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" != _typeof(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == _typeof(t) ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function y() {
  return y = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y.apply(null, arguments);
}
function S(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function x(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? S(Object(r), !0).forEach(function (t) {
      w(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function E() {
  E = function E() {
    return t;
  };
  var e,
    t = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    i = Object.defineProperty || function (e, t, r) {
      e[t] = r.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    s = a.iterator || "@@iterator",
    o = a.asyncIterator || "@@asyncIterator",
    l = a.toStringTag || "@@toStringTag";
  function c(e, t, r) {
    return Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    c({}, "");
  } catch (e) {
    c = function c(e, t, r) {
      return e[t] = r;
    };
  }
  function d(e, t, r, n) {
    var a = t && t.prototype instanceof b ? t : b,
      s = Object.create(a.prototype),
      o = new O(n || []);
    return i(s, "_invoke", {
      value: C(e, r, o)
    }), s;
  }
  function p(e, t, r) {
    try {
      return {
        type: "normal",
        arg: e.call(t, r)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = d;
  var u = "suspendedStart",
    m = "suspendedYield",
    f = "executing",
    g = "completed",
    h = {};
  function b() {}
  function v() {}
  function w() {}
  var y = {};
  c(y, s, function () {
    return this;
  });
  var S = Object.getPrototypeOf,
    x = S && S(S(I([])));
  x && x !== r && n.call(x, s) && (y = x);
  var T = w.prototype = b.prototype = Object.create(y);
  function k(e) {
    ["next", "throw", "return"].forEach(function (t) {
      c(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function A(e, t) {
    function r(i, a, s, o) {
      var l = p(e[i], e, a);
      if ("throw" !== l.type) {
        var c = l.arg,
          d = c.value;
        return d && "object" == _typeof(d) && n.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
          r("next", e, s, o);
        }, function (e) {
          r("throw", e, s, o);
        }) : t.resolve(d).then(function (e) {
          c.value = e, s(c);
        }, function (e) {
          return r("throw", e, s, o);
        });
      }
      o(l.arg);
    }
    var a;
    i(this, "_invoke", {
      value: function value(e, n) {
        function i() {
          return new t(function (t, i) {
            r(e, n, t, i);
          });
        }
        return a = a ? a.then(i, i) : i();
      }
    });
  }
  function C(t, r, n) {
    var i = u;
    return function (a, s) {
      if (i === f) throw Error("Generator is already running");
      if (i === g) {
        if ("throw" === a) throw s;
        return {
          value: e,
          done: !0
        };
      }
      for (n.method = a, n.arg = s;;) {
        var o = n.delegate;
        if (o) {
          var l = M(o, n);
          if (l) {
            if (l === h) continue;
            return l;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (i === u) throw i = g, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        i = f;
        var c = p(t, r, n);
        if ("normal" === c.type) {
          if (i = n.done ? g : m, c.arg === h) continue;
          return {
            value: c.arg,
            done: n.done
          };
        }
        "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
      }
    };
  }
  function M(t, r) {
    var n = r.method,
      i = t.iterator[n];
    if (i === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), h;
    var a = p(i, t.iterator, r.arg);
    if ("throw" === a.type) return r.method = "throw", r.arg = a.arg, r.delegate = null, h;
    var s = a.arg;
    return s ? s.done ? (r[t.resultName] = s.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, h) : s : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, h);
  }
  function P(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function L(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function O(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(P, this), this.reset(!0);
  }
  function I(t) {
    if (t || "" === t) {
      var r = t[s];
      if (r) return r.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var i = -1,
          a = function r() {
            for (; ++i < t.length;) if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
            return r.value = e, r.done = !0, r;
          };
        return a.next = a;
      }
    }
    throw new TypeError(_typeof(t) + " is not iterable");
  }
  return v.prototype = w, i(T, "constructor", {
    value: w,
    configurable: !0
  }), i(w, "constructor", {
    value: v,
    configurable: !0
  }), v.displayName = c(w, l, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, w) : (e.__proto__ = w, c(e, l, "GeneratorFunction")), e.prototype = Object.create(T), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, k(A.prototype), c(A.prototype, o, function () {
    return this;
  }), t.AsyncIterator = A, t.async = function (e, r, n, i, a) {
    void 0 === a && (a = Promise);
    var s = new A(d(e, r, n, i), a);
    return t.isGeneratorFunction(r) ? s : s.next().then(function (e) {
      return e.done ? e.value : s.next();
    });
  }, k(T), c(T, l, "Generator"), c(T, s, function () {
    return this;
  }), c(T, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      r = [];
    for (var n in t) r.push(n);
    return r.reverse(), function e() {
      for (; r.length;) {
        var n = r.pop();
        if (n in t) return e.value = n, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = I, O.prototype = {
    constructor: O,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(L), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var r = this;
      function i(n, i) {
        return o.type = "throw", o.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var s = this.tryEntries[a],
          o = s.completion;
        if ("root" === s.tryLoc) return i("end");
        if (s.tryLoc <= this.prev) {
          var l = n.call(s, "catchLoc"),
            c = n.call(s, "finallyLoc");
          if (l && c) {
            if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
            if (this.prev < s.finallyLoc) return i(s.finallyLoc);
          } else if (l) {
            if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
          } else {
            if (!c) throw Error("try statement without catch or finally");
            if (this.prev < s.finallyLoc) return i(s.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var i = this.tryEntries[r];
        if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
          var a = i;
          break;
        }
      }
      a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
      var s = a ? a.completion : {};
      return s.type = e, s.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, h) : this.complete(s);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), L(r), h;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc === e) {
          var n = r.completion;
          if ("throw" === n.type) {
            var i = n.arg;
            L(r);
          }
          return i;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, r, n) {
      return this.delegate = {
        iterator: I(t),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = e), h;
    }
  }, t;
}
function T(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var n,
        i,
        a,
        s,
        o = [],
        l = !0,
        c = !1;
      try {
        if (a = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          l = !1;
        } else for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); l = !0);
      } catch (e) {
        c = !0, i = e;
      } finally {
        try {
          if (!l && null != r.return && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (c) throw i;
        }
      }
      return o;
    }
  }(e, t) || A(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function k(e) {
  return function (e) {
    if (Array.isArray(e)) return h(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || A(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function A(e, t) {
  if (e) {
    if ("string" == typeof e) return h(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(e, t) : void 0;
  }
}
function C(e, t) {
  void 0 === t && (t = {});
  var r = t.insertAt;
  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
      i = document.createElement("style");
    i.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(i, n.firstChild) : n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
  }
}
C('.reactive-builder-wrapper .rb-container {\n  position: relative;\n  flex: 1;\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-columns {\n  position: relative;\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-column {\n  position: relative;\n  width: 100%;\n}\n.reactive-builder-wrapper .rb-column.stack {\n  width: 100% !important;\n}\n\n.reactive-builder-wrapper .rb-slider {\n  position: relative;\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-slide {\n  position: relative;\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-tabs .rb-tabs-panel-row {\n  overflow-x: auto;\n}\n.reactive-builder-wrapper .rb-tabs .rb-tab-panel-wrapper {\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-tabs .rb-tab-panel-wrapper .rb-tab-panel-title {\n  text-align: center;\n  font-family: inherit;\n}\n.reactive-builder-wrapper .rb-tabs .rb-tab-panel-wrapper .rb-tab-panel-icon.left {\n  margin-right: 5px;\n}\n.reactive-builder-wrapper .rb-tabs .rb-tab-panel-wrapper .rb-tab-panel-icon.right {\n  margin-left: 5px;\n}\n.reactive-builder-wrapper .rb-tabs .rb-tab-panel-wrapper .rb-tab-panel-icon.top {\n  margin-bottom: 5px;\n}\n.reactive-builder-wrapper .rb-tabs .rb-tab-panel-wrapper .rb-tab-panel-icon.bottom {\n  margin-top: 5px;\n}\n\n.reactive-builder-wrapper .rb-tab {\n  position: relative;\n}\n\n.reactive-builder-wrapper .rb-flip-card {\n  position: relative;\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-card-content-wrapper {\n  position: relative;\n  transition: transform 0.6s;\n  -webkit-transition: transform 0.6s;\n  transform-style: preserve-3d;\n  -webkit-transform-style: preserve-3d;\n  width: 100%;\n  height: 100%;\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-card-content-wrapper .rb-flip-card-front-card {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-card-content-wrapper .rb-flip-card-front-card .rb-flip-card-icon {\n  margin-bottom: 10px;\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-card-content-wrapper .rb-flip-card-back-card {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-right {\n  transform: rotateY(180deg);\n  -webkit-transform: rotateY(180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-left {\n  transform: rotateY(-180deg);\n  -webkit-transform: rotateY(-180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-up {\n  transform: rotateX(180deg);\n  -webkit-transform: rotateX(180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-down {\n  transform: rotateX(-180deg);\n  -webkit-transform: rotateX(-180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-diagonal-right {\n  transform: rotate3d(-1, 1, 0, 180deg);\n  -webkit-transform: rotate3d(-1, 1, 0, 180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-diagonal-left {\n  transform: rotate3d(1, 1, 0, -180deg);\n  -webkit-transform: rotate3d(1, 1, 0, -180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-inverted-diagonal-right {\n  transform: rotate3d(1, 1, 0, 180deg);\n  -webkit-transform: rotate3d(1, 1, 0, 180deg);\n}\n.reactive-builder-wrapper .rb-flip-card .rb-flip-inverted-diagonal-left {\n  transform: rotate3d(1, -1, 0, 180deg);\n  -webkit-transform: rotate3d(1, -1, 0, 180deg);\n}\n\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-heading {\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-heading .rb-accordion-item-icon.left {\n  margin-right: 10px;\n}\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-heading .rb-accordion-item-icon.right {\n  margin-left: 10px;\n}\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-heading .rb-accordion-item-heading-title-wrapper {\n  font-family: inherit;\n}\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-heading .rb-accordion-item-heading-title-wrapper .rb-accordion-item-heading-title {\n  font-family: inherit;\n}\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-content-wrapper {\n  position: relative;\n}\n.reactive-builder-wrapper .rb-accordion-item .rb-accordion-item-content-wrapper .rb-block-content {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.reactive-builder-wrapper .rb-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: inherit;\n}\n\n.reactive-builder-wrapper .rb-heading {\n  margin: 0;\n}\n\n.reactive-builder-wrapper .rb-text {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n}\n.reactive-builder-wrapper .rb-text ::-webkit-scrollbar {\n  height: 0px;\n  width: 0px;\n  background: transparent;\n}\n\n.reactive-builder-wrapper .rb-button {\n  text-align: center;\n  cursor: pointer;\n}\n\n.reactive-builder-wrapper .rb-audio audio {\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-blockquote .rb-blockquote-text {\n  padding: 0 10px;\n}\n\n.reactive-builder-wrapper .rb-youtube {\n  position: relative;\n}\n.reactive-builder-wrapper .rb-youtube .rb-video-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n}\n\n.reactive-builder-wrapper .rb-code {\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-checklist {\n  width: 100%;\n}\n.reactive-builder-wrapper .rb-checklist-item .rb-checklist-item-title {\n  font-family: inherit;\n}\n\n.reactive-builder-wrapper .rb-skill-bars {\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-skill-bar .rb-bar {\n  width: 100%;\n  border-radius: 4px;\n  margin-top: 6px;\n  background: rgba(0, 0, 0, 0.1);\n}\n.reactive-builder-wrapper .rb-skill-bar .rb-bar .rb-filled-bar {\n  position: relative;\n  display: block;\n  height: 100%;\n  border-radius: 4px;\n  animation: rb-progress 1.5s ease-in-out forwards;\n  -webkit-animation: progress 1.5s ease-in-out forwards;\n  -webkit-animation-delay: 0.3s;\n  opacity: 0;\n}\n.reactive-builder-wrapper .rb-skill-bar .rb-bar .rb-filled-bar .rb-tooltip {\n  font-weight: 600;\n  color: #FFFFFF;\n  font-size: 14px;\n  position: absolute;\n  right: 0;\n  top: -25px;\n  padding: 0 5px;\n  border-radius: 4px;\n  z-index: 1;\n  height: 20px;\n}\n@keyframes rb-progress {\n  0% {\n    width: 0;\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.reactive-builder-wrapper .rb-testimonials {\n  position: relative;\n  width: 100%;\n}\n\n.reactive-builder-wrapper .rb-testimonial {\n  position: relative;\n  width: 100%;\n}\n.reactive-builder-wrapper .rb-testimonial .rb-testimonial-title {\n  padding: 10px 0;\n}\n.reactive-builder-wrapper .rb-testimonial .rb-testimonial-content {\n  padding: 5px 0;\n}\n\n.reactive-builder-wrapper .rb-form {\n  position: relative;\n  width: 100%;\n}\n.reactive-builder-wrapper .rb-form label {\n  cursor: text;\n  font-weight: 700 !important;\n  margin-bottom: 5px;\n}\n.reactive-builder-wrapper .rb-form label .rb-form-label {\n  font-family: inherit;\n}\n.reactive-builder-wrapper .rb-form input, .reactive-builder-wrapper .rb-form textarea, .reactive-builder-wrapper .rb-form .rb-form-dropdown-input {\n  border: 2px solid;\n  outline: none;\n  -webkit-appearance: none;\n}\n.reactive-builder-wrapper .rb-form textarea {\n  resize: none;\n}\n\n.reactive-builder-wrapper .rb-form-dropdown {\n  position: relative;\n}\n.reactive-builder-wrapper .rb-form-dropdown .rb-form-dropdown-input {\n  max-width: 300px;\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-form-dropdown .rb-form-dropdown-menu-wrapper {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 2px);\n  border: 2px solid;\n  max-width: 300px;\n  z-index: 1;\n  text-align: start;\n}\n.reactive-builder-wrapper .rb-form-dropdown .rb-form-dropdown-menu-wrapper .rb-form-dropdown-divider {\n  width: 100%;\n  height: 2px;\n  margin: 5px 0;\n}\n.reactive-builder-wrapper .rb-form-dropdown .rb-form-dropdown-item {\n  cursor: pointer;\n}\n\n.reactive-builder-wrapper .rb-form-checkbox-item {\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-form-checkbox-item .rb-form-checkbox-item-box-wrapper {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid;\n  margin-right: 5px;\n}\n.reactive-builder-wrapper .rb-form-checkbox-item .rb-form-checkbox-item-box-wrapper i {\n  font-size: 15px;\n}\n\n.reactive-builder-wrapper .rb-form-radio-item {\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-form-radio-item .rb-form-radio-item-outer-box {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1px solid;\n  margin-right: 5px;\n}\n.reactive-builder-wrapper .rb-form-radio-item .rb-form-radio-item-outer-box .rb-form-radio-item-inner-box {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.reactive-builder-wrapper .rb-form-submit-wrapper {\n  width: 100%;\n}\n.reactive-builder-wrapper .rb-form-submit-wrapper .rb-form-submit {\n  text-align: center;\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-form-submit-wrapper .rb-form-submit .rb-button-text {\n  align-self: center;\n  font-family: inherit;\n}\n\n.reactive-builder-wrapper .rb-block-overlay {\n  inset: 0;\n  position: absolute;\n  min-height: inherit;\n  max-width: inherit;\n  width: 100%;\n  height: 100%;\n}\n.reactive-builder-wrapper .rb-block-content-wrapper {\n  min-height: inherit;\n  max-width: 100%;\n  height: 100%;\n}\n.reactive-builder-wrapper .rb-block-content-wrapper .rb-block-content {\n  min-height: inherit;\n  max-width: inherit;\n  position: relative;\n  height: 100%;\n}\n.reactive-builder-wrapper .rb-block-link {\n  cursor: pointer;\n}\n.reactive-builder-wrapper .rb-text-content {\n  font-family: inherit;\n  text-decoration-color: inherit;\n}\n.reactive-builder-wrapper .rb-text-content * {\n  font-family: inherit;\n  text-decoration-color: inherit;\n}\n.reactive-builder-wrapper .rb-text-content p {\n  margin: 0;\n}\n.reactive-builder-wrapper .rb-text-content ul {\n  margin: 0px 0px 0px 40px;\n}\n.reactive-builder-wrapper .rb-text-content ul li {\n  list-style: disc;\n}\n.reactive-builder-wrapper .rb-text-content code {\n  font-family: Courier;\n  background-color: #EEEEEE;\n}\n.reactive-builder-wrapper .rb-text-content a {\n  font-weight: 700;\n}\n.reactive-builder-wrapper .rb-text-content blockquote {\n  margin: 0 0 0 0.3em;\n  padding: 0 0 0 0.6em;\n  border-left: 0.3em solid #CCCCCC;\n}\n.reactive-builder-wrapper .swiper .swiper-button-prev, .reactive-builder-wrapper .swiper .swiper-button-next {\n  color: var(--color-scheme) !important;\n  font-weight: 300;\n}\n.reactive-builder-wrapper .swiper .swiper-button-prev:after {\n  font-size: 44px;\n  font-family: var(--icons-font);\n  content: "\\f104";\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n}\n.reactive-builder-wrapper .swiper .swiper-button-next:after {\n  font-size: 44px;\n  font-family: var(--icons-font);\n  content: "\\f105";\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n}\n.reactive-builder-wrapper .swiper .swiper-pagination .swiper-pagination-bullet-active {\n  background: var(--color-scheme) !important;\n}\n.reactive-builder-wrapper .swiper .swiper-scrollbar {\n  background: rgb(from var(--color-scheme) r g b/0.3) !important;\n}\n.reactive-builder-wrapper .swiper .swiper-scrollbar .swiper-scrollbar-drag {\n  background: var(--color-scheme) !important;\n  cursor: grab;\n}\n.reactive-builder-wrapper .swiper .swiper-wrapper .swiper-slide {\n  box-sizing: border-box;\n}');
var M = [{
    themeSettingKey: "body",
    themeSettingObserver: {
      fontFamily: "fontFamily",
      fontSize: "fontSize",
      fontWeight: "fontWeight",
      letterSpacing: "letterSpacing",
      lineHeight: "lineHeight",
      textTransform: "textTransform",
      color: "color"
    }
  }],
  P = [].concat(M, [{
    themeSettingKey: "colors",
    themeSettingObserver: {
      textDecorationColor: "underlineColor"
    }
  }]);
function L(e) {
  var t = {};
  return Object.keys(e).forEach(function (r) {
    ["", "-", void 0].includes(e[r]) || (void 0 !== e["".concat(r, "Unit")] ? t[r] = (String(e[r]).endsWith(".") ? String(e[r]).replace(".", "") : e[r]) + e["".concat(r, "Unit")] : ["desktop", "laptop", "tablet", "mobile"].includes(r) || r.includes("Unit") || (t[r] = e[r]));
  }), t;
}
function O(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    n = {};
  return (e || r.themeSettingsSeedData) && (e && (n = L(e), e[t] && (n = x(x({}, n), L(x(x({}, e), e[t]))))), r.themeSettingsSeedData && r.themeSettingsSeedData.forEach(function (e) {
    var t = x({}, ThemeSettings[e.themeSettingKey] || {}),
      r = e.themeSettingObserver;
    r ? Object.keys(r).forEach(function (e) {
      I(n, e, t, r[e]);
    }) : Object.keys(t).forEach(function (e) {
      I(n, e, t);
    }), n = L(n);
  })), n;
}
function I(e, t, r) {
  var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
  if (!e[t]) {
    var i = x({}, r);
    if (i[n || t]) if (["fontSize", "letterSpacing", "lineHeight", "borderRadius", "maxWidth"].includes(t)) {
      var a = z(e, t, i[t]);
      a && (e[t] = a.value, e["".concat(t, "Unit")] = a.unit);
    } else if ("padding" === t) {
      var s = i[t].split(" ");
      s.forEach(function (t, r) {
        var n = null;
        1 === s.length ? n = "padding" : 0 === r ? n = "paddingTop" : 1 === r ? n = "paddingRight" : 2 === r ? n = "paddingBottom" : 3 === r && (n = "paddingLeft");
        var i = z(e, n, t);
        if (i) {
          var a = i.value,
            o = i.unit;
          1 === s.length ? (e.padding = a, e.paddingUnit = o) : (0 === r && (e.paddingTop = a, e.paddingTopUnit = o, s.length < 3 && (e.paddingBottom = a, e.paddingBottomUnit = o)), 1 === r && (e.paddingRight = a, e.paddingRightUnit = o, s.length < 4 && (e.paddingLeft = a, e.paddingLeftUnit = o)), 2 === r && (e.paddingBottom = a, e.paddingBottomUnit = o), 3 === r && (e.paddingLeft = a, e.paddingLeftUnit = o));
        }
      });
    } else e[t] = i[n || t];
  }
}
function z(e, t, r) {
  if (a = Object.keys(e), s = t, !a.includes(s) && "borderRadius" !== s && !s.startsWith("padding") || "borderRadius" === s && !a.find(function (e) {
    return e.startsWith("border") && e.endsWith("Radius");
  }) || "padding" === s && !a.find(function (e) {
    return e.startsWith("padding");
  }) || "padding" !== s && s.startsWith("padding") && !a.find(function (e) {
    return e === s;
  })) {
    r.match(/\d/) || (r = 0 + r);
    var n = r.match(/^(\d+\.?\d*)(px|em|rem|%)$/);
    if (n) {
      var i = T(n, 3);
      return i[0], {
        value: i[1],
        unit: i[2]
      };
    }
  }
  var a, s;
  return null;
}
function N(e, t) {
  var r = e.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/),
    n = "https://www.youtube.com/embed/".concat(r ? r[7] : "", "?");
  return Object.keys(t).map(function (e) {
    switch (e) {
      case "showRelated":
        n += "&rel=".concat(t[e] ? 1 : 0);
        break;
      case "showCaptions":
        n += t[e] ? "&cc_load_policy=1&cc_lang_pref=en" : "";
        break;
      case "autoplay":
        n += "&autoplay=".concat(t[e] ? 1 : 0);
        break;
      case "loop":
        n += t[e] ? "&loop=1&playlist=".concat(r[7]) : "";
        break;
      case "mute":
        n += "&mute=".concat(t[e] ? 1 : 0);
        break;
      case "controls":
        n += "&controls=".concat(t[e] ? 1 : 0);
        break;
      case "showFullscreen":
        n += "&fs=".concat(t[e] ? 1 : 0);
    }
  }), n;
}
function D(e, t) {
  var r = e.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i),
    n = "https://player.vimeo.com/video/".concat(r ? r[1] : "", "?");
  return Object.keys(t).map(function (e) {
    switch (e) {
      case "autoplay":
        n += "&autoplay=".concat(t[e] ? 1 : 0);
        break;
      case "showCaptions":
        n += t[e] ? "&texttrack=en" : "";
        break;
      case "loop":
        n += "&loop=".concat(t[e] ? 1 : 0);
        break;
      case "mute":
        n += "&muted=".concat(t[e] ? 1 : 0);
        break;
      case "controls":
        n += "&controls=".concat(t[e] ? 1 : 0);
        break;
      case "showFullscreen":
        n += "&fs=".concat(t[e] ? 1 : 0);
    }
  }), n;
}
function _(e, t) {
  if (t) {
    if ("desktop" === e) return !t.hideDesktop;
    if ("laptop" === e) return !t.hideLaptop;
    if ("tablet" === e) return !t.hideTablet;
    if ("mobile" === e) return !t.hideMobile;
  }
  return !0;
}
function B() {
  if (Object.keys(ThemeSettings).length) {
    var e = function e(_e2) {
      var t = "";
      return ["fontFamily", "fontSize", "fontWeight", "letterSpacing", "lineHeight", "textTransform", "color", "backgroundColor"].forEach(function (r) {
        var n;
        ThemeSettings[_e2] && ThemeSettings[_e2][r] && (t += "".concat((n = r, n.replace(/[A-Z]/g, function (e, t) {
          return (t ? "-" : "") + e.toLowerCase();
        })), ": ").concat(ThemeSettings[_e2][r], ";"));
      }), t;
    };
    return "\n      --color-scheme: ".concat(ThemeSettings.colors.colorScheme, ";\n      --icons-font: 'Font Awesome 6 Pro';\n      ").concat(e("body"), "\n      a { color: ").concat(ThemeSettings.colors.linkColor, " }\n      h1 { ").concat(e("h1"), " }\n      h2 { ").concat(e("h2"), " }\n      h3 { ").concat(e("h3"), " }\n      h4 { ").concat(e("h4"), " }\n      h5 { ").concat(e("h5"), " }\n      h6 { ").concat(e("h6"), " }\n    ");
  }
  return null;
}
function F(t) {
  var r = t.settings,
    n = t.deviceType,
    i = t.style,
    a = t.className,
    s = t.backgroundColorThemeSettingKey,
    o = t.children,
    l = r.backgroundType,
    c = r.backgroundTypeColor,
    d = r.backgroundTypeImage,
    p = r.backgroundTypeImageStyles,
    u = r.backgroundTypeOverlay,
    m = r.borderStyles,
    f = O(r.styles, n);
  if (i && (f = x(x({}, f), i)), !l || "color" === l) {
    var g = {};
    s && (g = {
      themeSettingsSeedData: [{
        themeSettingKey: s,
        themeSettingObserver: {
          backgroundColor: "backgroundColor"
        }
      }]
    }), f = x(x(x({}, f), O(c, n, g)), O(m, n));
  }
  var h = {};
  return "imageAndOverlay" === l && (h = x(x({}, O(p || {}, n)), O(m || {}, n)), d && d.image && (h = x(x({}, h), {}, {
    backgroundImage: "url(".concat(d.variant && d.image.variants ? d.image.variants[d.variant].sourceUrl : d.image.sourceUrl, ")")
  }))), /*#__PURE__*/e.createElement(e.Fragment, null, "imageAndOverlay" === l && u && u.overlay && /*#__PURE__*/e.createElement("div", {
    className: "rb-block-overlay",
    style: x({
      backgroundColor: u.overlayColor
    }, O(m, n))
  }), /*#__PURE__*/e.createElement("div", {
    className: "rb-block-content-wrapper",
    style: h
  }, /*#__PURE__*/e.createElement("div", {
    className: "rb-block-content ".concat(a || ""),
    style: f
  }, o)));
}
function G(e) {
  return null !== e && "object" == _typeof(e) && "constructor" in e && e.constructor === Object;
}
function j(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function (r) {
    void 0 === e[r] ? e[r] = t[r] : G(t[r]) && G(e[r]) && Object.keys(t[r]).length > 0 && j(e[r], t[r]);
  });
}
var $ = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ""
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function H() {
  var e = "undefined" != typeof document ? document : {};
  return j(e, $), e;
}
var R = {
  document: $,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return "";
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(e) {
    return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(e) {
    "undefined" != typeof setTimeout && clearTimeout(e);
  }
};
function q() {
  var e = "undefined" != typeof window ? window : {};
  return j(e, R), e;
}
function Y(e) {
  return void 0 === e && (e = ""), e.trim().split(" ").filter(function (e) {
    return !!e.trim();
  });
}
function V(e, t) {
  return void 0 === t && (t = 0), setTimeout(e, t);
}
function W() {
  return Date.now();
}
function K(e, t) {
  void 0 === t && (t = "x");
  var r = q();
  var n, i, a;
  var s = function (e) {
    var t = q();
    var r;
    return t.getComputedStyle && (r = t.getComputedStyle(e, null)), !r && e.currentStyle && (r = e.currentStyle), r || (r = e.style), r;
  }(e);
  return r.WebKitCSSMatrix ? (i = s.transform || s.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map(function (e) {
    return e.replace(",", ".");
  }).join(", ")), a = new r.WebKitCSSMatrix("none" === i ? "" : i)) : (a = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = a.toString().split(",")), "x" === t && (i = r.WebKitCSSMatrix ? a.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])), "y" === t && (i = r.WebKitCSSMatrix ? a.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])), i || 0;
}
function U(e) {
  return "object" == _typeof(e) && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function X() {
  var e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    t = ["__proto__", "constructor", "prototype"];
  for (var _n = 1; _n < arguments.length; _n += 1) {
    var _i = _n < 0 || arguments.length <= _n ? void 0 : arguments[_n];
    if (null != _i && (r = _i, !("undefined" != typeof window && void 0 !== window.HTMLElement ? r instanceof HTMLElement : r && (1 === r.nodeType || 11 === r.nodeType)))) {
      var _r = Object.keys(Object(_i)).filter(function (e) {
        return t.indexOf(e) < 0;
      });
      for (var _t2 = 0, _n2 = _r.length; _t2 < _n2; _t2 += 1) {
        var _n3 = _r[_t2],
          _a = Object.getOwnPropertyDescriptor(_i, _n3);
        void 0 !== _a && _a.enumerable && (U(e[_n3]) && U(_i[_n3]) ? _i[_n3].__swiper__ ? e[_n3] = _i[_n3] : X(e[_n3], _i[_n3]) : !U(e[_n3]) && U(_i[_n3]) ? (e[_n3] = {}, _i[_n3].__swiper__ ? e[_n3] = _i[_n3] : X(e[_n3], _i[_n3])) : e[_n3] = _i[_n3]);
      }
    }
  }
  var r;
  return e;
}
function Z(e, t, r) {
  e.style.setProperty(t, r);
}
function Q(e) {
  var t = e.swiper,
    r = e.targetPosition,
    n = e.side;
  var i = q(),
    a = -t.translate;
  var s,
    o = null;
  var l = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(t.cssModeFrameID);
  var c = r > a ? "next" : "prev",
    d = function d(e, t) {
      return "next" === c && e >= t || "prev" === c && e <= t;
    },
    p = function p() {
      s = new Date().getTime(), null === o && (o = s);
      var e = Math.max(Math.min((s - o) / l, 1), 0),
        c = .5 - Math.cos(e * Math.PI) / 2;
      var u = a + c * (r - a);
      if (d(u, r) && (u = r), t.wrapperEl.scrollTo(_defineProperty({}, n, u)), d(u, r)) return t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(function () {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo(_defineProperty({}, n, u));
      }), void i.cancelAnimationFrame(t.cssModeFrameID);
      t.cssModeFrameID = i.requestAnimationFrame(p);
    };
  p();
}
function J(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function ee(e, t) {
  void 0 === t && (t = "");
  var r = q(),
    n = _toConsumableArray(e.children);
  return r.HTMLSlotElement && e instanceof HTMLSlotElement && n.push.apply(n, _toConsumableArray(e.assignedElements())), t ? n.filter(function (e) {
    return e.matches(t);
  }) : n;
}
function te(e) {
  try {
    return void console.warn(e);
  } catch (e) {}
}
function re(e, t) {
  var _r$classList;
  void 0 === t && (t = []);
  var r = document.createElement(e);
  return (_r$classList = r.classList).add.apply(_r$classList, _toConsumableArray(Array.isArray(t) ? t : Y(t))), r;
}
function ne(e, t) {
  return q().getComputedStyle(e, null).getPropertyValue(t);
}
function ie(e) {
  var t,
    r = e;
  if (r) {
    for (t = 0; null !== (r = r.previousSibling);) 1 === r.nodeType && (t += 1);
    return t;
  }
}
function ae(e, t) {
  var r = [];
  var n = e.parentElement;
  for (; n;) t ? n.matches(t) && r.push(n) : r.push(n), n = n.parentElement;
  return r;
}
function se(e, t, r) {
  var n = q();
  return e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom"));
}
function oe(e) {
  return (Array.isArray(e) ? e : [e]).filter(function (e) {
    return !!e;
  });
}
function le(e) {
  return function (t) {
    return Math.abs(t) > 0 && e.browser && e.browser.need3dFix && Math.abs(t) % 90 == 0 ? t + .001 : t;
  };
}
var ce, de, pe;
function ue() {
  return ce || (ce = function () {
    var e = q(),
      t = H();
    return {
      smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
      touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
    };
  }()), ce;
}
function me(e) {
  return void 0 === e && (e = {}), de || (de = function (e) {
    var _ref = void 0 === e ? {} : e,
      t = _ref.userAgent;
    var r = ue(),
      n = q(),
      i = n.navigator.platform,
      a = t || n.navigator.userAgent,
      s = {
        ios: !1,
        android: !1
      },
      o = n.screen.width,
      l = n.screen.height,
      c = a.match(/(Android);?[\s\/]+([\d.]+)?/);
    var d = a.match(/(iPad).*OS\s([\d_]+)/);
    var p = a.match(/(iPod)(.*OS\s([\d_]+))?/),
      u = !d && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
      m = "Win32" === i;
    var f = "MacIntel" === i;
    return !d && f && r.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf("".concat(o, "x").concat(l)) >= 0 && (d = a.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), f = !1), c && !m && (s.os = "android", s.android = !0), (d || u || p) && (s.os = "ios", s.ios = !0), s;
  }(e)), de;
}
function fe() {
  return pe || (pe = function () {
    var e = q(),
      t = me();
    var r = !1;
    function n() {
      var t = e.navigator.userAgent.toLowerCase();
      return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
    }
    if (n()) {
      var _t3 = String(e.navigator.userAgent);
      if (_t3.includes("Version/")) {
        var _t3$split$1$split$0$s = _t3.split("Version/")[1].split(" ")[0].split(".").map(function (e) {
            return Number(e);
          }),
          _t3$split$1$split$0$s2 = _slicedToArray(_t3$split$1$split$0$s, 2),
          _e3 = _t3$split$1$split$0$s2[0],
          _n4 = _t3$split$1$split$0$s2[1];
        r = _e3 < 16 || 16 === _e3 && _n4 < 2;
      }
    }
    var i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
      a = n();
    return {
      isSafari: r || a,
      needPerspectiveFix: r,
      need3dFix: a || i && t.ios,
      isWebView: i
    };
  }()), pe;
}
var ge = {
  on: function on(e, t, r) {
    var n = this;
    if (!n.eventsListeners || n.destroyed) return n;
    if ("function" != typeof t) return n;
    var i = r ? "unshift" : "push";
    return e.split(" ").forEach(function (e) {
      n.eventsListeners[e] || (n.eventsListeners[e] = []), n.eventsListeners[e][i](t);
    }), n;
  },
  once: function once(e, t, r) {
    var n = this;
    if (!n.eventsListeners || n.destroyed) return n;
    if ("function" != typeof t) return n;
    function i() {
      n.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
      for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++) a[s] = arguments[s];
      t.apply(n, a);
    }
    return i.__emitterProxy = t, n.on(e, i, r);
  },
  onAny: function onAny(e, t) {
    var r = this;
    if (!r.eventsListeners || r.destroyed) return r;
    if ("function" != typeof e) return r;
    var n = t ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(e) < 0 && r.eventsAnyListeners[n](e), r;
  },
  offAny: function offAny(e) {
    var t = this;
    if (!t.eventsListeners || t.destroyed) return t;
    if (!t.eventsAnyListeners) return t;
    var r = t.eventsAnyListeners.indexOf(e);
    return r >= 0 && t.eventsAnyListeners.splice(r, 1), t;
  },
  off: function off(e, t) {
    var r = this;
    return !r.eventsListeners || r.destroyed ? r : r.eventsListeners ? (e.split(" ").forEach(function (e) {
      void 0 === t ? r.eventsListeners[e] = [] : r.eventsListeners[e] && r.eventsListeners[e].forEach(function (n, i) {
        (n === t || n.__emitterProxy && n.__emitterProxy === t) && r.eventsListeners[e].splice(i, 1);
      });
    }), r) : r;
  },
  emit: function emit() {
    var e = this;
    if (!e.eventsListeners || e.destroyed) return e;
    if (!e.eventsListeners) return e;
    var t, r, n;
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++) a[s] = arguments[s];
    "string" == typeof a[0] || Array.isArray(a[0]) ? (t = a[0], r = a.slice(1, a.length), n = e) : (t = a[0].events, r = a[0].data, n = a[0].context || e), r.unshift(n);
    return (Array.isArray(t) ? t : t.split(" ")).forEach(function (t) {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach(function (e) {
        e.apply(n, [t].concat(_toConsumableArray(r)));
      }), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach(function (e) {
        e.apply(n, r);
      });
    }), e;
  }
};
var he = function he(e, t, r) {
  t && !e.classList.contains(r) ? e.classList.add(r) : !t && e.classList.contains(r) && e.classList.remove(r);
};
var be = function be(e, t, r) {
  t && !e.classList.contains(r) ? e.classList.add(r) : !t && e.classList.contains(r) && e.classList.remove(r);
};
var ve = function ve(e, t) {
    if (!e || e.destroyed || !e.params) return;
    var r = t.closest(e.isElement ? "swiper-slide" : ".".concat(e.params.slideClass));
    if (r) {
      var _t4 = r.querySelector(".".concat(e.params.lazyPreloaderClass));
      !_t4 && e.isElement && (r.shadowRoot ? _t4 = r.shadowRoot.querySelector(".".concat(e.params.lazyPreloaderClass)) : requestAnimationFrame(function () {
        r.shadowRoot && (_t4 = r.shadowRoot.querySelector(".".concat(e.params.lazyPreloaderClass)), _t4 && _t4.remove());
      })), _t4 && _t4.remove();
    }
  },
  we = function we(e, t) {
    if (!e.slides[t]) return;
    var r = e.slides[t].querySelector('[loading="lazy"]');
    r && r.removeAttribute("loading");
  },
  ye = function ye(e) {
    if (!e || e.destroyed || !e.params) return;
    var t = e.params.lazyPreloadPrevNext;
    var r = e.slides.length;
    if (!r || !t || t < 0) return;
    t = Math.min(t, r);
    var n = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
      i = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
      var _r2 = i,
        _a2 = [_r2 - t];
      return _a2.push.apply(_a2, _toConsumableArray(Array.from({
        length: t
      }).map(function (e, t) {
        return _r2 + n + t;
      }))), void e.slides.forEach(function (t, r) {
        _a2.includes(t.column) && we(e, r);
      });
    }
    var a = i + n - 1;
    if (e.params.rewind || e.params.loop) for (var _n5 = i - t; _n5 <= a + t; _n5 += 1) {
      var _t5 = (_n5 % r + r) % r;
      (_t5 < i || _t5 > a) && we(e, _t5);
    } else for (var _n6 = Math.max(i - t, 0); _n6 <= Math.min(a + t, r - 1); _n6 += 1) _n6 !== i && (_n6 > a || _n6 < i) && we(e, _n6);
  };
var Se = {
  updateSize: function updateSize() {
    var e = this;
    var t, r;
    var n = e.el;
    t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : n.clientWidth, r = void 0 !== e.params.height && null !== e.params.height ? e.params.height : n.clientHeight, 0 === t && e.isHorizontal() || 0 === r && e.isVertical() || (t = t - parseInt(ne(n, "padding-left") || 0, 10) - parseInt(ne(n, "padding-right") || 0, 10), r = r - parseInt(ne(n, "padding-top") || 0, 10) - parseInt(ne(n, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(r) && (r = 0), Object.assign(e, {
      width: t,
      height: r,
      size: e.isHorizontal() ? t : r
    }));
  },
  updateSlides: function updateSlides() {
    var e = this;
    function t(t, r) {
      return parseFloat(t.getPropertyValue(e.getDirectionLabel(r)) || 0);
    }
    var r = e.params,
      n = e.wrapperEl,
      i = e.slidesEl,
      a = e.size,
      s = e.rtlTranslate,
      o = e.wrongRTL,
      l = e.virtual && r.virtual.enabled,
      c = l ? e.virtual.slides.length : e.slides.length,
      d = ee(i, ".".concat(e.params.slideClass, ", swiper-slide")),
      p = l ? e.virtual.slides.length : d.length;
    var u = [];
    var m = [],
      f = [];
    var g = r.slidesOffsetBefore;
    "function" == typeof g && (g = r.slidesOffsetBefore.call(e));
    var h = r.slidesOffsetAfter;
    "function" == typeof h && (h = r.slidesOffsetAfter.call(e));
    var b = e.snapGrid.length,
      v = e.slidesGrid.length;
    var w = r.spaceBetween,
      y = -g,
      S = 0,
      x = 0;
    if (void 0 === a) return;
    "string" == typeof w && w.indexOf("%") >= 0 ? w = parseFloat(w.replace("%", "")) / 100 * a : "string" == typeof w && (w = parseFloat(w)), e.virtualSize = -w, d.forEach(function (e) {
      s ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
    }), r.centeredSlides && r.cssMode && (Z(n, "--swiper-centered-offset-before", ""), Z(n, "--swiper-centered-offset-after", ""));
    var E = r.grid && r.grid.rows > 1 && e.grid;
    var T;
    E ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
    var k = "auto" === r.slidesPerView && r.breakpoints && Object.keys(r.breakpoints).filter(function (e) {
      return void 0 !== r.breakpoints[e].slidesPerView;
    }).length > 0;
    for (var _n7 = 0; _n7 < p; _n7 += 1) {
      var _i2 = void 0;
      if (T = 0, d[_n7] && (_i2 = d[_n7]), E && e.grid.updateSlide(_n7, _i2, d), !d[_n7] || "none" !== ne(_i2, "display")) {
        if ("auto" === r.slidesPerView) {
          k && (d[_n7].style[e.getDirectionLabel("width")] = "");
          var _a3 = getComputedStyle(_i2),
            _s = _i2.style.transform,
            _o = _i2.style.webkitTransform;
          if (_s && (_i2.style.transform = "none"), _o && (_i2.style.webkitTransform = "none"), r.roundLengths) T = e.isHorizontal() ? se(_i2, "width") : se(_i2, "height");else {
            var _e4 = t(_a3, "width"),
              _r3 = t(_a3, "padding-left"),
              _n8 = t(_a3, "padding-right"),
              _s2 = t(_a3, "margin-left"),
              _o2 = t(_a3, "margin-right"),
              _l = _a3.getPropertyValue("box-sizing");
            if (_l && "border-box" === _l) T = _e4 + _s2 + _o2;else {
              var _i3 = _i2,
                _t6 = _i3.clientWidth,
                _a4 = _i3.offsetWidth;
              T = _e4 + _r3 + _n8 + _s2 + _o2 + (_a4 - _t6);
            }
          }
          _s && (_i2.style.transform = _s), _o && (_i2.style.webkitTransform = _o), r.roundLengths && (T = Math.floor(T));
        } else T = (a - (r.slidesPerView - 1) * w) / r.slidesPerView, r.roundLengths && (T = Math.floor(T)), d[_n7] && (d[_n7].style[e.getDirectionLabel("width")] = "".concat(T, "px"));
        d[_n7] && (d[_n7].swiperSlideSize = T), f.push(T), r.centeredSlides ? (y = y + T / 2 + S / 2 + w, 0 === S && 0 !== _n7 && (y = y - a / 2 - w), 0 === _n7 && (y = y - a / 2 - w), Math.abs(y) < .001 && (y = 0), r.roundLengths && (y = Math.floor(y)), x % r.slidesPerGroup == 0 && u.push(y), m.push(y)) : (r.roundLengths && (y = Math.floor(y)), (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && u.push(y), m.push(y), y = y + T + w), e.virtualSize += T + w, S = T, x += 1;
      }
    }
    if (e.virtualSize = Math.max(e.virtualSize, a) + h, s && o && ("slide" === r.effect || "coverflow" === r.effect) && (n.style.width = "".concat(e.virtualSize + w, "px")), r.setWrapperSize && (n.style[e.getDirectionLabel("width")] = "".concat(e.virtualSize + w, "px")), E && e.grid.updateWrapperSize(T, u), !r.centeredSlides) {
      var _t7 = [];
      for (var _n9 = 0; _n9 < u.length; _n9 += 1) {
        var _i4 = u[_n9];
        r.roundLengths && (_i4 = Math.floor(_i4)), u[_n9] <= e.virtualSize - a && _t7.push(_i4);
      }
      u = _t7, Math.floor(e.virtualSize - a) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - a);
    }
    if (l && r.loop) {
      var _t8 = f[0] + w;
      if (r.slidesPerGroup > 1) {
        var _n10 = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / r.slidesPerGroup),
          _i5 = _t8 * r.slidesPerGroup;
        for (var _e5 = 0; _e5 < _n10; _e5 += 1) u.push(u[u.length - 1] + _i5);
      }
      for (var _n11 = 0; _n11 < e.virtual.slidesBefore + e.virtual.slidesAfter; _n11 += 1) 1 === r.slidesPerGroup && u.push(u[u.length - 1] + _t8), m.push(m[m.length - 1] + _t8), e.virtualSize += _t8;
    }
    if (0 === u.length && (u = [0]), 0 !== w) {
      var _t9 = e.isHorizontal() && s ? "marginLeft" : e.getDirectionLabel("marginRight");
      d.filter(function (e, t) {
        return !(r.cssMode && !r.loop) || t !== d.length - 1;
      }).forEach(function (e) {
        e.style[_t9] = "".concat(w, "px");
      });
    }
    if (r.centeredSlides && r.centeredSlidesBounds) {
      var _e6 = 0;
      f.forEach(function (t) {
        _e6 += t + (w || 0);
      }), _e6 -= w;
      var _t10 = _e6 > a ? _e6 - a : 0;
      u = u.map(function (e) {
        return e <= 0 ? -g : e > _t10 ? _t10 + h : e;
      });
    }
    if (r.centerInsufficientSlides) {
      var _e7 = 0;
      f.forEach(function (t) {
        _e7 += t + (w || 0);
      }), _e7 -= w;
      var _t11 = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
      if (_e7 + _t11 < a) {
        var _r4 = (a - _e7 - _t11) / 2;
        u.forEach(function (e, t) {
          u[t] = e - _r4;
        }), m.forEach(function (e, t) {
          m[t] = e + _r4;
        });
      }
    }
    if (Object.assign(e, {
      slides: d,
      snapGrid: u,
      slidesGrid: m,
      slidesSizesGrid: f
    }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
      Z(n, "--swiper-centered-offset-before", -u[0] + "px"), Z(n, "--swiper-centered-offset-after", e.size / 2 - f[f.length - 1] / 2 + "px");
      var _t12 = -e.snapGrid[0],
        _r5 = -e.slidesGrid[0];
      e.snapGrid = e.snapGrid.map(function (e) {
        return e + _t12;
      }), e.slidesGrid = e.slidesGrid.map(function (e) {
        return e + _r5;
      });
    }
    if (p !== c && e.emit("slidesLengthChange"), u.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), m.length !== v && e.emit("slidesGridLengthChange"), r.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !(l || r.cssMode || "slide" !== r.effect && "fade" !== r.effect)) {
      var _t13 = "".concat(r.containerModifierClass, "backface-hidden"),
        _n12 = e.el.classList.contains(_t13);
      p <= r.maxBackfaceHiddenSlides ? _n12 || e.el.classList.add(_t13) : _n12 && e.el.classList.remove(_t13);
    }
  },
  updateAutoHeight: function updateAutoHeight(e) {
    var t = this,
      r = [],
      n = t.virtual && t.params.virtual.enabled;
    var i,
      a = 0;
    "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
    var s = function s(e) {
      return n ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
    };
    if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1) {
      if (t.params.centeredSlides) (t.visibleSlides || []).forEach(function (e) {
        r.push(e);
      });else for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
        var _e8 = t.activeIndex + i;
        if (_e8 > t.slides.length && !n) break;
        r.push(s(_e8));
      }
    } else r.push(s(t.activeIndex));
    for (i = 0; i < r.length; i += 1) if (void 0 !== r[i]) {
      var _e9 = r[i].offsetHeight;
      a = _e9 > a ? _e9 : a;
    }
    (a || 0 === a) && (t.wrapperEl.style.height = "".concat(a, "px"));
  },
  updateSlidesOffset: function updateSlidesOffset() {
    var e = this,
      t = e.slides,
      r = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
    for (var _n13 = 0; _n13 < t.length; _n13 += 1) t[_n13].swiperSlideOffset = (e.isHorizontal() ? t[_n13].offsetLeft : t[_n13].offsetTop) - r - e.cssOverflowAdjustment();
  },
  updateSlidesProgress: function updateSlidesProgress(e) {
    void 0 === e && (e = this && this.translate || 0);
    var t = this,
      r = t.params,
      n = t.slides,
      i = t.rtlTranslate,
      a = t.snapGrid;
    if (0 === n.length) return;
    void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset();
    var s = -e;
    i && (s = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    var o = r.spaceBetween;
    "string" == typeof o && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : "string" == typeof o && (o = parseFloat(o));
    for (var _e10 = 0; _e10 < n.length; _e10 += 1) {
      var _l2 = n[_e10];
      var _c = _l2.swiperSlideOffset;
      r.cssMode && r.centeredSlides && (_c -= n[0].swiperSlideOffset);
      var _d = (s + (r.centeredSlides ? t.minTranslate() : 0) - _c) / (_l2.swiperSlideSize + o),
        _p = (s - a[0] + (r.centeredSlides ? t.minTranslate() : 0) - _c) / (_l2.swiperSlideSize + o),
        _u = -(s - _c),
        _m = _u + t.slidesSizesGrid[_e10],
        _f = _u >= 0 && _u <= t.size - t.slidesSizesGrid[_e10],
        _g = _u >= 0 && _u < t.size - 1 || _m > 1 && _m <= t.size || _u <= 0 && _m >= t.size;
      _g && (t.visibleSlides.push(_l2), t.visibleSlidesIndexes.push(_e10)), he(_l2, _g, r.slideVisibleClass), he(_l2, _f, r.slideFullyVisibleClass), _l2.progress = i ? -_d : _d, _l2.originalProgress = i ? -_p : _p;
    }
  },
  updateProgress: function updateProgress(e) {
    var t = this;
    if (void 0 === e) {
      var _r6 = t.rtlTranslate ? -1 : 1;
      e = t && t.translate && t.translate * _r6 || 0;
    }
    var r = t.params,
      n = t.maxTranslate() - t.minTranslate();
    var i = t.progress,
      a = t.isBeginning,
      s = t.isEnd,
      o = t.progressLoop;
    var l = a,
      c = s;
    if (0 === n) i = 0, a = !0, s = !0;else {
      i = (e - t.minTranslate()) / n;
      var _r7 = Math.abs(e - t.minTranslate()) < 1,
        _o3 = Math.abs(e - t.maxTranslate()) < 1;
      a = _r7 || i <= 0, s = _o3 || i >= 1, _r7 && (i = 0), _o3 && (i = 1);
    }
    if (r.loop) {
      var _r8 = t.getSlideIndexByData(0),
        _n14 = t.getSlideIndexByData(t.slides.length - 1),
        _i6 = t.slidesGrid[_r8],
        _a5 = t.slidesGrid[_n14],
        _s3 = t.slidesGrid[t.slidesGrid.length - 1],
        _l3 = Math.abs(e);
      o = _l3 >= _i6 ? (_l3 - _i6) / _s3 : (_l3 + _s3 - _a5) / _s3, o > 1 && (o -= 1);
    }
    Object.assign(t, {
      progress: i,
      progressLoop: o,
      isBeginning: a,
      isEnd: s
    }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e), a && !l && t.emit("reachBeginning toEdge"), s && !c && t.emit("reachEnd toEdge"), (l && !a || c && !s) && t.emit("fromEdge"), t.emit("progress", i);
  },
  updateSlidesClasses: function updateSlidesClasses() {
    var e = this,
      t = e.slides,
      r = e.params,
      n = e.slidesEl,
      i = e.activeIndex,
      a = e.virtual && r.virtual.enabled,
      s = e.grid && r.grid && r.grid.rows > 1,
      o = function o(e) {
        return ee(n, ".".concat(r.slideClass).concat(e, ", swiper-slide").concat(e))[0];
      };
    var l, c, d;
    if (a) {
      if (r.loop) {
        var _t14 = i - e.virtual.slidesBefore;
        _t14 < 0 && (_t14 = e.virtual.slides.length + _t14), _t14 >= e.virtual.slides.length && (_t14 -= e.virtual.slides.length), l = o("[data-swiper-slide-index=\"".concat(_t14, "\"]"));
      } else l = o("[data-swiper-slide-index=\"".concat(i, "\"]"));
    } else s ? (l = t.find(function (e) {
      return e.column === i;
    }), d = t.find(function (e) {
      return e.column === i + 1;
    }), c = t.find(function (e) {
      return e.column === i - 1;
    })) : l = t[i];
    l && (s || (d = function (e, t) {
      var r = [];
      for (; e.nextElementSibling;) {
        var _n15 = e.nextElementSibling;
        t ? _n15.matches(t) && r.push(_n15) : r.push(_n15), e = _n15;
      }
      return r;
    }(l, ".".concat(r.slideClass, ", swiper-slide"))[0], r.loop && !d && (d = t[0]), c = function (e, t) {
      var r = [];
      for (; e.previousElementSibling;) {
        var _n16 = e.previousElementSibling;
        t ? _n16.matches(t) && r.push(_n16) : r.push(_n16), e = _n16;
      }
      return r;
    }(l, ".".concat(r.slideClass, ", swiper-slide"))[0], r.loop && 0 === !c && (c = t[t.length - 1]))), t.forEach(function (e) {
      be(e, e === l, r.slideActiveClass), be(e, e === d, r.slideNextClass), be(e, e === c, r.slidePrevClass);
    }), e.emitSlidesClasses();
  },
  updateActiveIndex: function updateActiveIndex(e) {
    var t = this,
      r = t.rtlTranslate ? t.translate : -t.translate,
      n = t.snapGrid,
      i = t.params,
      a = t.activeIndex,
      s = t.realIndex,
      o = t.snapIndex;
    var l,
      c = e;
    var d = function d(e) {
      var r = e - t.virtual.slidesBefore;
      return r < 0 && (r = t.virtual.slides.length + r), r >= t.virtual.slides.length && (r -= t.virtual.slides.length), r;
    };
    if (void 0 === c && (c = function (e) {
      var t = e.slidesGrid,
        r = e.params,
        n = e.rtlTranslate ? e.translate : -e.translate;
      var i;
      for (var _e11 = 0; _e11 < t.length; _e11 += 1) void 0 !== t[_e11 + 1] ? n >= t[_e11] && n < t[_e11 + 1] - (t[_e11 + 1] - t[_e11]) / 2 ? i = _e11 : n >= t[_e11] && n < t[_e11 + 1] && (i = _e11 + 1) : n >= t[_e11] && (i = _e11);
      return r.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i;
    }(t)), n.indexOf(r) >= 0) l = n.indexOf(r);else {
      var _e12 = Math.min(i.slidesPerGroupSkip, c);
      l = _e12 + Math.floor((c - _e12) / i.slidesPerGroup);
    }
    if (l >= n.length && (l = n.length - 1), c === a && !t.params.loop) return void (l !== o && (t.snapIndex = l, t.emit("snapIndexChange")));
    if (c === a && t.params.loop && t.virtual && t.params.virtual.enabled) return void (t.realIndex = d(c));
    var p = t.grid && i.grid && i.grid.rows > 1;
    var u;
    if (t.virtual && i.virtual.enabled && i.loop) u = d(c);else if (p) {
      var _e13 = t.slides.find(function (e) {
        return e.column === c;
      });
      var _r9 = parseInt(_e13.getAttribute("data-swiper-slide-index"), 10);
      Number.isNaN(_r9) && (_r9 = Math.max(t.slides.indexOf(_e13), 0)), u = Math.floor(_r9 / i.grid.rows);
    } else if (t.slides[c]) {
      var _e14 = t.slides[c].getAttribute("data-swiper-slide-index");
      u = _e14 ? parseInt(_e14, 10) : c;
    } else u = c;
    Object.assign(t, {
      previousSnapIndex: o,
      snapIndex: l,
      previousRealIndex: s,
      realIndex: u,
      previousIndex: a,
      activeIndex: c
    }), t.initialized && ye(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (s !== u && t.emit("realIndexChange"), t.emit("slideChange"));
  },
  updateClickedSlide: function updateClickedSlide(e, t) {
    var r = this,
      n = r.params;
    var i = e.closest(".".concat(n.slideClass, ", swiper-slide"));
    !i && r.isElement && t && t.length > 1 && t.includes(e) && _toConsumableArray(t.slice(t.indexOf(e) + 1, t.length)).forEach(function (e) {
      !i && e.matches && e.matches(".".concat(n.slideClass, ", swiper-slide")) && (i = e);
    });
    var a,
      s = !1;
    if (i) for (var _e15 = 0; _e15 < r.slides.length; _e15 += 1) if (r.slides[_e15] === i) {
      s = !0, a = _e15;
      break;
    }
    if (!i || !s) return r.clickedSlide = void 0, void (r.clickedIndex = void 0);
    r.clickedSlide = i, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = a, n.slideToClickedSlide && void 0 !== r.clickedIndex && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
  }
};
var xe = {
  getTranslate: function getTranslate(e) {
    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
    var t = this.params,
      r = this.rtlTranslate,
      n = this.translate,
      i = this.wrapperEl;
    if (t.virtualTranslate) return r ? -n : n;
    if (t.cssMode) return n;
    var a = K(i, e);
    return a += this.cssOverflowAdjustment(), r && (a = -a), a || 0;
  },
  setTranslate: function setTranslate(e, t) {
    var r = this,
      n = r.rtlTranslate,
      i = r.params,
      a = r.wrapperEl,
      s = r.progress;
    var o,
      l = 0,
      c = 0;
    r.isHorizontal() ? l = n ? -e : e : c = e, i.roundLengths && (l = Math.floor(l), c = Math.floor(c)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? l : c, i.cssMode ? a[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -l : -c : i.virtualTranslate || (r.isHorizontal() ? l -= r.cssOverflowAdjustment() : c -= r.cssOverflowAdjustment(), a.style.transform = "translate3d(".concat(l, "px, ").concat(c, "px, 0px)"));
    var d = r.maxTranslate() - r.minTranslate();
    o = 0 === d ? 0 : (e - r.minTranslate()) / d, o !== s && r.updateProgress(e), r.emit("setTranslate", r.translate, t);
  },
  minTranslate: function minTranslate() {
    return -this.snapGrid[0];
  },
  maxTranslate: function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  },
  translateTo: function translateTo(e, t, r, n, i) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === r && (r = !0), void 0 === n && (n = !0);
    var a = this,
      s = a.params,
      o = a.wrapperEl;
    if (a.animating && s.preventInteractionOnTransition) return !1;
    var l = a.minTranslate(),
      c = a.maxTranslate();
    var d;
    if (d = n && e > l ? l : n && e < c ? c : e, a.updateProgress(d), s.cssMode) {
      var _e16 = a.isHorizontal();
      if (0 === t) o[_e16 ? "scrollLeft" : "scrollTop"] = -d;else {
        if (!a.support.smoothScroll) return Q({
          swiper: a,
          targetPosition: -d,
          side: _e16 ? "left" : "top"
        }), !0;
        o.scrollTo(_defineProperty(_defineProperty({}, _e16 ? "left" : "top", -d), "behavior", "smooth"));
      }
      return !0;
    }
    return 0 === t ? (a.setTransition(0), a.setTranslate(d), r && (a.emit("beforeTransitionStart", t, i), a.emit("transitionEnd"))) : (a.setTransition(t), a.setTranslate(d), r && (a.emit("beforeTransitionStart", t, i), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function (e) {
      a && !a.destroyed && e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, r && a.emit("transitionEnd"));
    }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
  }
};
function Ee(e) {
  var t = e.swiper,
    r = e.runCallbacks,
    n = e.direction,
    i = e.step;
  var a = t.activeIndex,
    s = t.previousIndex;
  var o = n;
  if (o || (o = a > s ? "next" : a < s ? "prev" : "reset"), t.emit("transition".concat(i)), r && a !== s) {
    if ("reset" === o) return void t.emit("slideResetTransition".concat(i));
    t.emit("slideChangeTransition".concat(i)), "next" === o ? t.emit("slideNextTransition".concat(i)) : t.emit("slidePrevTransition".concat(i));
  }
}
var Te = {
  slideTo: function slideTo(e, t, r, n, i) {
    void 0 === e && (e = 0), void 0 === r && (r = !0), "string" == typeof e && (e = parseInt(e, 10));
    var a = this;
    var s = e;
    s < 0 && (s = 0);
    var o = a.params,
      l = a.snapGrid,
      c = a.slidesGrid,
      d = a.previousIndex,
      p = a.activeIndex,
      u = a.rtlTranslate,
      m = a.wrapperEl,
      f = a.enabled;
    if (!f && !n && !i || a.destroyed || a.animating && o.preventInteractionOnTransition) return !1;
    void 0 === t && (t = a.params.speed);
    var g = Math.min(a.params.slidesPerGroupSkip, s);
    var h = g + Math.floor((s - g) / a.params.slidesPerGroup);
    h >= l.length && (h = l.length - 1);
    var b = -l[h];
    if (o.normalizeSlideIndex) for (var _e17 = 0; _e17 < c.length; _e17 += 1) {
      var _t15 = -Math.floor(100 * b),
        _r10 = Math.floor(100 * c[_e17]),
        _n17 = Math.floor(100 * c[_e17 + 1]);
      void 0 !== c[_e17 + 1] ? _t15 >= _r10 && _t15 < _n17 - (_n17 - _r10) / 2 ? s = _e17 : _t15 >= _r10 && _t15 < _n17 && (s = _e17 + 1) : _t15 >= _r10 && (s = _e17);
    }
    if (a.initialized && s !== p) {
      if (!a.allowSlideNext && (u ? b > a.translate && b > a.minTranslate() : b < a.translate && b < a.minTranslate())) return !1;
      if (!a.allowSlidePrev && b > a.translate && b > a.maxTranslate() && (p || 0) !== s) return !1;
    }
    var v;
    s !== (d || 0) && r && a.emit("beforeSlideChangeStart"), a.updateProgress(b), v = s > p ? "next" : s < p ? "prev" : "reset";
    var w = a.virtual && a.params.virtual.enabled;
    if (!(w && i) && (u && -b === a.translate || !u && b === a.translate)) return a.updateActiveIndex(s), o.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), "slide" !== o.effect && a.setTranslate(b), "reset" !== v && (a.transitionStart(r, v), a.transitionEnd(r, v)), !1;
    if (o.cssMode) {
      var _e18 = a.isHorizontal(),
        _r11 = u ? b : -b;
      if (0 === t) w && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), w && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(function () {
        m[_e18 ? "scrollLeft" : "scrollTop"] = _r11;
      })) : m[_e18 ? "scrollLeft" : "scrollTop"] = _r11, w && requestAnimationFrame(function () {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });else {
        if (!a.support.smoothScroll) return Q({
          swiper: a,
          targetPosition: _r11,
          side: _e18 ? "left" : "top"
        }), !0;
        m.scrollTo(_defineProperty(_defineProperty({}, _e18 ? "left" : "top", _r11), "behavior", "smooth"));
      }
      return !0;
    }
    return a.setTransition(t), a.setTranslate(b), a.updateActiveIndex(s), a.updateSlidesClasses(), a.emit("beforeTransitionStart", t, n), a.transitionStart(r, v), 0 === t ? a.transitionEnd(r, v) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function (e) {
      a && !a.destroyed && e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(r, v));
    }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
  },
  slideToLoop: function slideToLoop(e, t, r, n) {
    if (void 0 === e && (e = 0), void 0 === r && (r = !0), "string" == typeof e) {
      e = parseInt(e, 10);
    }
    var i = this;
    if (i.destroyed) return;
    void 0 === t && (t = i.params.speed);
    var a = i.grid && i.params.grid && i.params.grid.rows > 1;
    var s = e;
    if (i.params.loop) if (i.virtual && i.params.virtual.enabled) s += i.virtual.slidesBefore;else {
      var _e19;
      if (a) {
        var _t16 = s * i.params.grid.rows;
        _e19 = i.slides.find(function (e) {
          return 1 * e.getAttribute("data-swiper-slide-index") === _t16;
        }).column;
      } else _e19 = i.getSlideIndexByData(s);
      var _t17 = a ? Math.ceil(i.slides.length / i.params.grid.rows) : i.slides.length,
        _r12 = i.params.centeredSlides;
      var _o4 = i.params.slidesPerView;
      "auto" === _o4 ? _o4 = i.slidesPerViewDynamic() : (_o4 = Math.ceil(parseFloat(i.params.slidesPerView, 10)), _r12 && _o4 % 2 == 0 && (_o4 += 1));
      var _l4 = _t17 - _e19 < _o4;
      if (_r12 && (_l4 = _l4 || _e19 < Math.ceil(_o4 / 2)), n && _r12 && "auto" !== i.params.slidesPerView && !a && (_l4 = !1), _l4) {
        var _n18 = _r12 ? _e19 < i.activeIndex ? "prev" : "next" : _e19 - i.activeIndex - 1 < i.params.slidesPerView ? "next" : "prev";
        i.loopFix({
          direction: _n18,
          slideTo: !0,
          activeSlideIndex: "next" === _n18 ? _e19 + 1 : _e19 - _t17 + 1,
          slideRealIndex: "next" === _n18 ? i.realIndex : void 0
        });
      }
      if (a) {
        var _e20 = s * i.params.grid.rows;
        s = i.slides.find(function (t) {
          return 1 * t.getAttribute("data-swiper-slide-index") === _e20;
        }).column;
      } else s = i.getSlideIndexByData(s);
    }
    return requestAnimationFrame(function () {
      i.slideTo(s, t, r, n);
    }), i;
  },
  slideNext: function slideNext(e, t, r) {
    void 0 === t && (t = !0);
    var n = this,
      i = n.enabled,
      a = n.params,
      s = n.animating;
    if (!i || n.destroyed) return n;
    void 0 === e && (e = n.params.speed);
    var o = a.slidesPerGroup;
    "auto" === a.slidesPerView && 1 === a.slidesPerGroup && a.slidesPerGroupAuto && (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
    var l = n.activeIndex < a.slidesPerGroupSkip ? 1 : o,
      c = n.virtual && a.virtual.enabled;
    if (a.loop) {
      if (s && !c && a.loopPreventsSliding) return !1;
      if (n.loopFix({
        direction: "next"
      }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && a.cssMode) return requestAnimationFrame(function () {
        n.slideTo(n.activeIndex + l, e, t, r);
      }), !0;
    }
    return a.rewind && n.isEnd ? n.slideTo(0, e, t, r) : n.slideTo(n.activeIndex + l, e, t, r);
  },
  slidePrev: function slidePrev(e, t, r) {
    void 0 === t && (t = !0);
    var n = this,
      i = n.params,
      a = n.snapGrid,
      s = n.slidesGrid,
      o = n.rtlTranslate,
      l = n.enabled,
      c = n.animating;
    if (!l || n.destroyed) return n;
    void 0 === e && (e = n.params.speed);
    var d = n.virtual && i.virtual.enabled;
    if (i.loop) {
      if (c && !d && i.loopPreventsSliding) return !1;
      n.loopFix({
        direction: "prev"
      }), n._clientLeft = n.wrapperEl.clientLeft;
    }
    function p(e) {
      return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
    }
    var u = p(o ? n.translate : -n.translate),
      m = a.map(function (e) {
        return p(e);
      });
    var f = a[m.indexOf(u) - 1];
    if (void 0 === f && i.cssMode) {
      var _e21;
      a.forEach(function (t, r) {
        u >= t && (_e21 = r);
      }), void 0 !== _e21 && (f = a[_e21 > 0 ? _e21 - 1 : _e21]);
    }
    var g = 0;
    if (void 0 !== f && (g = s.indexOf(f), g < 0 && (g = n.activeIndex - 1), "auto" === i.slidesPerView && 1 === i.slidesPerGroup && i.slidesPerGroupAuto && (g = g - n.slidesPerViewDynamic("previous", !0) + 1, g = Math.max(g, 0))), i.rewind && n.isBeginning) {
      var _i7 = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
      return n.slideTo(_i7, e, t, r);
    }
    return i.loop && 0 === n.activeIndex && i.cssMode ? (requestAnimationFrame(function () {
      n.slideTo(g, e, t, r);
    }), !0) : n.slideTo(g, e, t, r);
  },
  slideReset: function slideReset(e, t, r) {
    void 0 === t && (t = !0);
    var n = this;
    if (!n.destroyed) return void 0 === e && (e = n.params.speed), n.slideTo(n.activeIndex, e, t, r);
  },
  slideToClosest: function slideToClosest(e, t, r, n) {
    void 0 === t && (t = !0), void 0 === n && (n = .5);
    var i = this;
    if (i.destroyed) return;
    void 0 === e && (e = i.params.speed);
    var a = i.activeIndex;
    var s = Math.min(i.params.slidesPerGroupSkip, a),
      o = s + Math.floor((a - s) / i.params.slidesPerGroup),
      l = i.rtlTranslate ? i.translate : -i.translate;
    if (l >= i.snapGrid[o]) {
      var _e22 = i.snapGrid[o];
      l - _e22 > (i.snapGrid[o + 1] - _e22) * n && (a += i.params.slidesPerGroup);
    } else {
      var _e23 = i.snapGrid[o - 1];
      l - _e23 <= (i.snapGrid[o] - _e23) * n && (a -= i.params.slidesPerGroup);
    }
    return a = Math.max(a, 0), a = Math.min(a, i.slidesGrid.length - 1), i.slideTo(a, e, t, r);
  },
  slideToClickedSlide: function slideToClickedSlide() {
    var e = this;
    if (e.destroyed) return;
    var t = e.params,
      r = e.slidesEl,
      n = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
    var i,
      a = e.clickedIndex;
    var s = e.isElement ? "swiper-slide" : ".".concat(t.slideClass);
    if (t.loop) {
      if (e.animating) return;
      i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? a < e.loopedSlides - n / 2 || a > e.slides.length - e.loopedSlides + n / 2 ? (e.loopFix(), a = e.getSlideIndex(ee(r, "".concat(s, "[data-swiper-slide-index=\"").concat(i, "\"]"))[0]), V(function () {
        e.slideTo(a);
      })) : e.slideTo(a) : a > e.slides.length - n ? (e.loopFix(), a = e.getSlideIndex(ee(r, "".concat(s, "[data-swiper-slide-index=\"").concat(i, "\"]"))[0]), V(function () {
        e.slideTo(a);
      })) : e.slideTo(a);
    } else e.slideTo(a);
  }
};
var ke = {
  loopCreate: function loopCreate(e) {
    var t = this,
      r = t.params,
      n = t.slidesEl;
    if (!r.loop || t.virtual && t.params.virtual.enabled) return;
    var i = function i() {
        ee(n, ".".concat(r.slideClass, ", swiper-slide")).forEach(function (e, t) {
          e.setAttribute("data-swiper-slide-index", t);
        });
      },
      a = t.grid && r.grid && r.grid.rows > 1,
      s = r.slidesPerGroup * (a ? r.grid.rows : 1),
      o = t.slides.length % s != 0,
      l = a && t.slides.length % r.grid.rows != 0,
      c = function c(e) {
        for (var _n19 = 0; _n19 < e; _n19 += 1) {
          var _e24 = t.isElement ? re("swiper-slide", [r.slideBlankClass]) : re("div", [r.slideClass, r.slideBlankClass]);
          t.slidesEl.append(_e24);
        }
      };
    if (o) {
      if (r.loopAddBlankSlides) {
        c(s - t.slides.length % s), t.recalcSlides(), t.updateSlides();
      } else te("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      i();
    } else if (l) {
      if (r.loopAddBlankSlides) {
        c(r.grid.rows - t.slides.length % r.grid.rows), t.recalcSlides(), t.updateSlides();
      } else te("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      i();
    } else i();
    t.loopFix({
      slideRealIndex: e,
      direction: r.centeredSlides ? void 0 : "next"
    });
  },
  loopFix: function loopFix(e) {
    var _ref2 = void 0 === e ? {} : e,
      t = _ref2.slideRealIndex,
      _ref2$slideTo = _ref2.slideTo,
      r = _ref2$slideTo === void 0 ? !0 : _ref2$slideTo,
      n = _ref2.direction,
      i = _ref2.setTranslate,
      a = _ref2.activeSlideIndex,
      s = _ref2.byController,
      o = _ref2.byMousewheel;
    var l = this;
    if (!l.params.loop) return;
    l.emit("beforeLoopFix");
    var c = l.slides,
      d = l.allowSlidePrev,
      p = l.allowSlideNext,
      u = l.slidesEl,
      m = l.params,
      f = m.centeredSlides;
    if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && m.virtual.enabled) return r && (m.centeredSlides || 0 !== l.snapIndex ? m.centeredSlides && l.snapIndex < m.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0) : l.slideTo(l.virtual.slides.length, 0, !1, !0)), l.allowSlidePrev = d, l.allowSlideNext = p, void l.emit("loopFix");
    var g = m.slidesPerView;
    "auto" === g ? g = l.slidesPerViewDynamic() : (g = Math.ceil(parseFloat(m.slidesPerView, 10)), f && g % 2 == 0 && (g += 1));
    var h = m.slidesPerGroupAuto ? g : m.slidesPerGroup;
    var b = h;
    b % h != 0 && (b += h - b % h), b += m.loopAdditionalSlides, l.loopedSlides = b;
    var v = l.grid && m.grid && m.grid.rows > 1;
    c.length < g + b ? te("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : v && "row" === m.grid.fill && te("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    var w = [],
      y = [];
    var S = l.activeIndex;
    void 0 === a ? a = l.getSlideIndex(c.find(function (e) {
      return e.classList.contains(m.slideActiveClass);
    })) : S = a;
    var x = "next" === n || !n,
      E = "prev" === n || !n;
    var T = 0,
      k = 0;
    var A = v ? Math.ceil(c.length / m.grid.rows) : c.length,
      C = (v ? c[a].column : a) + (f && void 0 === i ? -g / 2 + .5 : 0);
    if (C < b) {
      T = Math.max(b - C, h);
      for (var _e25 = 0; _e25 < b - C; _e25 += 1) {
        var _t18 = _e25 - Math.floor(_e25 / A) * A;
        if (v) {
          var _e26 = A - _t18 - 1;
          for (var _t19 = c.length - 1; _t19 >= 0; _t19 -= 1) c[_t19].column === _e26 && w.push(_t19);
        } else w.push(A - _t18 - 1);
      }
    } else if (C + g > A - b) {
      k = Math.max(C - (A - 2 * b), h);
      var _loop = function _loop() {
        var t = _e27 - Math.floor(_e27 / A) * A;
        v ? c.forEach(function (e, r) {
          e.column === t && y.push(r);
        }) : y.push(t);
      };
      for (var _e27 = 0; _e27 < k; _e27 += 1) {
        _loop();
      }
    }
    if (l.__preventObserver__ = !0, requestAnimationFrame(function () {
      l.__preventObserver__ = !1;
    }), E && w.forEach(function (e) {
      c[e].swiperLoopMoveDOM = !0, u.prepend(c[e]), c[e].swiperLoopMoveDOM = !1;
    }), x && y.forEach(function (e) {
      c[e].swiperLoopMoveDOM = !0, u.append(c[e]), c[e].swiperLoopMoveDOM = !1;
    }), l.recalcSlides(), "auto" === m.slidesPerView ? l.updateSlides() : v && (w.length > 0 && E || y.length > 0 && x) && l.slides.forEach(function (e, t) {
      l.grid.updateSlide(t, e, l.slides);
    }), m.watchSlidesProgress && l.updateSlidesOffset(), r) if (w.length > 0 && E) {
      if (void 0 === t) {
        var _e28 = l.slidesGrid[S],
          _t20 = l.slidesGrid[S + T] - _e28;
        o ? l.setTranslate(l.translate - _t20) : (l.slideTo(S + Math.ceil(T), 0, !1, !0), i && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - _t20, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - _t20));
      } else if (i) {
        var _e29 = v ? w.length / m.grid.rows : w.length;
        l.slideTo(l.activeIndex + _e29, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (y.length > 0 && x) if (void 0 === t) {
      var _e30 = l.slidesGrid[S],
        _t21 = l.slidesGrid[S - k] - _e30;
      o ? l.setTranslate(l.translate - _t21) : (l.slideTo(S - k, 0, !1, !0), i && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - _t21, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - _t21));
    } else {
      var _e31 = v ? y.length / m.grid.rows : y.length;
      l.slideTo(l.activeIndex - _e31, 0, !1, !0);
    }
    if (l.allowSlidePrev = d, l.allowSlideNext = p, l.controller && l.controller.control && !s) {
      var _e32 = {
        slideRealIndex: t,
        direction: n,
        setTranslate: i,
        activeSlideIndex: a,
        byController: !0
      };
      Array.isArray(l.controller.control) ? l.controller.control.forEach(function (t) {
        !t.destroyed && t.params.loop && t.loopFix(_objectSpread(_objectSpread({}, _e32), {}, {
          slideTo: t.params.slidesPerView === m.slidesPerView && r
        }));
      }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix(_objectSpread(_objectSpread({}, _e32), {}, {
        slideTo: l.controller.control.params.slidesPerView === m.slidesPerView && r
      }));
    }
    l.emit("loopFix");
  },
  loopDestroy: function loopDestroy() {
    var e = this,
      t = e.params,
      r = e.slidesEl;
    if (!t.loop || e.virtual && e.params.virtual.enabled) return;
    e.recalcSlides();
    var n = [];
    e.slides.forEach(function (e) {
      var t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
      n[t] = e;
    }), e.slides.forEach(function (e) {
      e.removeAttribute("data-swiper-slide-index");
    }), n.forEach(function (e) {
      r.append(e);
    }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
  }
};
function Ae(e, t, r) {
  var n = q(),
    i = e.params,
    a = i.edgeSwipeDetection,
    s = i.edgeSwipeThreshold;
  return !a || !(r <= s || r >= n.innerWidth - s) || "prevent" === a && (t.preventDefault(), !0);
}
function Ce(e) {
  var t = this,
    r = H();
  var n = e;
  n.originalEvent && (n = n.originalEvent);
  var i = t.touchEventsData;
  if ("pointerdown" === n.type) {
    if (null !== i.pointerId && i.pointerId !== n.pointerId) return;
    i.pointerId = n.pointerId;
  } else "touchstart" === n.type && 1 === n.targetTouches.length && (i.touchId = n.targetTouches[0].identifier);
  if ("touchstart" === n.type) return void Ae(t, n, n.targetTouches[0].pageX);
  var a = t.params,
    s = t.touches,
    o = t.enabled;
  if (!o) return;
  if (!a.simulateTouch && "mouse" === n.pointerType) return;
  if (t.animating && a.preventInteractionOnTransition) return;
  !t.animating && a.cssMode && a.loop && t.loopFix();
  var l = n.target;
  if ("wrapper" === a.touchEventsTarget && !function (e, t) {
    var r = q();
    var n = t.contains(e);
    !n && r.HTMLSlotElement && t instanceof HTMLSlotElement && (n = _toConsumableArray(t.assignedElements()).includes(e), n || (n = function (e, t) {
      var r = [t];
      for (; r.length > 0;) {
        var _t22$shadowRoot, _t22$assignedElements;
        var _t22 = r.shift();
        if (e === _t22) return !0;
        r.push.apply(r, _toConsumableArray(_t22.children).concat(_toConsumableArray(((_t22$shadowRoot = _t22.shadowRoot) === null || _t22$shadowRoot === void 0 ? void 0 : _t22$shadowRoot.children) || []), _toConsumableArray(((_t22$assignedElements = _t22.assignedElements) === null || _t22$assignedElements === void 0 ? void 0 : _t22$assignedElements.call(_t22)) || [])));
      }
    }(e, t)));
    return n;
  }(l, t.wrapperEl)) return;
  if ("which" in n && 3 === n.which) return;
  if ("button" in n && n.button > 0) return;
  if (i.isTouched && i.isMoved) return;
  var c = !!a.noSwipingClass && "" !== a.noSwipingClass,
    d = n.composedPath ? n.composedPath() : n.path;
  c && n.target && n.target.shadowRoot && d && (l = d[0]);
  var p = a.noSwipingSelector ? a.noSwipingSelector : ".".concat(a.noSwipingClass),
    u = !(!n.target || !n.target.shadowRoot);
  if (a.noSwiping && (u ? function (e, t) {
    return void 0 === t && (t = this), function t(r) {
      if (!r || r === H() || r === q()) return null;
      r.assignedSlot && (r = r.assignedSlot);
      var n = r.closest(e);
      return n || r.getRootNode ? n || t(r.getRootNode().host) : null;
    }(t);
  }(p, l) : l.closest(p))) return void (t.allowClick = !0);
  if (a.swipeHandler && !l.closest(a.swipeHandler)) return;
  s.currentX = n.pageX, s.currentY = n.pageY;
  var m = s.currentX,
    f = s.currentY;
  if (!Ae(t, n, m)) return;
  Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = m, s.startY = f, i.touchStartTime = W(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, a.threshold > 0 && (i.allowThresholdMove = !1);
  var g = !0;
  l.matches(i.focusableElements) && (g = !1, "SELECT" === l.nodeName && (i.isTouched = !1)), r.activeElement && r.activeElement.matches(i.focusableElements) && r.activeElement !== l && ("mouse" === n.pointerType || "mouse" !== n.pointerType && !l.matches(i.focusableElements)) && r.activeElement.blur();
  var h = g && t.allowTouchMove && a.touchStartPreventDefault;
  !a.touchStartForcePreventDefault && !h || l.isContentEditable || n.preventDefault(), a.freeMode && a.freeMode.enabled && t.freeMode && t.animating && !a.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", n);
}
function Me(e) {
  var t = H(),
    r = this,
    n = r.touchEventsData,
    i = r.params,
    a = r.touches,
    s = r.rtlTranslate,
    o = r.enabled;
  if (!o) return;
  if (!i.simulateTouch && "mouse" === e.pointerType) return;
  var l,
    c = e;
  if (c.originalEvent && (c = c.originalEvent), "pointermove" === c.type) {
    if (null !== n.touchId) return;
    if (c.pointerId !== n.pointerId) return;
  }
  if ("touchmove" === c.type) {
    if (l = _toConsumableArray(c.changedTouches).find(function (e) {
      return e.identifier === n.touchId;
    }), !l || l.identifier !== n.touchId) return;
  } else l = c;
  if (!n.isTouched) return void (n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", c));
  var d = l.pageX,
    p = l.pageY;
  if (c.preventedByNestedSwiper) return a.startX = d, void (a.startY = p);
  if (!r.allowTouchMove) return c.target.matches(n.focusableElements) || (r.allowClick = !1), void (n.isTouched && (Object.assign(a, {
    startX: d,
    startY: p,
    currentX: d,
    currentY: p
  }), n.touchStartTime = W()));
  if (i.touchReleaseOnEdges && !i.loop) if (r.isVertical()) {
    if (p < a.startY && r.translate <= r.maxTranslate() || p > a.startY && r.translate >= r.minTranslate()) return n.isTouched = !1, void (n.isMoved = !1);
  } else if (d < a.startX && r.translate <= r.maxTranslate() || d > a.startX && r.translate >= r.minTranslate()) return;
  if (t.activeElement && t.activeElement.matches(n.focusableElements) && t.activeElement !== c.target && "mouse" !== c.pointerType && t.activeElement.blur(), t.activeElement && c.target === t.activeElement && c.target.matches(n.focusableElements)) return n.isMoved = !0, void (r.allowClick = !1);
  n.allowTouchCallbacks && r.emit("touchMove", c), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = d, a.currentY = p;
  var u = a.currentX - a.startX,
    m = a.currentY - a.startY;
  if (r.params.threshold && Math.sqrt(Math.pow(u, 2) + Math.pow(m, 2)) < r.params.threshold) return;
  if (void 0 === n.isScrolling) {
    var _e33;
    r.isHorizontal() && a.currentY === a.startY || r.isVertical() && a.currentX === a.startX ? n.isScrolling = !1 : u * u + m * m >= 25 && (_e33 = 180 * Math.atan2(Math.abs(m), Math.abs(u)) / Math.PI, n.isScrolling = r.isHorizontal() ? _e33 > i.touchAngle : 90 - _e33 > i.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", c), void 0 === n.startMoving && (a.currentX === a.startX && a.currentY === a.startY || (n.startMoving = !0)), n.isScrolling || "touchmove" === c.type && n.preventTouchMoveFromPointerMove) return void (n.isTouched = !1);
  if (!n.startMoving) return;
  r.allowClick = !1, !i.cssMode && c.cancelable && c.preventDefault(), i.touchMoveStopPropagation && !i.nested && c.stopPropagation();
  var f = r.isHorizontal() ? u : m,
    g = r.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
  i.oneWayMovement && (f = Math.abs(f) * (s ? 1 : -1), g = Math.abs(g) * (s ? 1 : -1)), a.diff = f, f *= i.touchRatio, s && (f = -f, g = -g);
  var h = r.touchesDirection;
  r.swipeDirection = f > 0 ? "prev" : "next", r.touchesDirection = g > 0 ? "prev" : "next";
  var b = r.params.loop && !i.cssMode,
    v = "next" === r.touchesDirection && r.allowSlideNext || "prev" === r.touchesDirection && r.allowSlidePrev;
  if (!n.isMoved) {
    if (b && v && r.loopFix({
      direction: r.swipeDirection
    }), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      var _e34 = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      r.wrapperEl.dispatchEvent(_e34);
    }
    n.allowMomentumBounce = !1, !i.grabCursor || !0 !== r.allowSlideNext && !0 !== r.allowSlidePrev || r.setGrabCursor(!0), r.emit("sliderFirstMove", c);
  }
  if (new Date().getTime(), n.isMoved && n.allowThresholdMove && h !== r.touchesDirection && b && v && Math.abs(f) >= 1) return Object.assign(a, {
    startX: d,
    startY: p,
    currentX: d,
    currentY: p,
    startTranslate: n.currentTranslate
  }), n.loopSwapReset = !0, void (n.startTranslate = n.currentTranslate);
  r.emit("sliderMove", c), n.isMoved = !0, n.currentTranslate = f + n.startTranslate;
  var w = !0,
    y = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (y = 0), f > 0 ? (b && v && n.allowThresholdMove && n.currentTranslate > (i.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - ("auto" !== i.slidesPerView && r.slides.length - i.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > r.minTranslate() && (w = !1, i.resistance && (n.currentTranslate = r.minTranslate() - 1 + Math.pow(-r.minTranslate() + n.startTranslate + f, y)))) : f < 0 && (b && v && n.allowThresholdMove && n.currentTranslate < (i.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + ("auto" !== i.slidesPerView && r.slides.length - i.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - ("auto" === i.slidesPerView ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
  }), n.currentTranslate < r.maxTranslate() && (w = !1, i.resistance && (n.currentTranslate = r.maxTranslate() + 1 - Math.pow(r.maxTranslate() - n.startTranslate - f, y)))), w && (c.preventedByNestedSwiper = !0), !r.allowSlideNext && "next" === r.swipeDirection && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && "prev" === r.swipeDirection && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), r.allowSlidePrev || r.allowSlideNext || (n.currentTranslate = n.startTranslate), i.threshold > 0) {
    if (!(Math.abs(f) > i.threshold || n.allowThresholdMove)) return void (n.currentTranslate = n.startTranslate);
    if (!n.allowThresholdMove) return n.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, n.currentTranslate = n.startTranslate, void (a.diff = r.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY);
  }
  i.followFinger && !i.cssMode && ((i.freeMode && i.freeMode.enabled && r.freeMode || i.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), i.freeMode && i.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function Pe(e) {
  var t = this,
    r = t.touchEventsData;
  var n,
    i = e;
  i.originalEvent && (i = i.originalEvent);
  if ("touchend" === i.type || "touchcancel" === i.type) {
    if (n = _toConsumableArray(i.changedTouches).find(function (e) {
      return e.identifier === r.touchId;
    }), !n || n.identifier !== r.touchId) return;
  } else {
    if (null !== r.touchId) return;
    if (i.pointerId !== r.pointerId) return;
    n = i;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(i.type)) {
    if (!(["pointercancel", "contextmenu"].includes(i.type) && (t.browser.isSafari || t.browser.isWebView))) return;
  }
  r.pointerId = null, r.touchId = null;
  var a = t.params,
    s = t.touches,
    o = t.rtlTranslate,
    l = t.slidesGrid,
    c = t.enabled;
  if (!c) return;
  if (!a.simulateTouch && "mouse" === i.pointerType) return;
  if (r.allowTouchCallbacks && t.emit("touchEnd", i), r.allowTouchCallbacks = !1, !r.isTouched) return r.isMoved && a.grabCursor && t.setGrabCursor(!1), r.isMoved = !1, void (r.startMoving = !1);
  a.grabCursor && r.isMoved && r.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
  var d = W(),
    p = d - r.touchStartTime;
  if (t.allowClick) {
    var _e35 = i.path || i.composedPath && i.composedPath();
    t.updateClickedSlide(_e35 && _e35[0] || i.target, _e35), t.emit("tap click", i), p < 300 && d - r.lastClickTime < 300 && t.emit("doubleTap doubleClick", i);
  }
  if (r.lastClickTime = W(), V(function () {
    t.destroyed || (t.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !t.swipeDirection || 0 === s.diff && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) return r.isTouched = !1, r.isMoved = !1, void (r.startMoving = !1);
  var u;
  if (r.isTouched = !1, r.isMoved = !1, r.startMoving = !1, u = a.followFinger ? o ? t.translate : -t.translate : -r.currentTranslate, a.cssMode) return;
  if (a.freeMode && a.freeMode.enabled) return void t.freeMode.onTouchEnd({
    currentPos: u
  });
  var m = u >= -t.maxTranslate() && !t.params.loop;
  var f = 0,
    g = t.slidesSizesGrid[0];
  for (var _e36 = 0; _e36 < l.length; _e36 += _e36 < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    var _t23 = _e36 < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    void 0 !== l[_e36 + _t23] ? (m || u >= l[_e36] && u < l[_e36 + _t23]) && (f = _e36, g = l[_e36 + _t23] - l[_e36]) : (m || u >= l[_e36]) && (f = _e36, g = l[l.length - 1] - l[l.length - 2]);
  }
  var h = null,
    b = null;
  a.rewind && (t.isBeginning ? b = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (h = 0));
  var v = (u - l[f]) / g,
    w = f < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (p > a.longSwipesMs) {
    if (!a.longSwipes) return void t.slideTo(t.activeIndex);
    "next" === t.swipeDirection && (v >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? h : f + w) : t.slideTo(f)), "prev" === t.swipeDirection && (v > 1 - a.longSwipesRatio ? t.slideTo(f + w) : null !== b && v < 0 && Math.abs(v) > a.longSwipesRatio ? t.slideTo(b) : t.slideTo(f));
  } else {
    if (!a.shortSwipes) return void t.slideTo(t.activeIndex);
    t.navigation && (i.target === t.navigation.nextEl || i.target === t.navigation.prevEl) ? i.target === t.navigation.nextEl ? t.slideTo(f + w) : t.slideTo(f) : ("next" === t.swipeDirection && t.slideTo(null !== h ? h : f + w), "prev" === t.swipeDirection && t.slideTo(null !== b ? b : f));
  }
}
function Le() {
  var e = this,
    t = e.params,
    r = e.el;
  if (r && 0 === r.offsetWidth) return;
  t.breakpoints && e.setBreakpoint();
  var n = e.allowSlideNext,
    i = e.allowSlidePrev,
    a = e.snapGrid,
    s = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  var o = s && t.loop;
  !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || o ? e.params.loop && !s ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(function () {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = i, e.allowSlideNext = n, e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
}
function Oe(e) {
  var t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function Ie() {
  var e = this,
    t = e.wrapperEl,
    r = e.rtlTranslate,
    n = e.enabled;
  if (!n) return;
  var i;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  var a = e.maxTranslate() - e.minTranslate();
  i = 0 === a ? 0 : (e.translate - e.minTranslate()) / a, i !== e.progress && e.updateProgress(r ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function ze(e) {
  var t = this;
  ve(t, e.target), t.params.cssMode || "auto" !== t.params.slidesPerView && !t.params.autoHeight || t.update();
}
function Ne() {
  var e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
var De = function De(e, t) {
  var r = H(),
    n = e.params,
    i = e.el,
    a = e.wrapperEl,
    s = e.device,
    o = !!n.nested,
    l = "on" === t ? "addEventListener" : "removeEventListener",
    c = t;
  i && "string" != typeof i && (r[l]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), i[l]("touchstart", e.onTouchStart, {
    passive: !1
  }), i[l]("pointerdown", e.onTouchStart, {
    passive: !1
  }), r[l]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("touchend", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerup", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), r[l]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerout", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), r[l]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && i[l]("click", e.onClick, !0), n.cssMode && a[l]("scroll", e.onScroll), n.updateOnWindowResize ? e[c](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Le, !0) : e[c]("observerUpdate", Le, !0), i[l]("load", e.onLoad, {
    capture: !0
  }));
};
var _e = function _e(e, t) {
  return e.grid && t.grid && t.grid.rows > 1;
};
var Be = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: !1,
  userAgent: null,
  url: null,
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  autoHeight: !1,
  setWrapperSize: !1,
  virtualTranslate: !1,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  watchOverflow: !0,
  roundLengths: !1,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: .5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  uniqueNavElements: !0,
  resistance: !0,
  resistanceRatio: .85,
  watchSlidesProgress: !1,
  grabCursor: !1,
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  rewind: !1,
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  runCallbacksOnInit: !0,
  _emitClasses: !1
};
function Fe(e, t) {
  return function (r) {
    void 0 === r && (r = {});
    var n = Object.keys(r)[0],
      i = r[n];
    "object" == _typeof(i) && null !== i ? (!0 === e[n] && (e[n] = {
      enabled: !0
    }), "navigation" === n && e[n] && e[n].enabled && !e[n].prevEl && !e[n].nextEl && (e[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && e[n] && e[n].enabled && !e[n].el && (e[n].auto = !0), n in e && "enabled" in i ? ("object" != _typeof(e[n]) || "enabled" in e[n] || (e[n].enabled = !0), e[n] || (e[n] = {
      enabled: !1
    }), X(t, r)) : X(t, r)) : X(t, r);
  };
}
var Ge = {
    eventsEmitter: ge,
    update: Se,
    translate: xe,
    transition: {
      setTransition: function setTransition(e, t) {
        var r = this;
        r.params.cssMode || (r.wrapperEl.style.transitionDuration = "".concat(e, "ms"), r.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""), r.emit("setTransition", e, t);
      },
      transitionStart: function transitionStart(e, t) {
        void 0 === e && (e = !0);
        var r = this,
          n = r.params;
        n.cssMode || (n.autoHeight && r.updateAutoHeight(), Ee({
          swiper: r,
          runCallbacks: e,
          direction: t,
          step: "Start"
        }));
      },
      transitionEnd: function transitionEnd(e, t) {
        void 0 === e && (e = !0);
        var r = this,
          n = r.params;
        r.animating = !1, n.cssMode || (r.setTransition(0), Ee({
          swiper: r,
          runCallbacks: e,
          direction: t,
          step: "End"
        }));
      }
    },
    slide: Te,
    loop: ke,
    grabCursor: {
      setGrabCursor: function setGrabCursor(e) {
        var t = this;
        if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
        var r = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
        t.isElement && (t.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(function () {
          t.__preventObserver__ = !1;
        });
      },
      unsetGrabCursor: function unsetGrabCursor() {
        var e = this;
        e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(function () {
          e.__preventObserver__ = !1;
        }));
      }
    },
    events: {
      attachEvents: function attachEvents() {
        var e = this,
          t = e.params;
        e.onTouchStart = Ce.bind(e), e.onTouchMove = Me.bind(e), e.onTouchEnd = Pe.bind(e), e.onDocumentTouchStart = Ne.bind(e), t.cssMode && (e.onScroll = Ie.bind(e)), e.onClick = Oe.bind(e), e.onLoad = ze.bind(e), De(e, "on");
      },
      detachEvents: function detachEvents() {
        De(this, "off");
      }
    },
    breakpoints: {
      setBreakpoint: function setBreakpoint() {
        var e = this,
          t = e.realIndex,
          r = e.initialized,
          n = e.params,
          i = e.el,
          a = n.breakpoints;
        if (!a || a && 0 === Object.keys(a).length) return;
        var s = H(),
          o = "window" !== n.breakpointsBase && n.breakpointsBase ? "container" : n.breakpointsBase,
          l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? e.el : s.querySelector(n.breakpointsBase),
          c = e.getBreakpoint(a, o, l);
        if (!c || e.currentBreakpoint === c) return;
        var d = (c in a ? a[c] : void 0) || e.originalParams,
          p = _e(e, n),
          u = _e(e, d),
          m = e.params.grabCursor,
          f = d.grabCursor,
          g = n.enabled;
        p && !u ? (i.classList.remove("".concat(n.containerModifierClass, "grid"), "".concat(n.containerModifierClass, "grid-column")), e.emitContainerClasses()) : !p && u && (i.classList.add("".concat(n.containerModifierClass, "grid")), (d.grid.fill && "column" === d.grid.fill || !d.grid.fill && "column" === n.grid.fill) && i.classList.add("".concat(n.containerModifierClass, "grid-column")), e.emitContainerClasses()), m && !f ? e.unsetGrabCursor() : !m && f && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach(function (t) {
          if (void 0 === d[t]) return;
          var r = n[t] && n[t].enabled,
            i = d[t] && d[t].enabled;
          r && !i && e[t].disable(), !r && i && e[t].enable();
        });
        var h = d.direction && d.direction !== n.direction,
          b = n.loop && (d.slidesPerView !== n.slidesPerView || h),
          v = n.loop;
        h && r && e.changeDirection(), X(e.params, d);
        var w = e.params.enabled,
          y = e.params.loop;
        Object.assign(e, {
          allowTouchMove: e.params.allowTouchMove,
          allowSlideNext: e.params.allowSlideNext,
          allowSlidePrev: e.params.allowSlidePrev
        }), g && !w ? e.disable() : !g && w && e.enable(), e.currentBreakpoint = c, e.emit("_beforeBreakpoint", d), r && (b ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !v && y ? (e.loopCreate(t), e.updateSlides()) : v && !y && e.loopDestroy()), e.emit("breakpoint", d);
      },
      getBreakpoint: function getBreakpoint(e, t, r) {
        if (void 0 === t && (t = "window"), !e || "container" === t && !r) return;
        var n = !1;
        var i = q(),
          a = "window" === t ? i.innerHeight : r.clientHeight,
          s = Object.keys(e).map(function (e) {
            if ("string" == typeof e && 0 === e.indexOf("@")) {
              var _t24 = parseFloat(e.substr(1));
              return {
                value: a * _t24,
                point: e
              };
            }
            return {
              value: e,
              point: e
            };
          });
        s.sort(function (e, t) {
          return parseInt(e.value, 10) - parseInt(t.value, 10);
        });
        for (var _e37 = 0; _e37 < s.length; _e37 += 1) {
          var _s$_e = s[_e37],
            _a6 = _s$_e.point,
            _o5 = _s$_e.value;
          "window" === t ? i.matchMedia("(min-width: ".concat(_o5, "px)")).matches && (n = _a6) : _o5 <= r.clientWidth && (n = _a6);
        }
        return n || "max";
      }
    },
    checkOverflow: {
      checkOverflow: function checkOverflow() {
        var e = this,
          t = e.isLocked,
          r = e.params,
          n = r.slidesOffsetBefore;
        if (n) {
          var _t25 = e.slides.length - 1,
            _r13 = e.slidesGrid[_t25] + e.slidesSizesGrid[_t25] + 2 * n;
          e.isLocked = e.size > _r13;
        } else e.isLocked = 1 === e.snapGrid.length;
        !0 === r.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === r.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
      }
    },
    classes: {
      addClasses: function addClasses() {
        var _i$classList;
        var e = this,
          t = e.classNames,
          r = e.params,
          n = e.rtl,
          i = e.el,
          a = e.device,
          s = function (e, t) {
            var r = [];
            return e.forEach(function (e) {
              "object" == _typeof(e) ? Object.keys(e).forEach(function (n) {
                e[n] && r.push(t + n);
              }) : "string" == typeof e && r.push(t + e);
            }), r;
          }(["initialized", r.direction, {
            "free-mode": e.params.freeMode && r.freeMode.enabled
          }, {
            autoheight: r.autoHeight
          }, {
            rtl: n
          }, {
            grid: r.grid && r.grid.rows > 1
          }, {
            "grid-column": r.grid && r.grid.rows > 1 && "column" === r.grid.fill
          }, {
            android: a.android
          }, {
            ios: a.ios
          }, {
            "css-mode": r.cssMode
          }, {
            centered: r.cssMode && r.centeredSlides
          }, {
            "watch-progress": r.watchSlidesProgress
          }], r.containerModifierClass);
        t.push.apply(t, _toConsumableArray(s)), (_i$classList = i.classList).add.apply(_i$classList, _toConsumableArray(t)), e.emitContainerClasses();
      },
      removeClasses: function removeClasses() {
        var _e$classList;
        var e = this.el,
          t = this.classNames;
        e && "string" != typeof e && ((_e$classList = e.classList).remove.apply(_e$classList, _toConsumableArray(t)), this.emitContainerClasses());
      }
    }
  },
  je = {};
var $e = /*#__PURE__*/function () {
  function e() {
    var _i8, _i9, _o$modules;
    _classCallCheck(this, e);
    var t, r;
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++) i[a] = arguments[a];
    1 === i.length && i[0].constructor && "Object" === Object.prototype.toString.call(i[0]).slice(8, -1) ? r = i[0] : (_i8 = i, _i9 = _slicedToArray(_i8, 2), t = _i9[0], r = _i9[1], _i8), r || (r = {}), r = X({}, r), t && !r.el && (r.el = t);
    var s = H();
    if (r.el && "string" == typeof r.el && s.querySelectorAll(r.el).length > 1) {
      var _t26 = [];
      return s.querySelectorAll(r.el).forEach(function (n) {
        var i = X({}, r, {
          el: n
        });
        _t26.push(new e(i));
      }), _t26;
    }
    var o = this;
    o.__swiper__ = !0, o.support = ue(), o.device = me({
      userAgent: r.userAgent
    }), o.browser = fe(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = _toConsumableArray(o.__modules__), r.modules && Array.isArray(r.modules) && (_o$modules = o.modules).push.apply(_o$modules, _toConsumableArray(r.modules));
    var l = {};
    o.modules.forEach(function (_e38) {
      _e38({
        params: r,
        swiper: o,
        extendParams: Fe(r, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    var c = X({}, Be, l);
    return o.params = X({}, c, je, r), o.originalParams = X({}, o.params), o.passedParams = X({}, r), o.params && o.params.on && Object.keys(o.params.on).forEach(function (_e39) {
      o.on(_e39, o.params.on[_e39]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      classNames: [],
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal: function isHorizontal() {
        return "horizontal" === o.params.direction;
      },
      isVertical: function isVertical() {
        return "vertical" === o.params.direction;
      },
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment: function cssOverflowAdjustment() {
        return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
      },
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: o.params.focusableElements,
        lastClickTime: 0,
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      allowClick: !0,
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  _createClass(e, [{
    key: "getDirectionLabel",
    value: function getDirectionLabel(_e40) {
      return this.isHorizontal() ? _e40 : {
        width: "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        marginRight: "marginBottom"
      }[_e40];
    }
  }, {
    key: "getSlideIndex",
    value: function getSlideIndex(_e41) {
      var t = this.slidesEl,
        r = this.params,
        n = ie(ee(t, ".".concat(r.slideClass, ", swiper-slide"))[0]);
      return ie(_e41) - n;
    }
  }, {
    key: "getSlideIndexByData",
    value: function getSlideIndexByData(_e42) {
      return this.getSlideIndex(this.slides.find(function (t) {
        return 1 * t.getAttribute("data-swiper-slide-index") === _e42;
      }));
    }
  }, {
    key: "recalcSlides",
    value: function recalcSlides() {
      var _e43 = this.slidesEl,
        t = this.params;
      this.slides = ee(_e43, ".".concat(t.slideClass, ", swiper-slide"));
    }
  }, {
    key: "enable",
    value: function enable() {
      var _e44 = this;
      _e44.enabled || (_e44.enabled = !0, _e44.params.grabCursor && _e44.setGrabCursor(), _e44.emit("enable"));
    }
  }, {
    key: "disable",
    value: function disable() {
      var _e45 = this;
      _e45.enabled && (_e45.enabled = !1, _e45.params.grabCursor && _e45.unsetGrabCursor(), _e45.emit("disable"));
    }
  }, {
    key: "setProgress",
    value: function setProgress(_e46, t) {
      var r = this;
      _e46 = Math.min(Math.max(_e46, 0), 1);
      var n = r.minTranslate(),
        i = (r.maxTranslate() - n) * _e46 + n;
      r.translateTo(i, void 0 === t ? 0 : t), r.updateActiveIndex(), r.updateSlidesClasses();
    }
  }, {
    key: "emitContainerClasses",
    value: function emitContainerClasses() {
      var _e47 = this;
      if (!_e47.params._emitClasses || !_e47.el) return;
      var t = _e47.el.className.split(" ").filter(function (t) {
        return 0 === t.indexOf("swiper") || 0 === t.indexOf(_e47.params.containerModifierClass);
      });
      _e47.emit("_containerClasses", t.join(" "));
    }
  }, {
    key: "getSlideClasses",
    value: function getSlideClasses(_e48) {
      var t = this;
      return t.destroyed ? "" : _e48.className.split(" ").filter(function (_e49) {
        return 0 === _e49.indexOf("swiper-slide") || 0 === _e49.indexOf(t.params.slideClass);
      }).join(" ");
    }
  }, {
    key: "emitSlidesClasses",
    value: function emitSlidesClasses() {
      var _e50 = this;
      if (!_e50.params._emitClasses || !_e50.el) return;
      var t = [];
      _e50.slides.forEach(function (r) {
        var n = _e50.getSlideClasses(r);
        t.push({
          slideEl: r,
          classNames: n
        }), _e50.emit("_slideClass", r, n);
      }), _e50.emit("_slideClasses", t);
    }
  }, {
    key: "slidesPerViewDynamic",
    value: function slidesPerViewDynamic(_e51, t) {
      void 0 === _e51 && (_e51 = "current"), void 0 === t && (t = !1);
      var r = this.params,
        n = this.slides,
        i = this.slidesGrid,
        a = this.slidesSizesGrid,
        s = this.size,
        o = this.activeIndex;
      var l = 1;
      if ("number" == typeof r.slidesPerView) return r.slidesPerView;
      if (r.centeredSlides) {
        var _e52,
          _t27 = n[o] ? Math.ceil(n[o].swiperSlideSize) : 0;
        for (var _r14 = o + 1; _r14 < n.length; _r14 += 1) n[_r14] && !_e52 && (_t27 += Math.ceil(n[_r14].swiperSlideSize), l += 1, _t27 > s && (_e52 = !0));
        for (var _r15 = o - 1; _r15 >= 0; _r15 -= 1) n[_r15] && !_e52 && (_t27 += n[_r15].swiperSlideSize, l += 1, _t27 > s && (_e52 = !0));
      } else if ("current" === _e51) for (var _e67 = o + 1; _e67 < n.length; _e67 += 1) {
        (t ? i[_e67] + a[_e67] - i[o] < s : i[_e67] - i[o] < s) && (l += 1);
      } else for (var _e68 = o - 1; _e68 >= 0; _e68 -= 1) {
        i[o] - i[_e68] < s && (l += 1);
      }
      return l;
    }
  }, {
    key: "update",
    value: function update() {
      var _e55 = this;
      if (!_e55 || _e55.destroyed) return;
      var t = _e55.snapGrid,
        r = _e55.params;
      function n() {
        var t = _e55.rtlTranslate ? -1 * _e55.translate : _e55.translate,
          r = Math.min(Math.max(t, _e55.maxTranslate()), _e55.minTranslate());
        _e55.setTranslate(r), _e55.updateActiveIndex(), _e55.updateSlidesClasses();
      }
      var i;
      if (r.breakpoints && _e55.setBreakpoint(), _toConsumableArray(_e55.el.querySelectorAll('[loading="lazy"]')).forEach(function (t) {
        t.complete && ve(_e55, t);
      }), _e55.updateSize(), _e55.updateSlides(), _e55.updateProgress(), _e55.updateSlidesClasses(), r.freeMode && r.freeMode.enabled && !r.cssMode) n(), r.autoHeight && _e55.updateAutoHeight();else {
        if (("auto" === r.slidesPerView || r.slidesPerView > 1) && _e55.isEnd && !r.centeredSlides) {
          var _t28 = _e55.virtual && r.virtual.enabled ? _e55.virtual.slides : _e55.slides;
          i = _e55.slideTo(_t28.length - 1, 0, !1, !0);
        } else i = _e55.slideTo(_e55.activeIndex, 0, !1, !0);
        i || n();
      }
      r.watchOverflow && t !== _e55.snapGrid && _e55.checkOverflow(), _e55.emit("update");
    }
  }, {
    key: "changeDirection",
    value: function changeDirection(_e56, t) {
      void 0 === t && (t = !0);
      var r = this,
        n = r.params.direction;
      return _e56 || (_e56 = "horizontal" === n ? "vertical" : "horizontal"), _e56 === n || "horizontal" !== _e56 && "vertical" !== _e56 || (r.el.classList.remove("".concat(r.params.containerModifierClass).concat(n)), r.el.classList.add("".concat(r.params.containerModifierClass).concat(_e56)), r.emitContainerClasses(), r.params.direction = _e56, r.slides.forEach(function (t) {
        "vertical" === _e56 ? t.style.width = "" : t.style.height = "";
      }), r.emit("changeDirection"), t && r.update()), r;
    }
  }, {
    key: "changeLanguageDirection",
    value: function changeLanguageDirection(_e57) {
      var t = this;
      t.rtl && "rtl" === _e57 || !t.rtl && "ltr" === _e57 || (t.rtl = "rtl" === _e57, t.rtlTranslate = "horizontal" === t.params.direction && t.rtl, t.rtl ? (t.el.classList.add("".concat(t.params.containerModifierClass, "rtl")), t.el.dir = "rtl") : (t.el.classList.remove("".concat(t.params.containerModifierClass, "rtl")), t.el.dir = "ltr"), t.update());
    }
  }, {
    key: "mount",
    value: function mount(_e58) {
      var t = this;
      if (t.mounted) return !0;
      var r = _e58 || t.params.el;
      if ("string" == typeof r && (r = document.querySelector(r)), !r) return !1;
      r.swiper = t, r.parentNode && r.parentNode.host && r.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
      var n = function n() {
        return ".".concat((t.params.wrapperClass || "").trim().split(" ").join("."));
      };
      var i = function () {
        if (r && r.shadowRoot && r.shadowRoot.querySelector) {
          return r.shadowRoot.querySelector(n());
        }
        return ee(r, n())[0];
      }();
      return !i && t.params.createElements && (i = re("div", t.params.wrapperClass), r.append(i), ee(r, ".".concat(t.params.slideClass)).forEach(function (_e59) {
        i.append(_e59);
      })), Object.assign(t, {
        el: r,
        wrapperEl: i,
        slidesEl: t.isElement && !r.parentNode.host.slideSlots ? r.parentNode.host : i,
        hostEl: t.isElement ? r.parentNode.host : r,
        mounted: !0,
        rtl: "rtl" === r.dir.toLowerCase() || "rtl" === ne(r, "direction"),
        rtlTranslate: "horizontal" === t.params.direction && ("rtl" === r.dir.toLowerCase() || "rtl" === ne(r, "direction")),
        wrongRTL: "-webkit-box" === ne(i, "display")
      }), !0;
    }
  }, {
    key: "init",
    value: function init(_e60) {
      var t = this;
      if (t.initialized) return t;
      if (!1 === t.mount(_e60)) return t;
      t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
      var r = _toConsumableArray(t.el.querySelectorAll('[loading="lazy"]'));
      return t.isElement && r.push.apply(r, _toConsumableArray(t.hostEl.querySelectorAll('[loading="lazy"]'))), r.forEach(function (_e61) {
        _e61.complete ? ve(t, _e61) : _e61.addEventListener("load", function (_e62) {
          ve(t, _e62.target);
        });
      }), ye(t), t.initialized = !0, ye(t), t.emit("init"), t.emit("afterInit"), t;
    }
  }, {
    key: "destroy",
    value: function destroy(_e63, t) {
      void 0 === _e63 && (_e63 = !0), void 0 === t && (t = !0);
      var r = this,
        n = r.params,
        i = r.el,
        a = r.wrapperEl,
        s = r.slides;
      return void 0 === r.params || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), n.loop && r.loopDestroy(), t && (r.removeClasses(), i && "string" != typeof i && i.removeAttribute("style"), a && a.removeAttribute("style"), s && s.length && s.forEach(function (_e64) {
        _e64.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), _e64.removeAttribute("style"), _e64.removeAttribute("data-swiper-slide-index");
      })), r.emit("destroy"), Object.keys(r.eventsListeners).forEach(function (_e65) {
        r.off(_e65);
      }), !1 !== _e63 && (r.el && "string" != typeof r.el && (r.el.swiper = null), function (e) {
        var t = e;
        Object.keys(t).forEach(function (e) {
          try {
            t[e] = null;
          } catch (e) {}
          try {
            delete t[e];
          } catch (e) {}
        });
      }(r)), r.destroyed = !0), null;
    }
  }], [{
    key: "extendDefaults",
    value: function extendDefaults(_e66) {
      X(je, _e66);
    }
  }, {
    key: "extendedDefaults",
    get: function get() {
      return je;
    }
  }, {
    key: "defaults",
    get: function get() {
      return Be;
    }
  }, {
    key: "installModule",
    value: function installModule(t) {
      e.prototype.__modules__ || (e.prototype.__modules__ = []);
      var r = e.prototype.__modules__;
      "function" == typeof t && r.indexOf(t) < 0 && r.push(t);
    }
  }, {
    key: "use",
    value: function use(t) {
      return Array.isArray(t) ? (t.forEach(function (t) {
        return e.installModule(t);
      }), e) : (e.installModule(t), e);
    }
  }]);
  return e;
}();
Object.keys(Ge).forEach(function (e) {
  Object.keys(Ge[e]).forEach(function (t) {
    $e.prototype[t] = Ge[e][t];
  });
}), $e.use([function (e) {
  var t = e.swiper,
    r = e.on,
    n = e.emit;
  var i = q();
  var a = null,
    s = null;
  var o = function o() {
      t && !t.destroyed && t.initialized && (n("beforeResize"), n("resize"));
    },
    l = function l() {
      t && !t.destroyed && t.initialized && n("orientationchange");
    };
  r("init", function () {
    t.params.resizeObserver && void 0 !== i.ResizeObserver ? t && !t.destroyed && t.initialized && (a = new ResizeObserver(function (e) {
      s = i.requestAnimationFrame(function () {
        var r = t.width,
          n = t.height;
        var i = r,
          a = n;
        e.forEach(function (e) {
          var r = e.contentBoxSize,
            n = e.contentRect,
            s = e.target;
          s && s !== t.el || (i = n ? n.width : (r[0] || r).inlineSize, a = n ? n.height : (r[0] || r).blockSize);
        }), i === r && a === n || o();
      });
    }), a.observe(t.el)) : (i.addEventListener("resize", o), i.addEventListener("orientationchange", l));
  }), r("destroy", function () {
    s && i.cancelAnimationFrame(s), a && a.unobserve && t.el && (a.unobserve(t.el), a = null), i.removeEventListener("resize", o), i.removeEventListener("orientationchange", l);
  });
}, function (e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on,
    i = e.emit;
  var a = [],
    s = q(),
    o = function o(e, r) {
      void 0 === r && (r = {});
      var n = new (s.MutationObserver || s.WebkitMutationObserver)(function (e) {
        if (t.__preventObserver__) return;
        if (1 === e.length) return void i("observerUpdate", e[0]);
        var r = function r() {
          i("observerUpdate", e[0]);
        };
        s.requestAnimationFrame ? s.requestAnimationFrame(r) : s.setTimeout(r, 0);
      });
      n.observe(e, {
        attributes: void 0 === r.attributes || r.attributes,
        childList: t.isElement || (void 0 === r.childList || r).childList,
        characterData: void 0 === r.characterData || r.characterData
      }), a.push(n);
    };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", function () {
    if (t.params.observer) {
      if (t.params.observeParents) {
        var _e69 = ae(t.hostEl);
        for (var _t29 = 0; _t29 < _e69.length; _t29 += 1) o(_e69[_t29]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }), n("destroy", function () {
    a.forEach(function (e) {
      e.disconnect();
    }), a.splice(0, a.length);
  });
}]);
var He = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "swiperElementNodeName", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopAdditionalSlides", "loopAddBlankSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideFullyVisibleClass", "slideNextClass", "slidePrevClass", "slideBlankClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
function Re(e) {
  return "object" == _typeof(e) && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1) && !e.__swiper__;
}
function qe(e, t) {
  var r = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter(function (e) {
    return r.indexOf(e) < 0;
  }).forEach(function (r) {
    void 0 === e[r] ? e[r] = t[r] : Re(t[r]) && Re(e[r]) && Object.keys(t[r]).length > 0 ? t[r].__swiper__ ? e[r] = t[r] : qe(e[r], t[r]) : e[r] = t[r];
  });
}
function Ye(e) {
  return void 0 === e && (e = {}), e.navigation && void 0 === e.navigation.nextEl && void 0 === e.navigation.prevEl;
}
function Ve(e) {
  return void 0 === e && (e = {}), e.pagination && void 0 === e.pagination.el;
}
function We(e) {
  return void 0 === e && (e = {}), e.scrollbar && void 0 === e.scrollbar.el;
}
function Ke(e) {
  void 0 === e && (e = "");
  var t = e.split(" ").map(function (e) {
      return e.trim();
    }).filter(function (e) {
      return !!e;
    }),
    r = [];
  return t.forEach(function (e) {
    r.indexOf(e) < 0 && r.push(e);
  }), r.join(" ");
}
function Ue(e) {
  return void 0 === e && (e = ""), e ? e.includes("swiper-wrapper") ? e : "swiper-wrapper ".concat(e) : "swiper-wrapper";
}
function Xe() {
  return Xe = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xe.apply(this, arguments);
}
function Ze(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function Qe(t) {
  var r = [];
  return e.Children.toArray(t).forEach(function (e) {
    Ze(e) ? r.push(e) : e.props && e.props.children && Qe(e.props.children).forEach(function (e) {
      return r.push(e);
    });
  }), r;
}
function Je(t) {
  var r = [],
    n = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return e.Children.toArray(t).forEach(function (e) {
    if (Ze(e)) r.push(e);else if (e.props && e.props.slot && n[e.props.slot]) n[e.props.slot].push(e);else if (e.props && e.props.children) {
      var _t30 = Qe(e.props.children);
      _t30.length > 0 ? _t30.forEach(function (e) {
        return r.push(e);
      }) : n["container-end"].push(e);
    } else n["container-end"].push(e);
  }), {
    slides: r,
    slots: n
  };
}
function et(e, t) {
  return "undefined" == typeof window ? i(e, t) : a(e, t);
}
var tt = /*#__PURE__*/s(null),
  rt = /*#__PURE__*/s(null),
  nt = /*#__PURE__*/t(function (t, a) {
    var _ref3 = void 0 === t ? {} : t,
      s = _ref3.className,
      _ref3$tag = _ref3.tag,
      o = _ref3$tag === void 0 ? "div" : _ref3$tag,
      _ref3$wrapperTag = _ref3.wrapperTag,
      l = _ref3$wrapperTag === void 0 ? "div" : _ref3$wrapperTag,
      c = _ref3.children,
      d = _ref3.onSwiper,
      p = _objectWithoutProperties(_ref3, _excluded),
      u = !1;
    var _r16 = r("swiper"),
      _r17 = _slicedToArray(_r16, 2),
      m = _r17[0],
      f = _r17[1],
      _r18 = r(null),
      _r19 = _slicedToArray(_r18, 2),
      g = _r19[0],
      h = _r19[1],
      _r20 = r(!1),
      _r21 = _slicedToArray(_r20, 2),
      b = _r21[0],
      v = _r21[1],
      w = n(!1),
      y = n(null),
      S = n(null),
      x = n(null),
      E = n(null),
      T = n(null),
      k = n(null),
      A = n(null),
      C = n(null),
      _ref4 = function (e, t) {
        void 0 === e && (e = {}), void 0 === t && (t = !0);
        var r = {
            on: {}
          },
          n = {},
          i = {};
        qe(r, Be), r._emitClasses = !0, r.init = !1;
        var a = {},
          s = He.map(function (e) {
            return e.replace(/_/, "");
          }),
          o = Object.assign({}, e);
        return Object.keys(o).forEach(function (o) {
          void 0 !== e[o] && (s.indexOf(o) >= 0 ? Re(e[o]) ? (r[o] = {}, i[o] = {}, qe(r[o], e[o]), qe(i[o], e[o])) : (r[o] = e[o], i[o] = e[o]) : 0 === o.search(/on[A-Z]/) && "function" == typeof e[o] ? t ? n["".concat(o[2].toLowerCase()).concat(o.substr(3))] = e[o] : r.on["".concat(o[2].toLowerCase()).concat(o.substr(3))] = e[o] : a[o] = e[o]);
        }), ["navigation", "pagination", "scrollbar"].forEach(function (e) {
          !0 === r[e] && (r[e] = {}), !1 === r[e] && delete r[e];
        }), {
          params: r,
          passedParams: i,
          rest: a,
          events: n
        };
      }(p),
      M = _ref4.params,
      P = _ref4.passedParams,
      L = _ref4.rest,
      O = _ref4.events,
      _Je = Je(c),
      I = _Je.slides,
      z = _Je.slots,
      N = function N() {
        v(!b);
      };
    Object.assign(M.on, {
      _containerClasses: function _containerClasses(e, t) {
        f(t);
      }
    });
    var D = function D() {
      Object.assign(M.on, O), u = !0;
      var e = _objectSpread({}, M);
      if (delete e.wrapperClass, S.current = new $e(e), S.current.virtual && S.current.params.virtual.enabled) {
        S.current.virtual.slides = I;
        var _e70 = {
          cache: !1,
          slides: I,
          renderExternal: h,
          renderExternalUpdate: !1
        };
        qe(S.current.params.virtual, _e70), qe(S.current.originalParams.virtual, _e70);
      }
    };
    y.current || D(), S.current && S.current.on("_beforeBreakpoint", N);
    return i(function () {
      return function () {
        S.current && S.current.off("_beforeBreakpoint", N);
      };
    }), i(function () {
      !w.current && S.current && (S.current.emitSlidesClasses(), w.current = !0);
    }), et(function () {
      if (a && (a.current = y.current), y.current) return S.current.destroyed && D(), function (e, t) {
        var r = e.el,
          n = e.nextEl,
          i = e.prevEl,
          a = e.paginationEl,
          s = e.scrollbarEl,
          o = e.swiper;
        Ye(t) && n && i && (o.params.navigation.nextEl = n, o.originalParams.navigation.nextEl = n, o.params.navigation.prevEl = i, o.originalParams.navigation.prevEl = i), Ve(t) && a && (o.params.pagination.el = a, o.originalParams.pagination.el = a), We(t) && s && (o.params.scrollbar.el = s, o.originalParams.scrollbar.el = s), o.init(r);
      }({
        el: y.current,
        nextEl: T.current,
        prevEl: k.current,
        paginationEl: A.current,
        scrollbarEl: C.current,
        swiper: S.current
      }, M), d && !S.current.destroyed && d(S.current), function () {
        S.current && !S.current.destroyed && S.current.destroy(!0, !1);
      };
    }, []), et(function () {
      !u && O && S.current && Object.keys(O).forEach(function (e) {
        S.current.on(e, O[e]);
      });
      var e = function (e, t, r, n, i) {
        var a = [];
        if (!t) return a;
        var s = function s(e) {
          a.indexOf(e) < 0 && a.push(e);
        };
        if (r && n) {
          var _e71 = n.map(i),
            _t31 = r.map(i);
          _e71.join("") !== _t31.join("") && s("children"), n.length !== r.length && s("children");
        }
        return He.filter(function (e) {
          return "_" === e[0];
        }).map(function (e) {
          return e.replace(/_/, "");
        }).forEach(function (r) {
          if (r in e && r in t) if (Re(e[r]) && Re(t[r])) {
            var _n20 = Object.keys(e[r]),
              _i10 = Object.keys(t[r]);
            _n20.length !== _i10.length ? s(r) : (_n20.forEach(function (n) {
              e[r][n] !== t[r][n] && s(r);
            }), _i10.forEach(function (n) {
              e[r][n] !== t[r][n] && s(r);
            }));
          } else e[r] !== t[r] && s(r);
        }), a;
      }(P, x.current, I, E.current, function (e) {
        return e.key;
      });
      return x.current = P, E.current = I, e.length && S.current && !S.current.destroyed && function (e) {
        var t = e.swiper,
          r = e.slides,
          n = e.passedParams,
          i = e.changedParams,
          a = e.nextEl,
          s = e.prevEl,
          o = e.scrollbarEl,
          l = e.paginationEl;
        var c = i.filter(function (e) {
            return "children" !== e && "direction" !== e && "wrapperClass" !== e;
          }),
          d = t.params,
          p = t.pagination,
          u = t.navigation,
          m = t.scrollbar,
          f = t.virtual,
          g = t.thumbs;
        var h, b, v, w, y, S, x, E;
        i.includes("thumbs") && n.thumbs && n.thumbs.swiper && !n.thumbs.swiper.destroyed && d.thumbs && (!d.thumbs.swiper || d.thumbs.swiper.destroyed) && (h = !0), i.includes("controller") && n.controller && n.controller.control && d.controller && !d.controller.control && (b = !0), i.includes("pagination") && n.pagination && (n.pagination.el || l) && (d.pagination || !1 === d.pagination) && p && !p.el && (v = !0), i.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || o) && (d.scrollbar || !1 === d.scrollbar) && m && !m.el && (w = !0), i.includes("navigation") && n.navigation && (n.navigation.prevEl || s) && (n.navigation.nextEl || a) && (d.navigation || !1 === d.navigation) && u && !u.prevEl && !u.nextEl && (y = !0);
        var T = function T(e) {
          t[e] && (t[e].destroy(), "navigation" === e ? (t.isElement && (t[e].prevEl.remove(), t[e].nextEl.remove()), d[e].prevEl = void 0, d[e].nextEl = void 0, t[e].prevEl = void 0, t[e].nextEl = void 0) : (t.isElement && t[e].el.remove(), d[e].el = void 0, t[e].el = void 0));
        };
        i.includes("loop") && t.isElement && (d.loop && !n.loop ? S = !0 : !d.loop && n.loop ? x = !0 : E = !0), c.forEach(function (e) {
          if (Re(d[e]) && Re(n[e])) Object.assign(d[e], n[e]), "navigation" !== e && "pagination" !== e && "scrollbar" !== e || !("enabled" in n[e]) || n[e].enabled || T(e);else {
            var _t32 = n[e];
            !0 !== _t32 && !1 !== _t32 || "navigation" !== e && "pagination" !== e && "scrollbar" !== e ? d[e] = n[e] : !1 === _t32 && T(e);
          }
        }), c.includes("controller") && !b && t.controller && t.controller.control && d.controller && d.controller.control && (t.controller.control = d.controller.control), i.includes("children") && r && f && d.virtual.enabled ? (f.slides = r, f.update(!0)) : i.includes("virtual") && f && d.virtual.enabled && (r && (f.slides = r), f.update(!0)), i.includes("children") && r && d.loop && (E = !0), h && g.init() && g.update(!0);
        b && (t.controller.control = d.controller.control), v && (!t.isElement || l && "string" != typeof l || (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), t.el.appendChild(l)), l && (d.pagination.el = l), p.init(), p.render(), p.update()), w && (!t.isElement || o && "string" != typeof o || (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), t.el.appendChild(o)), o && (d.scrollbar.el = o), m.init(), m.updateSize(), m.setTranslate()), y && (t.isElement && (a && "string" != typeof a || (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = t.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), t.el.appendChild(a)), s && "string" != typeof s || (s = document.createElement("div"), s.classList.add("swiper-button-prev"), s.innerHTML = t.hostEl.constructor.prevButtonSvg, s.part.add("button-prev"), t.el.appendChild(s))), a && (d.navigation.nextEl = a), s && (d.navigation.prevEl = s), u.init(), u.update()), i.includes("allowSlideNext") && (t.allowSlideNext = n.allowSlideNext), i.includes("allowSlidePrev") && (t.allowSlidePrev = n.allowSlidePrev), i.includes("direction") && t.changeDirection(n.direction, !1), (S || E) && t.loopDestroy(), (x || E) && t.loopCreate(), t.update();
      }({
        swiper: S.current,
        slides: I,
        passedParams: P,
        changedParams: e,
        nextEl: T.current,
        prevEl: k.current,
        scrollbarEl: C.current,
        paginationEl: A.current
      }), function () {
        O && S.current && Object.keys(O).forEach(function (e) {
          S.current.off(e, O[e]);
        });
      };
    }), et(function () {
      var e;
      !(e = S.current) || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
    }, [g]), /*#__PURE__*/e.createElement(o, Xe({
      ref: y,
      className: Ke("".concat(m).concat(s ? " ".concat(s) : ""))
    }, L), /*#__PURE__*/e.createElement(rt.Provider, {
      value: S.current
    }, z["container-start"], /*#__PURE__*/e.createElement(l, {
      className: Ue(M.wrapperClass)
    }, z["wrapper-start"], M.virtual ? function (t, r, n) {
      if (!n) return null;
      var i = function i(e) {
          var t = e;
          return e < 0 ? t = r.length + e : t >= r.length && (t -= r.length), t;
        },
        a = t.isHorizontal() ? _defineProperty({}, t.rtlTranslate ? "right" : "left", "".concat(n.offset, "px")) : {
          top: "".concat(n.offset, "px")
        },
        s = n.from,
        o = n.to,
        l = t.params.loop ? -r.length : 0,
        c = t.params.loop ? 2 * r.length : r.length,
        d = [];
      for (var _e72 = l; _e72 < c; _e72 += 1) _e72 >= s && _e72 <= o && d.push(r[i(_e72)]);
      return d.map(function (r, n) {
        return /*#__PURE__*/e.cloneElement(r, {
          swiper: t,
          style: a,
          key: r.props.virtualIndex || r.key || "slide-".concat(n)
        });
      });
    }(S.current, I, g) : I.map(function (t, r) {
      return /*#__PURE__*/e.cloneElement(t, {
        swiper: S.current,
        swiperSlideIndex: r
      });
    }), z["wrapper-end"]), Ye(M) && /*#__PURE__*/e.createElement(e.Fragment, null, /*#__PURE__*/e.createElement("div", {
      ref: k,
      className: "swiper-button-prev"
    }), /*#__PURE__*/e.createElement("div", {
      ref: T,
      className: "swiper-button-next"
    })), We(M) && /*#__PURE__*/e.createElement("div", {
      ref: C,
      className: "swiper-scrollbar"
    }), Ve(M) && /*#__PURE__*/e.createElement("div", {
      ref: A,
      className: "swiper-pagination"
    }), z["container-end"]));
  });
nt.displayName = "Swiper";
var it = /*#__PURE__*/t(function (t, i) {
  var _ref6 = void 0 === t ? {} : t,
    _ref6$tag = _ref6.tag,
    a = _ref6$tag === void 0 ? "div" : _ref6$tag,
    s = _ref6.children,
    _ref6$className = _ref6.className,
    o = _ref6$className === void 0 ? "" : _ref6$className,
    l = _ref6.swiper,
    c = _ref6.zoom,
    d = _ref6.lazy,
    p = _ref6.virtualIndex,
    u = _ref6.swiperSlideIndex,
    m = _objectWithoutProperties(_ref6, _excluded2);
  var f = n(null),
    _r22 = r("swiper-slide"),
    _r23 = _slicedToArray(_r22, 2),
    g = _r23[0],
    h = _r23[1],
    _r24 = r(!1),
    _r25 = _slicedToArray(_r24, 2),
    b = _r25[0],
    v = _r25[1];
  function w(e, t, r) {
    t === f.current && h(r);
  }
  et(function () {
    if (void 0 !== u && (f.current.swiperSlideIndex = u), i && (i.current = f.current), f.current && l) {
      if (!l.destroyed) return l.on("_slideClass", w), function () {
        l && l.off("_slideClass", w);
      };
      "swiper-slide" !== g && h("swiper-slide");
    }
  }), et(function () {
    l && f.current && !l.destroyed && h(l.getSlideClasses(f.current));
  }, [l]);
  var y = {
      isActive: g.indexOf("swiper-slide-active") >= 0,
      isVisible: g.indexOf("swiper-slide-visible") >= 0,
      isPrev: g.indexOf("swiper-slide-prev") >= 0,
      isNext: g.indexOf("swiper-slide-next") >= 0
    },
    S = function S() {
      return "function" == typeof s ? s(y) : s;
    };
  return /*#__PURE__*/e.createElement(a, Xe({
    ref: f,
    className: Ke("".concat(g).concat(o ? " ".concat(o) : "")),
    "data-swiper-slide-index": p,
    onLoad: function onLoad() {
      v(!0);
    }
  }, m), c && /*#__PURE__*/e.createElement(tt.Provider, {
    value: y
  }, /*#__PURE__*/e.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": "number" == typeof c ? c : void 0
  }, S(), d && !b && /*#__PURE__*/e.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !c && /*#__PURE__*/e.createElement(tt.Provider, {
    value: y
  }, S(), d && !b && /*#__PURE__*/e.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
function at(e, t, r, n) {
  return e.params.createElements && Object.keys(n).forEach(function (i) {
    if (!r[i] && !0 === r.auto) {
      var _a7 = ee(e.el, ".".concat(n[i]))[0];
      _a7 || (_a7 = re("div", n[i]), _a7.className = n[i], e.el.append(_a7)), r[i] = _a7, t[i] = _a7;
    }
  }), r;
}
function st(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on,
    i = e.emit;
  function a(e) {
    var r;
    return e && "string" == typeof e && t.isElement && (r = t.el.querySelector(e) || t.hostEl.querySelector(e), r) ? r : (e && ("string" == typeof e && (r = _toConsumableArray(document.querySelectorAll(e))), t.params.uniqueNavElements && "string" == typeof e && r && r.length > 1 && 1 === t.el.querySelectorAll(e).length ? r = t.el.querySelector(e) : r && 1 === r.length && (r = r[0])), e && !r ? e : r);
  }
  function s(e, r) {
    var n = t.params.navigation;
    (e = oe(e)).forEach(function (e) {
      var _e$classList2;
      e && ((_e$classList2 = e.classList)[r ? "add" : "remove"].apply(_e$classList2, _toConsumableArray(n.disabledClass.split(" "))), "BUTTON" === e.tagName && (e.disabled = r), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](n.lockClass));
    });
  }
  function o() {
    var _t$navigation = t.navigation,
      e = _t$navigation.nextEl,
      r = _t$navigation.prevEl;
    if (t.params.loop) return s(r, !1), void s(e, !1);
    s(r, t.isBeginning && !t.params.rewind), s(e, t.isEnd && !t.params.rewind);
  }
  function l(e) {
    e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), i("navigationPrev"));
  }
  function c(e) {
    e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), i("navigationNext"));
  }
  function d() {
    var e = t.params.navigation;
    if (t.params.navigation = at(t, t.originalParams.navigation, t.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !e.nextEl && !e.prevEl) return;
    var r = a(e.nextEl),
      n = a(e.prevEl);
    Object.assign(t.navigation, {
      nextEl: r,
      prevEl: n
    }), r = oe(r), n = oe(n);
    var i = function i(r, n) {
      var _r$classList2;
      r && r.addEventListener("click", "next" === n ? c : l), !t.enabled && r && (_r$classList2 = r.classList).add.apply(_r$classList2, _toConsumableArray(e.lockClass.split(" ")));
    };
    r.forEach(function (e) {
      return i(e, "next");
    }), n.forEach(function (e) {
      return i(e, "prev");
    });
  }
  function p() {
    var _t$navigation2 = t.navigation,
      e = _t$navigation2.nextEl,
      r = _t$navigation2.prevEl;
    e = oe(e), r = oe(r);
    var n = function n(e, r) {
      var _e$classList3;
      e.removeEventListener("click", "next" === r ? c : l), (_e$classList3 = e.classList).remove.apply(_e$classList3, _toConsumableArray(t.params.navigation.disabledClass.split(" ")));
    };
    e.forEach(function (e) {
      return n(e, "next");
    }), r.forEach(function (e) {
      return n(e, "prev");
    });
  }
  r({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), t.navigation = {
    nextEl: null,
    prevEl: null
  }, n("init", function () {
    !1 === t.params.navigation.enabled ? u() : (d(), o());
  }), n("toEdge fromEdge lock unlock", function () {
    o();
  }), n("destroy", function () {
    p();
  }), n("enable disable", function () {
    var _t$navigation3 = t.navigation,
      e = _t$navigation3.nextEl,
      r = _t$navigation3.prevEl;
    e = oe(e), r = oe(r), t.enabled ? o() : [].concat(_toConsumableArray(e), _toConsumableArray(r)).filter(function (e) {
      return !!e;
    }).forEach(function (e) {
      return e.classList.add(t.params.navigation.lockClass);
    });
  }), n("click", function (e, r) {
    var _t$navigation4 = t.navigation,
      n = _t$navigation4.nextEl,
      a = _t$navigation4.prevEl;
    n = oe(n), a = oe(a);
    var s = r.target;
    var o = a.includes(s) || n.includes(s);
    if (t.isElement && !o) {
      var _e73 = r.path || r.composedPath && r.composedPath();
      _e73 && (o = _e73.find(function (e) {
        return n.includes(e) || a.includes(e);
      }));
    }
    if (t.params.navigation.hideOnClick && !o) {
      if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === s || t.pagination.el.contains(s))) return;
      var _e74;
      n.length ? _e74 = n[0].classList.contains(t.params.navigation.hiddenClass) : a.length && (_e74 = a[0].classList.contains(t.params.navigation.hiddenClass)), i(!0 === _e74 ? "navigationShow" : "navigationHide"), [].concat(_toConsumableArray(n), _toConsumableArray(a)).filter(function (e) {
        return !!e;
      }).forEach(function (e) {
        return e.classList.toggle(t.params.navigation.hiddenClass);
      });
    }
  });
  var u = function u() {
    var _t$el$classList;
    (_t$el$classList = t.el.classList).add.apply(_t$el$classList, _toConsumableArray(t.params.navigation.navigationDisabledClass.split(" "))), p();
  };
  Object.assign(t.navigation, {
    enable: function enable() {
      var _t$el$classList2;
      (_t$el$classList2 = t.el.classList).remove.apply(_t$el$classList2, _toConsumableArray(t.params.navigation.navigationDisabledClass.split(" "))), d(), o();
    },
    disable: u,
    update: o,
    init: d,
    destroy: p
  });
}
function ot(e) {
  return void 0 === e && (e = ""), ".".concat(e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, "."));
}
function lt(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on,
    i = e.emit;
  var a = "swiper-pagination";
  var s;
  r({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(e) {
        return e;
      },
      formatFractionTotal: function formatFractionTotal(e) {
        return e;
      },
      bulletClass: "".concat(a, "-bullet"),
      bulletActiveClass: "".concat(a, "-bullet-active"),
      modifierClass: "".concat(a, "-"),
      currentClass: "".concat(a, "-current"),
      totalClass: "".concat(a, "-total"),
      hiddenClass: "".concat(a, "-hidden"),
      progressbarFillClass: "".concat(a, "-progressbar-fill"),
      progressbarOppositeClass: "".concat(a, "-progressbar-opposite"),
      clickableClass: "".concat(a, "-clickable"),
      lockClass: "".concat(a, "-lock"),
      horizontalClass: "".concat(a, "-horizontal"),
      verticalClass: "".concat(a, "-vertical"),
      paginationDisabledClass: "".concat(a, "-disabled")
    }
  }), t.pagination = {
    el: null,
    bullets: []
  };
  var o = 0;
  function l() {
    return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && 0 === t.pagination.el.length;
  }
  function c(e, r) {
    var n = t.params.pagination.bulletActiveClass;
    e && (e = e[("prev" === r ? "previous" : "next") + "ElementSibling"]) && (e.classList.add("".concat(n, "-").concat(r)), (e = e[("prev" === r ? "previous" : "next") + "ElementSibling"]) && e.classList.add("".concat(n, "-").concat(r, "-").concat(r)));
  }
  function d(e) {
    var r = e.target.closest(ot(t.params.pagination.bulletClass));
    if (!r) return;
    e.preventDefault();
    var n = ie(r) * t.params.slidesPerGroup;
    if (t.params.loop) {
      if (t.realIndex === n) return;
      var _e75 = (i = t.realIndex, a = n, s = t.slides.length, (a %= s) == 1 + (i %= s) ? "next" : a === i - 1 ? "previous" : void 0);
      "next" === _e75 ? t.slideNext() : "previous" === _e75 ? t.slidePrev() : t.slideToLoop(n);
    } else t.slideTo(n);
    var i, a, s;
  }
  function p() {
    var e = t.rtl,
      r = t.params.pagination;
    if (l()) return;
    var n,
      a,
      d = t.pagination.el;
    d = oe(d);
    var p = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
      u = t.params.loop ? Math.ceil(p / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? (a = t.previousRealIndex || 0, n = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : void 0 !== t.snapIndex ? (n = t.snapIndex, a = t.previousSnapIndex) : (a = t.previousIndex || 0, n = t.activeIndex || 0), "bullets" === r.type && t.pagination.bullets && t.pagination.bullets.length > 0) {
      var _i11 = t.pagination.bullets;
      var _l5, _p2, _u2;
      if (r.dynamicBullets && (s = se(_i11[0], t.isHorizontal() ? "width" : "height"), d.forEach(function (e) {
        e.style[t.isHorizontal() ? "width" : "height"] = s * (r.dynamicMainBullets + 4) + "px";
      }), r.dynamicMainBullets > 1 && void 0 !== a && (o += n - (a || 0), o > r.dynamicMainBullets - 1 ? o = r.dynamicMainBullets - 1 : o < 0 && (o = 0)), _l5 = Math.max(n - o, 0), _p2 = _l5 + (Math.min(_i11.length, r.dynamicMainBullets) - 1), _u2 = (_p2 + _l5) / 2), _i11.forEach(function (e) {
        var _e$classList4;
        var t = _toConsumableArray(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(function (e) {
          return "".concat(r.bulletActiveClass).concat(e);
        })).map(function (e) {
          return "string" == typeof e && e.includes(" ") ? e.split(" ") : e;
        }).flat();
        (_e$classList4 = e.classList).remove.apply(_e$classList4, _toConsumableArray(t));
      }), d.length > 1) _i11.forEach(function (e) {
        var _e$classList5, _e$classList6;
        var i = ie(e);
        i === n ? (_e$classList5 = e.classList).add.apply(_e$classList5, _toConsumableArray(r.bulletActiveClass.split(" "))) : t.isElement && e.setAttribute("part", "bullet"), r.dynamicBullets && (i >= _l5 && i <= _p2 && (_e$classList6 = e.classList).add.apply(_e$classList6, _toConsumableArray("".concat(r.bulletActiveClass, "-main").split(" "))), i === _l5 && c(e, "prev"), i === _p2 && c(e, "next"));
      });else {
        var _e76$classList;
        var _e76 = _i11[n];
        if (_e76 && (_e76$classList = _e76.classList).add.apply(_e76$classList, _toConsumableArray(r.bulletActiveClass.split(" "))), t.isElement && _i11.forEach(function (e, t) {
          e.setAttribute("part", t === n ? "bullet-active" : "bullet");
        }), r.dynamicBullets) {
          var _e77 = _i11[_l5],
            _t33 = _i11[_p2];
          for (var _e78 = _l5; _e78 <= _p2; _e78 += 1) {
            var _i11$_e78$classList;
            _i11[_e78] && (_i11$_e78$classList = _i11[_e78].classList).add.apply(_i11$_e78$classList, _toConsumableArray("".concat(r.bulletActiveClass, "-main").split(" ")));
          }
          c(_e77, "prev"), c(_t33, "next");
        }
      }
      if (r.dynamicBullets) {
        var _n21 = Math.min(_i11.length, r.dynamicMainBullets + 4),
          _a8 = (s * _n21 - s) / 2 - _u2 * s,
          _o6 = e ? "right" : "left";
        _i11.forEach(function (e) {
          e.style[t.isHorizontal() ? _o6 : "top"] = "".concat(_a8, "px");
        });
      }
    }
    d.forEach(function (e, a) {
      if ("fraction" === r.type && (e.querySelectorAll(ot(r.currentClass)).forEach(function (e) {
        e.textContent = r.formatFractionCurrent(n + 1);
      }), e.querySelectorAll(ot(r.totalClass)).forEach(function (e) {
        e.textContent = r.formatFractionTotal(u);
      })), "progressbar" === r.type) {
        var _i12;
        _i12 = r.progressbarOpposite ? t.isHorizontal() ? "vertical" : "horizontal" : t.isHorizontal() ? "horizontal" : "vertical";
        var _a9 = (n + 1) / u;
        var _s4 = 1,
          _o7 = 1;
        "horizontal" === _i12 ? _s4 = _a9 : _o7 = _a9, e.querySelectorAll(ot(r.progressbarFillClass)).forEach(function (e) {
          e.style.transform = "translate3d(0,0,0) scaleX(".concat(_s4, ") scaleY(").concat(_o7, ")"), e.style.transitionDuration = "".concat(t.params.speed, "ms");
        });
      }
      "custom" === r.type && r.renderCustom ? (e.innerHTML = r.renderCustom(t, n + 1, u), 0 === a && i("paginationRender", e)) : (0 === a && i("paginationRender", e), i("paginationUpdate", e)), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](r.lockClass);
    });
  }
  function u() {
    var e = t.params.pagination;
    if (l()) return;
    var r = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
    var n = t.pagination.el;
    n = oe(n);
    var a = "";
    if ("bullets" === e.type) {
      var _n22 = t.params.loop ? Math.ceil(r / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && _n22 > r && (_n22 = r);
      for (var _r26 = 0; _r26 < _n22; _r26 += 1) e.renderBullet ? a += e.renderBullet.call(t, _r26, e.bulletClass) : a += "<".concat(e.bulletElement, " ").concat(t.isElement ? 'part="bullet"' : "", " class=\"").concat(e.bulletClass, "\"></").concat(e.bulletElement, ">");
    }
    "fraction" === e.type && (a = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : "<span class=\"".concat(e.currentClass, "\"></span> / <span class=\"").concat(e.totalClass, "\"></span>")), "progressbar" === e.type && (a = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : "<span class=\"".concat(e.progressbarFillClass, "\"></span>")), t.pagination.bullets = [], n.forEach(function (r) {
      var _t$pagination$bullets;
      "custom" !== e.type && (r.innerHTML = a || ""), "bullets" === e.type && (_t$pagination$bullets = t.pagination.bullets).push.apply(_t$pagination$bullets, _toConsumableArray(r.querySelectorAll(ot(e.bulletClass))));
    }), "custom" !== e.type && i("paginationRender", n[0]);
  }
  function m() {
    t.params.pagination = at(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    var e = t.params.pagination;
    if (!e.el) return;
    var r;
    "string" == typeof e.el && t.isElement && (r = t.el.querySelector(e.el)), r || "string" != typeof e.el || (r = _toConsumableArray(document.querySelectorAll(e.el))), r || (r = e.el), r && 0 !== r.length && (t.params.uniqueNavElements && "string" == typeof e.el && Array.isArray(r) && r.length > 1 && (r = _toConsumableArray(t.el.querySelectorAll(e.el)), r.length > 1 && (r = r.find(function (e) {
      return ae(e, ".swiper")[0] === t.el;
    }))), Array.isArray(r) && 1 === r.length && (r = r[0]), Object.assign(t.pagination, {
      el: r
    }), r = oe(r), r.forEach(function (r) {
      var _r$classList3;
      "bullets" === e.type && e.clickable && (_r$classList3 = r.classList).add.apply(_r$classList3, _toConsumableArray((e.clickableClass || "").split(" "))), r.classList.add(e.modifierClass + e.type), r.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass), "bullets" === e.type && e.dynamicBullets && (r.classList.add("".concat(e.modifierClass).concat(e.type, "-dynamic")), o = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && r.classList.add(e.progressbarOppositeClass), e.clickable && r.addEventListener("click", d), t.enabled || r.classList.add(e.lockClass);
    }));
  }
  function f() {
    var e = t.params.pagination;
    if (l()) return;
    var r = t.pagination.el;
    r && (r = oe(r), r.forEach(function (r) {
      var _r$classList4;
      r.classList.remove(e.hiddenClass), r.classList.remove(e.modifierClass + e.type), r.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass), e.clickable && ((_r$classList4 = r.classList).remove.apply(_r$classList4, _toConsumableArray((e.clickableClass || "").split(" "))), r.removeEventListener("click", d));
    })), t.pagination.bullets && t.pagination.bullets.forEach(function (t) {
      var _t$classList;
      return (_t$classList = t.classList).remove.apply(_t$classList, _toConsumableArray(e.bulletActiveClass.split(" ")));
    });
  }
  n("changeDirection", function () {
    if (!t.pagination || !t.pagination.el) return;
    var e = t.params.pagination;
    var r = t.pagination.el;
    r = oe(r), r.forEach(function (r) {
      r.classList.remove(e.horizontalClass, e.verticalClass), r.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
    });
  }), n("init", function () {
    !1 === t.params.pagination.enabled ? g() : (m(), u(), p());
  }), n("activeIndexChange", function () {
    void 0 === t.snapIndex && p();
  }), n("snapIndexChange", function () {
    p();
  }), n("snapGridLengthChange", function () {
    u(), p();
  }), n("destroy", function () {
    f();
  }), n("enable disable", function () {
    var e = t.pagination.el;
    e && (e = oe(e), e.forEach(function (e) {
      return e.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass);
    }));
  }), n("lock unlock", function () {
    p();
  }), n("click", function (e, r) {
    var n = r.target,
      a = oe(t.pagination.el);
    if (t.params.pagination.el && t.params.pagination.hideOnClick && a && a.length > 0 && !n.classList.contains(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && n === t.navigation.nextEl || t.navigation.prevEl && n === t.navigation.prevEl)) return;
      var _e79 = a[0].classList.contains(t.params.pagination.hiddenClass);
      i(!0 === _e79 ? "paginationShow" : "paginationHide"), a.forEach(function (e) {
        return e.classList.toggle(t.params.pagination.hiddenClass);
      });
    }
  });
  var g = function g() {
    t.el.classList.add(t.params.pagination.paginationDisabledClass);
    var e = t.pagination.el;
    e && (e = oe(e), e.forEach(function (e) {
      return e.classList.add(t.params.pagination.paginationDisabledClass);
    })), f();
  };
  Object.assign(t.pagination, {
    enable: function enable() {
      t.el.classList.remove(t.params.pagination.paginationDisabledClass);
      var e = t.pagination.el;
      e && (e = oe(e), e.forEach(function (e) {
        return e.classList.remove(t.params.pagination.paginationDisabledClass);
      })), m(), u(), p();
    },
    disable: g,
    render: u,
    update: p,
    init: m,
    destroy: f
  });
}
function ct(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on,
    i = e.emit;
  var a = H();
  var s,
    o,
    l,
    c,
    d = !1,
    p = null,
    u = null;
  function m() {
    if (!t.params.scrollbar.el || !t.scrollbar.el) return;
    var e = t.scrollbar,
      r = t.rtlTranslate,
      n = e.dragEl,
      i = e.el,
      a = t.params.scrollbar,
      s = t.params.loop ? t.progressLoop : t.progress;
    var c = o,
      d = (l - o) * s;
    r ? (d = -d, d > 0 ? (c = o - d, d = 0) : -d + o > l && (c = l + d)) : d < 0 ? (c = o + d, d = 0) : d + o > l && (c = l - d), t.isHorizontal() ? (n.style.transform = "translate3d(".concat(d, "px, 0, 0)"), n.style.width = "".concat(c, "px")) : (n.style.transform = "translate3d(0px, ".concat(d, "px, 0)"), n.style.height = "".concat(c, "px")), a.hide && (clearTimeout(p), i.style.opacity = 1, p = setTimeout(function () {
      i.style.opacity = 0, i.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function f() {
    if (!t.params.scrollbar.el || !t.scrollbar.el) return;
    var e = t.scrollbar,
      r = e.dragEl,
      n = e.el;
    r.style.width = "", r.style.height = "", l = t.isHorizontal() ? n.offsetWidth : n.offsetHeight, c = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0)), o = "auto" === t.params.scrollbar.dragSize ? l * c : parseInt(t.params.scrollbar.dragSize, 10), t.isHorizontal() ? r.style.width = "".concat(o, "px") : r.style.height = "".concat(o, "px"), n.style.display = c >= 1 ? "none" : "", t.params.scrollbar.hide && (n.style.opacity = 0), t.params.watchOverflow && t.enabled && e.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass);
  }
  function g(e) {
    return t.isHorizontal() ? e.clientX : e.clientY;
  }
  function h(e) {
    var r = t.scrollbar,
      n = t.rtlTranslate,
      i = r.el;
    var a;
    a = (g(e) - function (e) {
      var t = q(),
        r = H(),
        n = e.getBoundingClientRect(),
        i = r.body,
        a = e.clientTop || i.clientTop || 0,
        s = e.clientLeft || i.clientLeft || 0,
        o = e === t ? t.scrollY : e.scrollTop,
        l = e === t ? t.scrollX : e.scrollLeft;
      return {
        top: n.top + o - a,
        left: n.left + l - s
      };
    }(i)[t.isHorizontal() ? "left" : "top"] - (null !== s ? s : o / 2)) / (l - o), a = Math.max(Math.min(a, 1), 0), n && (a = 1 - a);
    var c = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * a;
    t.updateProgress(c), t.setTranslate(c), t.updateActiveIndex(), t.updateSlidesClasses();
  }
  function b(e) {
    var r = t.params.scrollbar,
      n = t.scrollbar,
      a = t.wrapperEl,
      o = n.el,
      l = n.dragEl;
    d = !0, s = e.target === l ? g(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null, e.preventDefault(), e.stopPropagation(), a.style.transitionDuration = "100ms", l.style.transitionDuration = "100ms", h(e), clearTimeout(u), o.style.transitionDuration = "0ms", r.hide && (o.style.opacity = 1), t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"), i("scrollbarDragStart", e);
  }
  function v(e) {
    var r = t.scrollbar,
      n = t.wrapperEl,
      a = r.el,
      s = r.dragEl;
    d && (e.preventDefault && e.cancelable ? e.preventDefault() : e.returnValue = !1, h(e), n.style.transitionDuration = "0ms", a.style.transitionDuration = "0ms", s.style.transitionDuration = "0ms", i("scrollbarDragMove", e));
  }
  function w(e) {
    var r = t.params.scrollbar,
      n = t.scrollbar,
      a = t.wrapperEl,
      s = n.el;
    d && (d = !1, t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "", a.style.transitionDuration = ""), r.hide && (clearTimeout(u), u = V(function () {
      s.style.opacity = 0, s.style.transitionDuration = "400ms";
    }, 1e3)), i("scrollbarDragEnd", e), r.snapOnRelease && t.slideToClosest());
  }
  function y(e) {
    var r = t.scrollbar,
      n = t.params,
      i = r.el;
    if (!i) return;
    var s = i,
      o = !!n.passiveListeners && {
        passive: !1,
        capture: !1
      },
      l = !!n.passiveListeners && {
        passive: !0,
        capture: !1
      };
    if (!s) return;
    var c = "on" === e ? "addEventListener" : "removeEventListener";
    s[c]("pointerdown", b, o), a[c]("pointermove", v, o), a[c]("pointerup", w, l);
  }
  function S() {
    var _i$classList2;
    var e = t.scrollbar,
      r = t.el;
    t.params.scrollbar = at(t, t.originalParams.scrollbar, t.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    var n = t.params.scrollbar;
    if (!n.el) return;
    var i, s;
    if ("string" == typeof n.el && t.isElement && (i = t.el.querySelector(n.el)), i || "string" != typeof n.el) i || (i = n.el);else if (i = a.querySelectorAll(n.el), !i.length) return;
    t.params.uniqueNavElements && "string" == typeof n.el && i.length > 1 && 1 === r.querySelectorAll(n.el).length && (i = r.querySelector(n.el)), i.length > 0 && (i = i[0]), i.classList.add(t.isHorizontal() ? n.horizontalClass : n.verticalClass), i && (s = i.querySelector(ot(t.params.scrollbar.dragClass)), s || (s = re("div", t.params.scrollbar.dragClass), i.append(s))), Object.assign(e, {
      el: i,
      dragEl: s
    }), n.draggable && t.params.scrollbar.el && t.scrollbar.el && y("on"), i && (_i$classList2 = i.classList)[t.enabled ? "remove" : "add"].apply(_i$classList2, _toConsumableArray(Y(t.params.scrollbar.lockClass)));
  }
  function x() {
    var _r$classList5;
    var e = t.params.scrollbar,
      r = t.scrollbar.el;
    r && (_r$classList5 = r.classList).remove.apply(_r$classList5, _toConsumableArray(Y(t.isHorizontal() ? e.horizontalClass : e.verticalClass))), t.params.scrollbar.el && t.scrollbar.el && y("off");
  }
  r({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), t.scrollbar = {
    el: null,
    dragEl: null
  }, n("changeDirection", function () {
    if (!t.scrollbar || !t.scrollbar.el) return;
    var e = t.params.scrollbar;
    var r = t.scrollbar.el;
    r = oe(r), r.forEach(function (r) {
      r.classList.remove(e.horizontalClass, e.verticalClass), r.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
    });
  }), n("init", function () {
    !1 === t.params.scrollbar.enabled ? E() : (S(), f(), m());
  }), n("update resize observerUpdate lock unlock changeDirection", function () {
    f();
  }), n("setTranslate", function () {
    m();
  }), n("setTransition", function (e, r) {
    !function (e) {
      t.params.scrollbar.el && t.scrollbar.el && (t.scrollbar.dragEl.style.transitionDuration = "".concat(e, "ms"));
    }(r);
  }), n("enable disable", function () {
    var _e$classList7;
    var e = t.scrollbar.el;
    e && (_e$classList7 = e.classList)[t.enabled ? "remove" : "add"].apply(_e$classList7, _toConsumableArray(Y(t.params.scrollbar.lockClass)));
  }), n("destroy", function () {
    x();
  });
  var E = function E() {
    var _t$el$classList3, _t$scrollbar$el$class;
    (_t$el$classList3 = t.el.classList).add.apply(_t$el$classList3, _toConsumableArray(Y(t.params.scrollbar.scrollbarDisabledClass))), t.scrollbar.el && (_t$scrollbar$el$class = t.scrollbar.el.classList).add.apply(_t$scrollbar$el$class, _toConsumableArray(Y(t.params.scrollbar.scrollbarDisabledClass))), x();
  };
  Object.assign(t.scrollbar, {
    enable: function enable() {
      var _t$el$classList4, _t$scrollbar$el$class2;
      (_t$el$classList4 = t.el.classList).remove.apply(_t$el$classList4, _toConsumableArray(Y(t.params.scrollbar.scrollbarDisabledClass))), t.scrollbar.el && (_t$scrollbar$el$class2 = t.scrollbar.el.classList).remove.apply(_t$scrollbar$el$class2, _toConsumableArray(Y(t.params.scrollbar.scrollbarDisabledClass))), S(), f(), m();
    },
    disable: E,
    updateSize: f,
    setTranslate: m,
    init: S,
    destroy: x
  });
}
function dt(e) {
  var t,
    r,
    n = e.swiper,
    i = e.extendParams,
    a = e.on,
    s = e.emit,
    o = e.params;
  n.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, i({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  var l,
    c,
    d,
    p,
    u,
    m,
    f,
    g,
    h = o && o.autoplay ? o.autoplay.delay : 3e3,
    b = o && o.autoplay ? o.autoplay.delay : 3e3,
    v = new Date().getTime();
  function w(e) {
    n && !n.destroyed && n.wrapperEl && e.target === n.wrapperEl && (n.wrapperEl.removeEventListener("transitionend", w), g || e.detail && e.detail.bySwiperTouchMove || k());
  }
  var y = function y() {
      if (n.destroyed || !n.autoplay.running) return;
      n.autoplay.paused ? c = !0 : c && (b = l, c = !1);
      var e = n.autoplay.paused ? l : v + b - new Date().getTime();
      n.autoplay.timeLeft = e, s("autoplayTimeLeft", e, e / h), r = requestAnimationFrame(function () {
        y();
      });
    },
    S = function S(e) {
      if (n.destroyed || !n.autoplay.running) return;
      cancelAnimationFrame(r), y();
      var i = void 0 === e ? n.params.autoplay.delay : e;
      h = n.params.autoplay.delay, b = n.params.autoplay.delay;
      var a = function () {
        var e;
        if (e = n.virtual && n.params.virtual.enabled ? n.slides.find(function (e) {
          return e.classList.contains("swiper-slide-active");
        }) : n.slides[n.activeIndex], !e) return;
        return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
      }();
      !Number.isNaN(a) && a > 0 && void 0 === e && (i = a, h = a, b = a), l = i;
      var o = n.params.speed,
        c = function c() {
          n && !n.destroyed && (n.params.autoplay.reverseDirection ? !n.isBeginning || n.params.loop || n.params.rewind ? (n.slidePrev(o, !0, !0), s("autoplay")) : n.params.autoplay.stopOnLastSlide || (n.slideTo(n.slides.length - 1, o, !0, !0), s("autoplay")) : !n.isEnd || n.params.loop || n.params.rewind ? (n.slideNext(o, !0, !0), s("autoplay")) : n.params.autoplay.stopOnLastSlide || (n.slideTo(0, o, !0, !0), s("autoplay")), n.params.cssMode && (v = new Date().getTime(), requestAnimationFrame(function () {
            S();
          })));
        };
      return i > 0 ? (clearTimeout(t), t = setTimeout(function () {
        c();
      }, i)) : requestAnimationFrame(function () {
        c();
      }), i;
    },
    x = function x() {
      v = new Date().getTime(), n.autoplay.running = !0, S(), s("autoplayStart");
    },
    E = function E() {
      n.autoplay.running = !1, clearTimeout(t), cancelAnimationFrame(r), s("autoplayStop");
    },
    T = function T(e, r) {
      if (n.destroyed || !n.autoplay.running) return;
      clearTimeout(t), e || (f = !0);
      var i = function i() {
        s("autoplayPause"), n.params.autoplay.waitForTransition ? n.wrapperEl.addEventListener("transitionend", w) : k();
      };
      if (n.autoplay.paused = !0, r) return m && (l = n.params.autoplay.delay), m = !1, void i();
      var a = l || n.params.autoplay.delay;
      l = a - (new Date().getTime() - v), n.isEnd && l < 0 && !n.params.loop || (l < 0 && (l = 0), i());
    },
    k = function k() {
      n.isEnd && l < 0 && !n.params.loop || n.destroyed || !n.autoplay.running || (v = new Date().getTime(), f ? (f = !1, S(l)) : S(), n.autoplay.paused = !1, s("autoplayResume"));
    },
    A = function A() {
      if (n.destroyed || !n.autoplay.running) return;
      var e = H();
      "hidden" === e.visibilityState && (f = !0, T(!0)), "visible" === e.visibilityState && k();
    },
    C = function C(e) {
      "mouse" === e.pointerType && (f = !0, g = !0, n.animating || n.autoplay.paused || T(!0));
    },
    M = function M(e) {
      "mouse" === e.pointerType && (g = !1, n.autoplay.paused && k());
    };
  a("init", function () {
    n.params.autoplay.enabled && (n.params.autoplay.pauseOnMouseEnter && (n.el.addEventListener("pointerenter", C), n.el.addEventListener("pointerleave", M)), H().addEventListener("visibilitychange", A), x());
  }), a("destroy", function () {
    n.el && "string" != typeof n.el && (n.el.removeEventListener("pointerenter", C), n.el.removeEventListener("pointerleave", M)), H().removeEventListener("visibilitychange", A), n.autoplay.running && E();
  }), a("_freeModeStaticRelease", function () {
    (p || f) && k();
  }), a("_freeModeNoMomentumRelease", function () {
    n.params.autoplay.disableOnInteraction ? E() : T(!0, !0);
  }), a("beforeTransitionStart", function (e, t, r) {
    !n.destroyed && n.autoplay.running && (r || !n.params.autoplay.disableOnInteraction ? T(!0, !0) : E());
  }), a("sliderFirstMove", function () {
    !n.destroyed && n.autoplay.running && (n.params.autoplay.disableOnInteraction ? E() : (d = !0, p = !1, f = !1, u = setTimeout(function () {
      f = !0, p = !0, T(!0);
    }, 200)));
  }), a("touchEnd", function () {
    if (!n.destroyed && n.autoplay.running && d) {
      if (clearTimeout(u), clearTimeout(t), n.params.autoplay.disableOnInteraction) return p = !1, void (d = !1);
      p && n.params.cssMode && k(), p = !1, d = !1;
    }
  }), a("slideChange", function () {
    !n.destroyed && n.autoplay.running && (m = !0);
  }), Object.assign(n.autoplay, {
    start: x,
    stop: E,
    pause: T,
    resume: k
  });
}
function pt(e) {
  var t = e.effect,
    r = e.swiper,
    n = e.on,
    i = e.setTranslate,
    a = e.setTransition,
    s = e.overwriteParams,
    o = e.perspective,
    l = e.recreateShadows,
    c = e.getEffectParams;
  var d;
  n("beforeInit", function () {
    if (r.params.effect !== t) return;
    r.classNames.push("".concat(r.params.containerModifierClass).concat(t)), o && o() && r.classNames.push("".concat(r.params.containerModifierClass, "3d"));
    var e = s ? s() : {};
    Object.assign(r.params, e), Object.assign(r.originalParams, e);
  }), n("setTranslate", function () {
    r.params.effect === t && i();
  }), n("setTransition", function (e, n) {
    r.params.effect === t && a(n);
  }), n("transitionEnd", function () {
    if (r.params.effect === t && l) {
      if (!c || !c().slideShadows) return;
      r.slides.forEach(function (e) {
        e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (e) {
          return e.remove();
        });
      }), l();
    }
  }), n("virtualUpdate", function () {
    r.params.effect === t && (r.slides.length || (d = !0), requestAnimationFrame(function () {
      d && r.slides && r.slides.length && (i(), d = !1);
    }));
  });
}
function ut(e, t) {
  var r = J(t);
  return r !== t && (r.style.backfaceVisibility = "hidden", r.style["-webkit-backface-visibility"] = "hidden"), r;
}
function mt(e) {
  var t = e.swiper,
    r = e.duration,
    n = e.transformElements,
    i = e.allSlides;
  var a = t.activeIndex;
  if (t.params.virtualTranslate && 0 !== r) {
    var _e80,
      _r27 = !1;
    _e80 = i ? n : n.filter(function (e) {
      var r = e.classList.contains("swiper-slide-transform") ? function (e) {
        if (!e.parentElement) return t.slides.find(function (t) {
          return t.shadowRoot && t.shadowRoot === e.parentNode;
        });
        return e.parentElement;
      }(e) : e;
      return t.getSlideIndex(r) === a;
    }), _e80.forEach(function (e) {
      !function (e, t) {
        e.addEventListener("transitionend", function r(n) {
          n.target === e && (t.call(e, n), e.removeEventListener("transitionend", r));
        });
      }(e, function () {
        if (_r27) return;
        if (!t || t.destroyed) return;
        _r27 = !0, t.animating = !1;
        var e = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        t.wrapperEl.dispatchEvent(e);
      });
    });
  }
}
function ft(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on;
  r({
    fadeEffect: {
      crossFade: !1
    }
  });
  pt({
    effect: "fade",
    swiper: t,
    on: n,
    setTranslate: function setTranslate() {
      var e = t.slides;
      t.params.fadeEffect;
      for (var _r28 = 0; _r28 < e.length; _r28 += 1) {
        var _e81 = t.slides[_r28];
        var _n23 = -_e81.swiperSlideOffset;
        t.params.virtualTranslate || (_n23 -= t.translate);
        var _i13 = 0;
        t.isHorizontal() || (_i13 = _n23, _n23 = 0);
        var _a10 = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(_e81.progress), 0) : 1 + Math.min(Math.max(_e81.progress, -1), 0),
          _s5 = ut(0, _e81);
        _s5.style.opacity = _a10, _s5.style.transform = "translate3d(".concat(_n23, "px, ").concat(_i13, "px, 0px)");
      }
    },
    setTransition: function setTransition(e) {
      var r = t.slides.map(function (e) {
        return J(e);
      });
      r.forEach(function (t) {
        t.style.transitionDuration = "".concat(e, "ms");
      }), mt({
        swiper: t,
        duration: e,
        transformElements: r,
        allSlides: !0
      });
    },
    overwriteParams: function overwriteParams() {
      return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !t.params.cssMode
      };
    }
  });
}
function gt(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on;
  r({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: .94
    }
  });
  var i = function i(e, t, r) {
    var n = r ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
      i = r ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
    n || (n = re("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (r ? "left" : "top")).split(" ")), e.append(n)), i || (i = re("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (r ? "right" : "bottom")).split(" ")), e.append(i)), n && (n.style.opacity = Math.max(-t, 0)), i && (i.style.opacity = Math.max(t, 0));
  };
  pt({
    effect: "cube",
    swiper: t,
    on: n,
    setTranslate: function setTranslate() {
      var e = t.el,
        r = t.wrapperEl,
        n = t.slides,
        a = t.width,
        s = t.height,
        o = t.rtlTranslate,
        l = t.size,
        c = t.browser,
        d = le(t),
        p = t.params.cubeEffect,
        u = t.isHorizontal(),
        m = t.virtual && t.params.virtual.enabled;
      var f,
        g = 0;
      p.shadow && (u ? (f = t.wrapperEl.querySelector(".swiper-cube-shadow"), f || (f = re("div", "swiper-cube-shadow"), t.wrapperEl.append(f)), f.style.height = "".concat(a, "px")) : (f = e.querySelector(".swiper-cube-shadow"), f || (f = re("div", "swiper-cube-shadow"), e.append(f))));
      for (var _e82 = 0; _e82 < n.length; _e82 += 1) {
        var _t34 = n[_e82];
        var _r29 = _e82;
        m && (_r29 = parseInt(_t34.getAttribute("data-swiper-slide-index"), 10));
        var _a11 = 90 * _r29,
          _s6 = Math.floor(_a11 / 360);
        o && (_a11 = -_a11, _s6 = Math.floor(-_a11 / 360));
        var _c2 = Math.max(Math.min(_t34.progress, 1), -1);
        var _f2 = 0,
          _h = 0,
          _b = 0;
        _r29 % 4 == 0 ? (_f2 = 4 * -_s6 * l, _b = 0) : (_r29 - 1) % 4 == 0 ? (_f2 = 0, _b = 4 * -_s6 * l) : (_r29 - 2) % 4 == 0 ? (_f2 = l + 4 * _s6 * l, _b = l) : (_r29 - 3) % 4 == 0 && (_f2 = -l, _b = 3 * l + 4 * l * _s6), o && (_f2 = -_f2), u || (_h = _f2, _f2 = 0);
        var _v = "rotateX(".concat(d(u ? 0 : -_a11), "deg) rotateY(").concat(d(u ? _a11 : 0), "deg) translate3d(").concat(_f2, "px, ").concat(_h, "px, ").concat(_b, "px)");
        _c2 <= 1 && _c2 > -1 && (g = 90 * _r29 + 90 * _c2, o && (g = 90 * -_r29 - 90 * _c2)), _t34.style.transform = _v, p.slideShadows && i(_t34, _c2, u);
      }
      if (r.style.transformOrigin = "50% 50% -".concat(l / 2, "px"), r.style["-webkit-transform-origin"] = "50% 50% -".concat(l / 2, "px"), p.shadow) if (u) f.style.transform = "translate3d(0px, ".concat(a / 2 + p.shadowOffset, "px, ").concat(-a / 2, "px) rotateX(89.99deg) rotateZ(0deg) scale(").concat(p.shadowScale, ")");else {
        var _e83 = Math.abs(g) - 90 * Math.floor(Math.abs(g) / 90),
          _t35 = 1.5 - (Math.sin(2 * _e83 * Math.PI / 360) / 2 + Math.cos(2 * _e83 * Math.PI / 360) / 2),
          _r30 = p.shadowScale,
          _n24 = p.shadowScale / _t35,
          _i14 = p.shadowOffset;
        f.style.transform = "scale3d(".concat(_r30, ", 1, ").concat(_n24, ") translate3d(0px, ").concat(s / 2 + _i14, "px, ").concat(-s / 2 / _n24, "px) rotateX(-89.99deg)");
      }
      var h = (c.isSafari || c.isWebView) && c.needPerspectiveFix ? -l / 2 : 0;
      r.style.transform = "translate3d(0px,0,".concat(h, "px) rotateX(").concat(d(t.isHorizontal() ? 0 : g), "deg) rotateY(").concat(d(t.isHorizontal() ? -g : 0), "deg)"), r.style.setProperty("--swiper-cube-translate-z", "".concat(h, "px"));
    },
    setTransition: function setTransition(e) {
      var r = t.el,
        n = t.slides;
      if (n.forEach(function (t) {
        t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (t) {
          t.style.transitionDuration = "".concat(e, "ms");
        });
      }), t.params.cubeEffect.shadow && !t.isHorizontal()) {
        var _t36 = r.querySelector(".swiper-cube-shadow");
        _t36 && (_t36.style.transitionDuration = "".concat(e, "ms"));
      }
    },
    recreateShadows: function recreateShadows() {
      var e = t.isHorizontal();
      t.slides.forEach(function (t) {
        var r = Math.max(Math.min(t.progress, 1), -1);
        i(t, r, e);
      });
    },
    getEffectParams: function getEffectParams() {
      return t.params.cubeEffect;
    },
    perspective: function perspective() {
      return !0;
    },
    overwriteParams: function overwriteParams() {
      return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: !1,
        virtualTranslate: !0
      };
    }
  });
}
function ht(e, t, r) {
  var n = "swiper-slide-shadow".concat(r ? "-".concat(r) : "").concat(e ? " swiper-slide-shadow-".concat(e) : ""),
    i = J(t);
  var a = i.querySelector(".".concat(n.split(" ").join(".")));
  return a || (a = re("div", n.split(" ")), i.append(a)), a;
}
function bt(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on;
  r({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  var i = function i(e, r) {
    var n = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
      i = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
    n || (n = ht("flip", e, t.isHorizontal() ? "left" : "top")), i || (i = ht("flip", e, t.isHorizontal() ? "right" : "bottom")), n && (n.style.opacity = Math.max(-r, 0)), i && (i.style.opacity = Math.max(r, 0));
  };
  pt({
    effect: "flip",
    swiper: t,
    on: n,
    setTranslate: function setTranslate() {
      var e = t.slides,
        r = t.rtlTranslate,
        n = t.params.flipEffect,
        a = le(t);
      for (var _s7 = 0; _s7 < e.length; _s7 += 1) {
        var _o8 = e[_s7];
        var _l6 = _o8.progress;
        t.params.flipEffect.limitRotation && (_l6 = Math.max(Math.min(_o8.progress, 1), -1));
        var _c3 = _o8.swiperSlideOffset;
        var _d2 = -180 * _l6,
          _p3 = 0,
          _u3 = t.params.cssMode ? -_c3 - t.translate : -_c3,
          _m2 = 0;
        t.isHorizontal() ? r && (_d2 = -_d2) : (_m2 = _u3, _u3 = 0, _p3 = -_d2, _d2 = 0), _o8.style.zIndex = -Math.abs(Math.round(_l6)) + e.length, n.slideShadows && i(_o8, _l6);
        var _f3 = "translate3d(".concat(_u3, "px, ").concat(_m2, "px, 0px) rotateX(").concat(a(_p3), "deg) rotateY(").concat(a(_d2), "deg)");
        ut(0, _o8).style.transform = _f3;
      }
    },
    setTransition: function setTransition(e) {
      var r = t.slides.map(function (e) {
        return J(e);
      });
      r.forEach(function (t) {
        t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (t) {
          t.style.transitionDuration = "".concat(e, "ms");
        });
      }), mt({
        swiper: t,
        duration: e,
        transformElements: r
      });
    },
    recreateShadows: function recreateShadows() {
      t.params.flipEffect, t.slides.forEach(function (e) {
        var r = e.progress;
        t.params.flipEffect.limitRotation && (r = Math.max(Math.min(e.progress, 1), -1)), i(e, r);
      });
    },
    getEffectParams: function getEffectParams() {
      return t.params.flipEffect;
    },
    perspective: function perspective() {
      return !0;
    },
    overwriteParams: function overwriteParams() {
      return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !t.params.cssMode
      };
    }
  });
}
function vt(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on;
  r({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  });
  pt({
    effect: "coverflow",
    swiper: t,
    on: n,
    setTranslate: function setTranslate() {
      var e = t.width,
        r = t.height,
        n = t.slides,
        i = t.slidesSizesGrid,
        a = t.params.coverflowEffect,
        s = t.isHorizontal(),
        o = t.translate,
        l = s ? e / 2 - o : r / 2 - o,
        c = s ? a.rotate : -a.rotate,
        d = a.depth,
        p = le(t);
      for (var _e84 = 0, _t37 = n.length; _e84 < _t37; _e84 += 1) {
        var _t38 = n[_e84],
          _r31 = i[_e84],
          _o9 = (l - _t38.swiperSlideOffset - _r31 / 2) / _r31,
          _u4 = "function" == typeof a.modifier ? a.modifier(_o9) : _o9 * a.modifier;
        var _m3 = s ? c * _u4 : 0,
          _f4 = s ? 0 : c * _u4,
          _g2 = -d * Math.abs(_u4),
          _h2 = a.stretch;
        "string" == typeof _h2 && -1 !== _h2.indexOf("%") && (_h2 = parseFloat(a.stretch) / 100 * _r31);
        var _b2 = s ? 0 : _h2 * _u4,
          _v2 = s ? _h2 * _u4 : 0,
          _w = 1 - (1 - a.scale) * Math.abs(_u4);
        Math.abs(_v2) < .001 && (_v2 = 0), Math.abs(_b2) < .001 && (_b2 = 0), Math.abs(_g2) < .001 && (_g2 = 0), Math.abs(_m3) < .001 && (_m3 = 0), Math.abs(_f4) < .001 && (_f4 = 0), Math.abs(_w) < .001 && (_w = 0);
        var _y = "translate3d(".concat(_v2, "px,").concat(_b2, "px,").concat(_g2, "px)  rotateX(").concat(p(_f4), "deg) rotateY(").concat(p(_m3), "deg) scale(").concat(_w, ")");
        if (ut(0, _t38).style.transform = _y, _t38.style.zIndex = 1 - Math.abs(Math.round(_u4)), a.slideShadows) {
          var _e85 = s ? _t38.querySelector(".swiper-slide-shadow-left") : _t38.querySelector(".swiper-slide-shadow-top"),
            _r32 = s ? _t38.querySelector(".swiper-slide-shadow-right") : _t38.querySelector(".swiper-slide-shadow-bottom");
          _e85 || (_e85 = ht("coverflow", _t38, s ? "left" : "top")), _r32 || (_r32 = ht("coverflow", _t38, s ? "right" : "bottom")), _e85 && (_e85.style.opacity = _u4 > 0 ? _u4 : 0), _r32 && (_r32.style.opacity = -_u4 > 0 ? -_u4 : 0);
        }
      }
    },
    setTransition: function setTransition(e) {
      t.slides.map(function (e) {
        return J(e);
      }).forEach(function (t) {
        t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (t) {
          t.style.transitionDuration = "".concat(e, "ms");
        });
      });
    },
    perspective: function perspective() {
      return !0;
    },
    overwriteParams: function overwriteParams() {
      return {
        watchSlidesProgress: !0
      };
    }
  });
}
function wt(e) {
  var t = e.swiper,
    r = e.extendParams,
    n = e.on;
  r({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });
  pt({
    effect: "cards",
    swiper: t,
    on: n,
    setTranslate: function setTranslate() {
      var e = t.slides,
        r = t.activeIndex,
        n = t.rtlTranslate,
        i = t.params.cardsEffect,
        _t$touchEventsData = t.touchEventsData,
        a = _t$touchEventsData.startTranslate,
        s = _t$touchEventsData.isTouched,
        o = n ? -t.translate : t.translate;
      for (var _l7 = 0; _l7 < e.length; _l7 += 1) {
        var _c4 = e[_l7],
          _d3 = _c4.progress,
          _p4 = Math.min(Math.max(_d3, -4), 4);
        var _u5 = _c4.swiperSlideOffset;
        t.params.centeredSlides && !t.params.cssMode && (t.wrapperEl.style.transform = "translateX(".concat(t.minTranslate(), "px)")), t.params.centeredSlides && t.params.cssMode && (_u5 -= e[0].swiperSlideOffset);
        var _m4 = t.params.cssMode ? -_u5 - t.translate : -_u5,
          _f5 = 0;
        var _g3 = -100 * Math.abs(_p4);
        var _h3 = 1,
          _b3 = -i.perSlideRotate * _p4,
          _v3 = i.perSlideOffset - .75 * Math.abs(_p4);
        var _w2 = t.virtual && t.params.virtual.enabled ? t.virtual.from + _l7 : _l7,
          _y2 = (_w2 === r || _w2 === r - 1) && _p4 > 0 && _p4 < 1 && (s || t.params.cssMode) && o < a,
          _S = (_w2 === r || _w2 === r + 1) && _p4 < 0 && _p4 > -1 && (s || t.params.cssMode) && o > a;
        if (_y2 || _S) {
          var _e86 = Math.pow(1 - Math.abs((Math.abs(_p4) - .5) / .5), .5);
          _b3 += -28 * _p4 * _e86, _h3 += -.5 * _e86, _v3 += 96 * _e86, _f5 = -25 * _e86 * Math.abs(_p4) + "%";
        }
        if (_m4 = _p4 < 0 ? "calc(".concat(_m4, "px ").concat(n ? "-" : "+", " (").concat(_v3 * Math.abs(_p4), "%))") : _p4 > 0 ? "calc(".concat(_m4, "px ").concat(n ? "-" : "+", " (-").concat(_v3 * Math.abs(_p4), "%))") : "".concat(_m4, "px"), !t.isHorizontal()) {
          var _e87 = _f5;
          _f5 = _m4, _m4 = _e87;
        }
        var _x = _p4 < 0 ? "" + (1 + (1 - _h3) * _p4) : "" + (1 - (1 - _h3) * _p4),
          _E = "\n        translate3d(".concat(_m4, ", ").concat(_f5, ", ").concat(_g3, "px)\n        rotateZ(").concat(i.rotate ? n ? -_b3 : _b3 : 0, "deg)\n        scale(").concat(_x, ")\n      ");
        if (i.slideShadows) {
          var _e88 = _c4.querySelector(".swiper-slide-shadow");
          _e88 || (_e88 = ht("cards", _c4)), _e88 && (_e88.style.opacity = Math.min(Math.max((Math.abs(_p4) - .5) / .5, 0), 1));
        }
        _c4.style.zIndex = -Math.abs(Math.round(_d3)) + e.length;
        ut(0, _c4).style.transform = _E;
      }
    },
    setTransition: function setTransition(e) {
      var r = t.slides.map(function (e) {
        return J(e);
      });
      r.forEach(function (t) {
        t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow").forEach(function (t) {
          t.style.transitionDuration = "".concat(e, "ms");
        });
      }), mt({
        swiper: t,
        duration: e,
        transformElements: r
      });
    },
    perspective: function perspective() {
      return !0;
    },
    overwriteParams: function overwriteParams() {
      return {
        watchSlidesProgress: !0,
        virtualTranslate: !t.params.cssMode
      };
    }
  });
}
it.displayName = "SwiperSlide";
C("/**\n * Swiper 11.2.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2025 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: January 10, 2025\n */\n\n/* FONT_START */\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, 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');\n  font-weight: 400;\n  font-style: normal;\n}\n/* FONT_END */\n:root {\n  --swiper-theme-color: #007aff;\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  --swiper-wrapper-transition-timing-function: initial;\n  */\n}\n:host {\n  position: relative;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n  display: block;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-ios .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-horizontal {\n  touch-action: pan-y;\n}\n.swiper-vertical {\n  touch-action: pan-x;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n  display: block;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight,\n.swiper-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n.swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* 3D Effects */\n.swiper-3d.swiper-css-mode .swiper-wrapper {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-wrapper {\n  transform-style: preserve-3d;\n}\n.swiper-3d {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-slide,\n.swiper-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n/* CSS Mode */\n.swiper-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-css-mode.swiper-horizontal > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-css-mode.swiper-vertical > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper {\n  scroll-snap-type: none;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: none;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper::before {\n  content: '';\n  flex-shrink: 0;\n  order: 9999;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: center center;\n  scroll-snap-stop: always;\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {\n  margin-inline-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {\n  height: 100%;\n  min-height: 1px;\n  width: var(--swiper-centered-offset-after);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {\n  margin-block-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {\n  width: 100%;\n  min-width: 1px;\n  height: var(--swiper-centered-offset-after);\n}\n/* Slide styles start */\n/* 3D Shadows */\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-3d .swiper-slide-shadow {\n  background: rgba(0, 0, 0, 0.15);\n}\n.swiper-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,\n.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {\n  animation: swiper-preloader-spin 1s infinite linear;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* Slide styles end */\n");
C(":root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-top-offset: 50%;\n  --swiper-navigation-sides-offset: 10px;\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: var(--swiper-navigation-top-offset, 50%);\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev.swiper-button-hidden,\n.swiper-button-next.swiper-button-hidden {\n  opacity: 0;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-navigation-disabled .swiper-button-prev,\n.swiper-navigation-disabled .swiper-button-next {\n  display: none !important;\n}\n.swiper-button-prev svg,\n.swiper-button-next svg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transform-origin: center;\n}\n.swiper-rtl .swiper-button-prev svg,\n.swiper-rtl .swiper-button-next svg {\n  transform: rotate(180deg);\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n  left: var(--swiper-navigation-sides-offset, 10px);\n  right: auto;\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: var(--swiper-navigation-sides-offset, 10px);\n  left: auto;\n}\n.swiper-button-lock {\n  display: none;\n}\n/* Navigation font start */\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev:after,\n.swiper-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: var(--swiper-navigation-sides-offset, 10px);\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n/* Navigation font end */\n");
C(":root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  --swiper-pagination-left: auto;\n  --swiper-pagination-right: 8px;\n  --swiper-pagination-bottom: 8px;\n  --swiper-pagination-top: auto;\n  --swiper-pagination-fraction-color: inherit;\n  --swiper-pagination-progressbar-bg-color: rgba(0,0,0,0.25);\n  --swiper-pagination-progressbar-size: 4px;\n  --swiper-pagination-bullet-size: 8px;\n  --swiper-pagination-bullet-width: 8px;\n  --swiper-pagination-bullet-height: 8px;\n  --swiper-pagination-bullet-border-radius: 50%;\n  --swiper-pagination-bullet-inactive-color: #000;\n  --swiper-pagination-bullet-inactive-opacity: 0.2;\n  --swiper-pagination-bullet-opacity: 1;\n  --swiper-pagination-bullet-horizontal-gap: 4px;\n  --swiper-pagination-bullet-vertical-gap: 6px;\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n.swiper-pagination-disabled > .swiper-pagination,\n.swiper-pagination.swiper-pagination-disabled {\n  display: none !important;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal {\n  bottom: var(--swiper-pagination-bottom, 8px);\n  top: var(--swiper-pagination-top, auto);\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));\n  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n  display: inline-block;\n  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);\n  background: var(--swiper-pagination-bullet-inactive-color, #000);\n  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n          appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet:only-child {\n  display: none !important;\n}\n.swiper-pagination-bullet-active {\n  opacity: var(--swiper-pagination-bullet-opacity, 1);\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n.swiper-vertical > .swiper-pagination-bullets,\n.swiper-pagination-vertical.swiper-pagination-bullets {\n  right: var(--swiper-pagination-right, 8px);\n  left: var(--swiper-pagination-left, auto);\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;\n  display: block;\n}\n.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform,\n        200ms top;\n}\n.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);\n}\n.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform,\n        200ms left;\n}\n.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform,\n    200ms right;\n}\n/* Fraction */\n.swiper-pagination-fraction {\n  color: var(--swiper-pagination-fraction-color, inherit);\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25));\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n.swiper-horizontal > .swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-horizontal,\n.swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: var(--swiper-pagination-progressbar-size, 4px);\n  left: 0;\n  top: 0;\n}\n.swiper-vertical > .swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-vertical,\n.swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {\n  width: var(--swiper-pagination-progressbar-size, 4px);\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n");
C(":root {\n  /*\n  --swiper-scrollbar-border-radius: 10px;\n  --swiper-scrollbar-top: auto;\n  --swiper-scrollbar-bottom: 4px;\n  --swiper-scrollbar-left: auto;\n  --swiper-scrollbar-right: 4px;\n  --swiper-scrollbar-sides-offset: 1%;\n  --swiper-scrollbar-bg-color: rgba(0, 0, 0, 0.1);\n  --swiper-scrollbar-drag-bg-color: rgba(0, 0, 0, 0.5);\n  --swiper-scrollbar-size: 4px;\n  */\n}\n.swiper-scrollbar {\n  border-radius: var(--swiper-scrollbar-border-radius, 10px);\n  position: relative;\n  touch-action: none;\n  background: var(--swiper-scrollbar-bg-color, rgba(0, 0, 0, 0.1));\n}\n.swiper-scrollbar-disabled > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-disabled {\n  display: none !important;\n}\n.swiper-horizontal > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-horizontal {\n  position: absolute;\n  left: var(--swiper-scrollbar-sides-offset, 1%);\n  bottom: var(--swiper-scrollbar-bottom, 4px);\n  top: var(--swiper-scrollbar-top, auto);\n  z-index: 50;\n  height: var(--swiper-scrollbar-size, 4px);\n  width: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));\n}\n.swiper-vertical > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-vertical {\n  position: absolute;\n  left: var(--swiper-scrollbar-left, auto);\n  right: var(--swiper-scrollbar-right, 4px);\n  top: var(--swiper-scrollbar-sides-offset, 1%);\n  z-index: 50;\n  width: var(--swiper-scrollbar-size, 4px);\n  height: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: var(--swiper-scrollbar-drag-bg-color, rgba(0, 0, 0, 0.5));\n  border-radius: var(--swiper-scrollbar-border-radius, 10px);\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n");
C(".swiper-fade.swiper-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n.swiper-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n.swiper-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-fade .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n");
C(".swiper.swiper-cube {\n  overflow: visible;\n}\n.swiper-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-cube.swiper-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n.swiper-cube .swiper-slide-active,\n.swiper-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-cube .swiper-slide-active,\n.swiper-cube .swiper-slide-next,\n.swiper-cube .swiper-slide-prev {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n  z-index: 0;\n}\n.swiper-cube .swiper-cube-shadow:before {\n  content: '';\n  background: #000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  filter: blur(50px);\n}\n.swiper-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n/* Cube slide shadows start */\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-top,\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-left,\n.swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* Cube slide shadows end */\n");
C("");
C(".swiper.swiper-flip {\n  overflow: visible;\n}\n.swiper-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-flip .swiper-slide-active,\n.swiper-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n/* Flip slide shadows start */\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-top,\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-bottom,\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-left,\n.swiper-flip .swiper-slide-shadow-flip.swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* Flip slide shadows end */\n");
var yt, St;
function xt(t) {
  var r = t.item,
    n = t.deviceType,
    i = t.renderItem,
    a = t.blockItemsParser,
    s = r.settings,
    o = s.effect,
    l = s.spaceBetween,
    c = s.autoSlidesPerPage,
    d = s.slidesPerPage,
    p = s.arrows,
    u = s.dots,
    m = s.scrollbar,
    f = s.loop,
    g = s.autoMove,
    h = s.moveDuration;
  return /*#__PURE__*/e.createElement(nt, {
    effect: o,
    spaceBetween: (["slide", "coverflow"].includes(o) ? l : 0) || 0,
    slidesPerView: ["slide", "coverflow"].includes(o) ? function () {
      if (c) {
        if ("laptop" === n && d > 3) return 3;
        if ("tablet" === n && d > 2) return 2;
        if ("mobile" === n && d > 1) return 1;
      }
      return d;
    }() : 1,
    navigation: p,
    pagination: u && {
      clickable: !0
    },
    scrollbar: m && {
      draggable: !0
    },
    loop: f,
    autoplay: g && {
      delay: 1e3 * (h || 1)
    },
    fadeEffect: {
      crossFade: !0
    },
    cubeEffect: {
      shadow: !1
    },
    modules: [st, lt, ct, dt, ft, gt, vt, bt, wt]
  }, r.items && a(r).map(function (t) {
    return /*#__PURE__*/e.createElement(it, {
      key: t.id
    }, i(t));
  }));
}
function Et(e) {
  return e.items ? e.items.map(function (t) {
    var r = x({}, t);
    return r.settings.wrapperStyles || (r.settings.wrapperStyles = {}), r.settings.wrapperStyles = x(x({}, r.settings.wrapperStyles), e.settings.slideStyles), r;
  }) : [];
}
function Tt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
C(".swiper.swiper-cards {\n  overflow: visible;\n}\n.swiper-cards .swiper-slide {\n  transform-origin: center bottom;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  overflow: hidden;\n}\n");
var kt = Tt(St ? yt : (St = 1, yt = function e(t, r) {
  if (t === r) return !0;
  if (t && r && "object" == _typeof(t) && "object" == _typeof(r)) {
    if (t.constructor !== r.constructor) return !1;
    var n, i, a;
    if (Array.isArray(t)) {
      if ((n = t.length) != r.length) return !1;
      for (i = n; 0 != i--;) if (!e(t[i], r[i])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
    if ((n = (a = Object.keys(t)).length) !== Object.keys(r).length) return !1;
    for (i = n; 0 != i--;) if (!Object.prototype.hasOwnProperty.call(r, a[i])) return !1;
    for (i = n; 0 != i--;) {
      var s = a[i];
      if (!e(t[s], r[s])) return !1;
    }
    return !0;
  }
  return t != t && r != r;
}));
function At() {
  return At = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, At.apply(null, arguments);
}
function Ct(e, t) {
  if (null == e) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
function Mt(e) {
  var t = function (e, t) {
    if ("object" != _typeof(e) || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t);
      if ("object" != _typeof(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }(e, "string");
  return "symbol" == _typeof(t) ? t : t + "";
}
var Pt = "NOT_LOADED",
  Lt = "LOADING",
  Ot = "LOADED",
  It = "FAILED",
  zt = "AUTH_FAILURE";
var Nt = /*#__PURE__*/function () {
  function Nt() {
    _classCallCheck(this, Nt);
  }
  _createClass(Nt, null, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t) {
        var r, n, i, a;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              n = e.libraries ? e.libraries.split(",") : [], i = this.serializeParams(e);
              this.listeners.push(t), null != (r = window.google) && null != (r = r.maps) && r.importLibrary ? (this.serializedApiParams || (this.loadingStatus = Ot), this.notifyLoadingStatusListeners()) : (this.serializedApiParams = i, this.initImportLibrary(e)), this.serializedApiParams && this.serializedApiParams !== i && console.warn("[google-maps-api-loader] The maps API has already been loaded with different parameters and will not be loaded again. Refresh the page for new values to have effect.");
              a = ["maps"].concat(_toConsumableArray(n));
              _context.next = 5;
              return Promise.all(a.map(function (e) {
                return google.maps.importLibrary(e);
              }));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load(_x2, _x3) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "serializeParams",
    value: function serializeParams(e) {
      return [e.v, e.key, e.language, e.region, e.authReferrerPolicy, e.solutionChannel].join("/");
    }
  }, {
    key: "initImportLibrary",
    value: function initImportLibrary(e) {
      var _this = this;
      if (window.google || (window.google = {}), window.google.maps || (window.google.maps = {}), window.google.maps.importLibrary) return void console.error("[google-maps-api-loader-internal]: initImportLibrary must only be called once");
      var t = null;
      var r = function r() {
        return t || (t = new Promise(function (t, r) {
          var n;
          var i = document.createElement("script"),
            a = new URLSearchParams();
          for (var _i15 = 0, _Object$entries = Object.entries(e); _i15 < _Object$entries.length; _i15++) {
            var _ref7 = _Object$entries[_i15];
            var _ref8 = _slicedToArray(_ref7, 2);
            var _t39 = _ref8[0];
            var _r33 = _ref8[1];
            {
              var _e89 = _t39.replace(/[A-Z]/g, function (e) {
                return "_" + e[0].toLowerCase();
              });
              a.set(_e89, _r33);
            }
          }
          a.set("loading", "async"), a.set("callback", "__googleMapsCallback__"), i.async = !0, i.src = "https://maps.googleapis.com/maps/api/js?" + a.toString(), i.nonce = (null == (n = document.querySelector("script[nonce]")) ? void 0 : n.nonce) || "", i.onerror = function () {
            _this.loadingStatus = It, _this.notifyLoadingStatusListeners(), r(new Error("The Google Maps JavaScript API could not load."));
          }, window.__googleMapsCallback__ = function () {
            _this.loadingStatus = Ot, _this.notifyLoadingStatusListeners(), t();
          }, window.gm_authFailure = function () {
            _this.loadingStatus = zt, _this.notifyLoadingStatusListeners();
          }, _this.loadingStatus = Lt, _this.notifyLoadingStatusListeners(), document.head.append(i);
        }), t);
      };
      google.maps.importLibrary = function (e) {
        return r().then(function () {
          return google.maps.importLibrary(e);
        });
      };
    }
  }, {
    key: "notifyLoadingStatusListeners",
    value: function notifyLoadingStatusListeners() {
      var _iterator = _createForOfIteratorHelper(this.listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e90 = _step.value;
          _e90(this.loadingStatus);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return Nt;
}();
Nt.loadingStatus = Pt, Nt.serializedApiParams = void 0, Nt.listeners = [];
var Dt = ["onLoad", "apiKey", "version", "libraries"],
  _t = ["children"],
  Bt = /*#__PURE__*/e.createContext(null);
var Ft = function Ft(t) {
  var n = t.children,
    a = Ct(t, _t),
    _ref9 = function () {
      var _r34 = r({}),
        _r35 = _slicedToArray(_r34, 2),
        e = _r35[0],
        t = _r35[1];
      return {
        mapInstances: e,
        addMapInstance: function addMapInstance(e) {
          var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
          t(function (t) {
            return At({}, t, _defineProperty({}, r, e));
          });
        },
        removeMapInstance: function removeMapInstance() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
          t(function (t) {
            return Ct(t, [e].map(Mt));
          });
        },
        clearMapInstances: function clearMapInstances() {
          t({});
        }
      };
    }(),
    s = _ref9.mapInstances,
    l = _ref9.addMapInstance,
    c = _ref9.removeMapInstance,
    u = _ref9.clearMapInstances,
    _ref10 = function (e) {
      var t = e.onLoad,
        n = e.apiKey,
        a = e.version,
        _e$libraries = e.libraries,
        s = _e$libraries === void 0 ? [] : _e$libraries,
        l = Ct(e, Dt),
        _r36 = r(Nt.loadingStatus),
        _r37 = _slicedToArray(_r36, 2),
        c = _r37[0],
        u = _r37[1],
        _d4 = d(function (e, t) {
          return At({}, e, _defineProperty({}, t.name, t.value));
        }, {}),
        _d5 = _slicedToArray(_d4, 2),
        m = _d5[0],
        f = _d5[1],
        g = o(function () {
          return null == s ? void 0 : s.join(",");
        }, [s]),
        h = o(function () {
          return JSON.stringify(At({
            apiKey: n,
            version: a
          }, l));
        }, [n, a, l]),
        b = p( /*#__PURE__*/function () {
          var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
            var t, r;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (!m[e]) {
                    _context2.next = 2;
                    break;
                  }
                  return _context2.abrupt("return", m[e]);
                case 2:
                  if (!(null == (t = google) || null == (t = t.maps) || !t.importLibrary)) {
                    _context2.next = 4;
                    break;
                  }
                  throw new Error("[api-provider-internal] importLibrary was called before google.maps.importLibrary was defined.");
                case 4:
                  _context2.next = 6;
                  return window.google.maps.importLibrary(e);
                case 6:
                  r = _context2.sent;
                  return _context2.abrupt("return", (f({
                    name: e,
                    value: r
                  }), r));
                case 8:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x4) {
            return _ref11.apply(this, arguments);
          };
        }(), [m]);
      return i(function () {
        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var _e91, _i16, _arr, _e92;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _e91 = At({
                  key: n
                }, l);
                a && (_e91.v = a);
                (null == g ? void 0 : g.length) > 0 && (_e91.libraries = g);
                void 0 === _e91.solutionChannel ? _e91.solutionChannel = "GMP_visgl_rgmlibrary_v1_default" : "" === _e91.solutionChannel && delete _e91.solutionChannel;
                _context3.next = 7;
                return Nt.load(_e91, function (e) {
                  return u(e);
                });
              case 7:
                _i16 = 0, _arr = ["core", "maps"].concat(_toConsumableArray(s));
              case 8:
                if (!(_i16 < _arr.length)) {
                  _context3.next = 15;
                  break;
                }
                _e92 = _arr[_i16];
                _context3.next = 12;
                return b(_e92);
              case 12:
                _i16++;
                _context3.next = 8;
                break;
              case 15:
                t && t();
                _context3.next = 21;
                break;
              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](0);
                console.error("<ApiProvider> failed to load the Google Maps JavaScript API", _context3.t0);
              case 21:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[0, 18]]);
        }))();
      }, [n, g, h]), {
        status: c,
        loadedLibraries: m,
        importLibrary: b
      };
    }(a),
    m = _ref10.status,
    f = _ref10.loadedLibraries,
    g = _ref10.importLibrary,
    h = o(function () {
      return {
        mapInstances: s,
        addMapInstance: l,
        removeMapInstance: c,
        clearMapInstances: u,
        status: m,
        loadedLibraries: f,
        importLibrary: g
      };
    }, [s, l, c, u, m, f, g]);
  return /*#__PURE__*/e.createElement(Bt.Provider, {
    value: h
  }, n);
};
function Gt(e, t, r) {
  var n = {
    type: e,
    map: t,
    detail: {},
    stoppable: !1,
    stop: function stop() {}
  };
  if ($t.includes(e)) {
    var _e93 = n,
      _r38 = t.getCenter(),
      _i17 = t.getZoom(),
      _a12 = t.getHeading() || 0,
      _s8 = t.getTilt() || 0,
      _o10 = t.getBounds();
    return _r38 && _o10 && Number.isFinite(_i17) || console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), _e93.detail = {
      center: (null == _r38 ? void 0 : _r38.toJSON()) || {
        lat: 0,
        lng: 0
      },
      zoom: _i17 || 0,
      heading: _a12,
      tilt: _s8,
      bounds: (null == _o10 ? void 0 : _o10.toJSON()) || {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      }
    }, _e93;
  }
  if (Ht.includes(e)) {
    var i;
    if (!r) throw new Error("[createEvent] mouse events must provide a srcEvent");
    var _e94 = n;
    return _e94.domEvent = r.domEvent, _e94.stoppable = !0, _e94.stop = function () {
      return r.stop();
    }, _e94.detail = {
      latLng: (null == (i = r.latLng) ? void 0 : i.toJSON()) || null,
      placeId: r.placeId
    }, _e94;
  }
  return n;
}
var jt = {
    onBoundsChanged: "bounds_changed",
    onCenterChanged: "center_changed",
    onClick: "click",
    onContextmenu: "contextmenu",
    onDblclick: "dblclick",
    onDrag: "drag",
    onDragend: "dragend",
    onDragstart: "dragstart",
    onHeadingChanged: "heading_changed",
    onIdle: "idle",
    onIsFractionalZoomEnabledChanged: "isfractionalzoomenabled_changed",
    onMapCapabilitiesChanged: "mapcapabilities_changed",
    onMapTypeIdChanged: "maptypeid_changed",
    onMousemove: "mousemove",
    onMouseout: "mouseout",
    onMouseover: "mouseover",
    onProjectionChanged: "projection_changed",
    onRenderingTypeChanged: "renderingtype_changed",
    onTilesLoaded: "tilesloaded",
    onTiltChanged: "tilt_changed",
    onZoomChanged: "zoom_changed",
    onCameraChanged: "bounds_changed"
  },
  $t = ["bounds_changed", "center_changed", "heading_changed", "tilt_changed", "zoom_changed"],
  Ht = ["click", "contextmenu", "dblclick", "mousemove", "mouseout", "mouseover"],
  Rt = Object.keys(jt);
var qt = new Set(["backgroundColor", "clickableIcons", "controlSize", "disableDefaultUI", "disableDoubleClickZoom", "draggable", "draggableCursor", "draggingCursor", "fullscreenControl", "fullscreenControlOptions", "gestureHandling", "headingInteractionEnabled", "isFractionalZoomEnabled", "keyboardShortcuts", "mapTypeControl", "mapTypeControlOptions", "mapTypeId", "maxZoom", "minZoom", "noClear", "panControl", "panControlOptions", "restriction", "rotateControl", "rotateControlOptions", "scaleControl", "scaleControlOptions", "scrollwheel", "streetView", "streetViewControl", "streetViewControlOptions", "styles", "tiltInteractionEnabled", "zoomControl", "zoomControlOptions"]);
function Yt(e, t) {
  var r = {},
    a = Object.keys(t);
  for (var _i18 = 0, _a13 = a; _i18 < _a13.length; _i18++) {
    var _e95 = _a13[_i18];
    qt.has(_e95) && (r[_e95] = t[_e95]);
  }
  !function (e, t) {
    var r = n(void 0);
    r.current && kt(t, r.current) || (r.current = t), i(e, r.current);
  }(function () {
    e && e.setOptions(r);
  }, [r]);
}
function Vt() {
  var e;
  return (null == (e = u(Bt)) ? void 0 : e.status) || Pt;
}
function Wt(e) {
  return function (e) {
    return !(!e || "object" != _typeof(e)) && "lat" in e && "lng" in e && Number.isFinite(e.lat) && Number.isFinite(e.lng);
  }(e) ? e : e.toJSON();
}
var Kt = function Kt() {
  return /*#__PURE__*/e.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 999,
      display: "flex",
      flexFlow: "column nowrap",
      textAlign: "center",
      justifyContent: "center",
      fontSize: ".8rem",
      color: "rgba(0,0,0,0.6)",
      background: "#dddddd",
      padding: "1rem 1.5rem"
    }
  }, /*#__PURE__*/e.createElement("h2", null, "Error: AuthFailure"), /*#__PURE__*/e.createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", /*#__PURE__*/e.createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function Ut() {
  return Vt() === Ot;
}
function Xt(e) {
  var t = function () {
      var _d6 = d(function (e) {
          return e + 1;
        }, 0),
        _d7 = _slicedToArray(_d6, 2),
        e = _d7[1];
      return e;
    }(),
    r = n({
      center: {
        lat: 0,
        lng: 0
      },
      heading: 0,
      tilt: 0,
      zoom: 0
    });
  return i(function () {
    if (!e) return;
    var n = google.maps.event.addListener(e, "bounds_changed", function () {
      !function (e, t) {
        var r = e.getCenter(),
          n = e.getZoom(),
          i = e.getHeading() || 0,
          a = e.getTilt() || 0,
          s = e.getBounds();
        r && s && Number.isFinite(n) || console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), Object.assign(t.current, {
          center: (null == r ? void 0 : r.toJSON()) || {
            lat: 0,
            lng: 0
          },
          zoom: n || 0,
          heading: i,
          tilt: a
        });
      }(e, r), t();
    });
    return function () {
      return n.remove();
    };
  }, [e, t]), r;
}
var Zt = ["id", "defaultBounds", "defaultCenter", "defaultZoom", "defaultHeading", "defaultTilt", "reuseMaps", "renderingType", "colorScheme"],
  Qt = ["padding"];
var Jt = /*#__PURE__*/function () {
  function Jt() {
    _classCallCheck(this, Jt);
  }
  _createClass(Jt, null, [{
    key: "has",
    value: function has(e) {
      return this.entries[e] && this.entries[e].length > 0;
    }
  }, {
    key: "pop",
    value: function pop(e) {
      return this.entries[e] && this.entries[e].pop() || null;
    }
  }, {
    key: "push",
    value: function push(e, t) {
      this.entries[e] || (this.entries[e] = []), this.entries[e].push(t);
    }
  }]);
  return Jt;
}();
function er(e, t) {
  var a = Ut(),
    _r39 = r(null),
    _r40 = _slicedToArray(_r39, 2),
    s = _r40[0],
    o = _r40[1],
    _ref13 = function () {
      var _r41 = r(null),
        _r42 = _slicedToArray(_r41, 2),
        e = _r42[0],
        t = _r42[1];
      return [e, p(function (e) {
        return t(e);
      }, [t])];
    }(),
    _ref14 = _slicedToArray(_ref13, 2),
    l = _ref14[0],
    c = _ref14[1],
    d = Xt(s),
    u = e.id,
    m = e.defaultBounds,
    f = e.defaultCenter,
    g = e.defaultZoom,
    h = e.defaultHeading,
    b = e.defaultTilt,
    v = e.reuseMaps,
    w = e.renderingType,
    y = e.colorScheme,
    S = Ct(e, Zt),
    x = void 0 !== e.zoom || void 0 !== e.defaultZoom,
    E = void 0 !== e.center || void 0 !== e.defaultCenter;
  m || x && E || console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required"), !S.center && f && (S.center = f), !S.zoom && Number.isFinite(g) && (S.zoom = g), !S.heading && Number.isFinite(h) && (S.heading = h), !S.tilt && Number.isFinite(b) && (S.tilt = b);
  for (var _i19 = 0, _Object$keys = Object.keys(S); _i19 < _Object$keys.length; _i19++) {
    var _e96 = _Object$keys[_i19];
    void 0 === S[_e96] && delete S[_e96];
  }
  var T = n();
  return i(function () {
    if (!l || !a) return;
    var r = t.addMapInstance,
      n = t.removeMapInstance,
      i = e.mapId,
      s = "".concat(i || "default", ":").concat(w || "default", ":").concat(y || "LIGHT");
    var c, p;
    if (v && Jt.has(s) ? (p = Jt.pop(s), c = p.getDiv(), l.appendChild(c), p.setOptions(S), setTimeout(function () {
      return p.setCenter(p.getCenter());
    }, 0)) : (c = document.createElement("div"), c.style.height = "100%", l.appendChild(c), p = new google.maps.Map(c, At({}, S, w ? {
      renderingType: w
    } : {}, y ? {
      colorScheme: y
    } : {}))), o(p), r(p, u), m) {
      var _e97 = m.padding,
        _t40 = Ct(m, Qt);
      p.fitBounds(_t40, _e97);
    } else x && E || p.fitBounds({
      east: 180,
      west: -180,
      south: -90,
      north: 90
    });
    if (T.current) {
      var _T$current = T.current,
        _e98 = _T$current.mapId,
        _t41 = _T$current.cameraState;
      _e98 !== i && p.setOptions(_t41);
    }
    return function () {
      T.current = {
        mapId: i,
        cameraState: d.current
      }, c.remove(), v ? Jt.push(s, p) : google.maps.event.clearInstanceListeners(p), o(null), n(u);
    };
  }, [l, a, u, e.mapId, e.renderingType, e.colorScheme]), [s, c, d];
}
Jt.entries = {};
var tr = /*#__PURE__*/e.createContext(null),
  rr = function rr(t) {
    var r = t.children,
      n = t.id,
      s = t.className,
      l = t.style,
      c = u(Bt),
      d = Vt();
    if (!c) throw new Error("<Map> can only be used inside an <ApiProvider> component.");
    var _er = er(t, c),
      _er2 = _slicedToArray(_er, 3),
      p = _er2[0],
      m = _er2[1],
      f = _er2[2];
    !function (e, t, r) {
      var n = r.center ? Wt(r.center) : null;
      var i = null,
        s = null;
      n && Number.isFinite(n.lat) && Number.isFinite(n.lng) && (i = n.lat, s = n.lng);
      var o = Number.isFinite(r.zoom) ? r.zoom : null,
        l = Number.isFinite(r.heading) ? r.heading : null,
        c = Number.isFinite(r.tilt) ? r.tilt : null;
      a(function () {
        if (!e) return;
        var r = {};
        var n = !1;
        null === i || null === s || t.current.center.lat === i && t.current.center.lng === s || (r.center = {
          lat: i,
          lng: s
        }, n = !0), null !== o && t.current.zoom !== o && (r.zoom = o, n = !0), null !== l && t.current.heading !== l && (r.heading = l, n = !0), null !== c && t.current.tilt !== c && (r.tilt = c, n = !0), n && e.moveCamera(r);
      });
    }(p, f, t), function (e, t) {
      var _loop2 = function _loop2() {
        var r = _Rt[_i20];
        var n = t[r],
          a = jt[r];
        i(function () {
          if (!e) return;
          if (!n) return;
          var t = google.maps.event.addListener(e, a, function (t) {
            n(Gt(a, e, t));
          });
          return function () {
            return t.remove();
          };
        }, [e, a, n]);
      };
      for (var _i20 = 0, _Rt = Rt; _i20 < _Rt.length; _i20++) {
        _loop2();
      }
    }(p, t), Yt(p, t);
    var g = function (e, t) {
        var r = t.viewport,
          n = t.viewState,
          i = !!r;
        return a(function () {
          if (!e || !n) return;
          var t = n.latitude,
            r = n.longitude,
            i = n.bearing,
            a = n.pitch,
            s = n.zoom;
          e.moveCamera({
            center: {
              lat: t,
              lng: r
            },
            heading: i,
            tilt: a,
            zoom: s + 1
          });
        }, [e, n]), i;
      }(p, t),
      h = !!t.controlled;
    i(function () {
      if (p) return g && p.setOptions({
        disableDefaultUI: !0
      }), (g || h) && p.setOptions({
        gestureHandling: "none",
        keyboardShortcuts: !1
      }), function () {
        p.setOptions({
          gestureHandling: t.gestureHandling,
          keyboardShortcuts: t.keyboardShortcuts
        });
      };
    }, [p, g, h, t.gestureHandling, t.keyboardShortcuts]);
    var b = t.center ? Wt(t.center) : null;
    var v = null,
      w = null;
    b && Number.isFinite(b.lat) && Number.isFinite(b.lng) && (v = b.lat, w = b.lng);
    var y = o(function () {
      var e, r, n, i, a;
      return {
        center: {
          lat: null != (e = v) ? e : 0,
          lng: null != (r = w) ? r : 0
        },
        zoom: null != (n = t.zoom) ? n : 0,
        heading: null != (i = t.heading) ? i : 0,
        tilt: null != (a = t.tilt) ? a : 0
      };
    }, [v, w, t.zoom, t.heading, t.tilt]);
    a(function () {
      if (!p || !h) return;
      p.moveCamera(y);
      var e = p.addListener("bounds_changed", function () {
        p.moveCamera(y);
      });
      return function () {
        return e.remove();
      };
    }, [p, h, y]);
    var S = o(function () {
        return At({
          width: "100%",
          height: "100%",
          position: "relative",
          zIndex: g ? -1 : 0
        }, l);
      }, [l, g]),
      x = o(function () {
        return {
          map: p
        };
      }, [p]);
    return d === zt ? /*#__PURE__*/e.createElement("div", {
      style: At({
        position: "relative"
      }, s ? {} : S),
      className: s
    }, /*#__PURE__*/e.createElement(Kt, null)) : /*#__PURE__*/e.createElement("div", At({
      ref: m,
      "data-testid": "map",
      style: s ? void 0 : S,
      className: s
    }, n ? {
      id: n
    } : {}), p ? /*#__PURE__*/e.createElement(tr.Provider, {
      value: x
    }, r) : null);
  };
rr.deckGLViewProps = !0;
var nr = new Set();
var ir = function ir() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var t = u(Bt),
    _ref15 = u(tr) || {},
    r = _ref15.map;
  if (null === t) return function () {
    var _console;
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }
    var t = JSON.stringify(e);
    nr.has(t) || (nr.add(t), (_console = console).error.apply(_console, e));
  }("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>."), null;
  var n = t.mapInstances;
  return null !== e ? n[e] || null : r || n.default || null;
};
function ar(e, t, r) {
  var n = 0 === t.indexOf("--");
  var i;
  null == r || "boolean" == typeof r || "" === r ? n ? e.setProperty(t, "") : "float" === t ? e.cssFloat = "" : e[t] = "" : n ? e.setProperty(t, r) : "number" != typeof r || 0 === r || (i = t, sr.has(i)) ? "float" === t ? e.cssFloat = r : e[t] = ("" + r).trim() : e[t] = r + "px";
}
var sr = new Set(["animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexPositive", "flexShrink", "flexNegative", "flexOrder", "gridArea", "gridRow", "gridRowEnd", "gridRowSpan", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnSpan", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "fillOpacity", "floodOpacity", "stopOpacity", "strokeDasharray", "strokeDashoffset", "strokeMiterlimit", "strokeOpacity", "strokeWidth"]);
function or(e, t, r) {
  i(function () {
    if (!e || !t || !r) return;
    var n = google.maps.event.addListener(e, t, r);
    return function () {
      return n.remove();
    };
  }, [e, t, r]);
}
function lr(e, t, r) {
  i(function () {
    e && (e[t] = r);
  }, [e, t, r]);
}
var cr = /*#__PURE__*/e.createContext(null);
function dr(e) {
  var _r43 = r(null),
    _r44 = _slicedToArray(_r43, 2),
    t = _r44[0],
    a = _r44[1],
    _r45 = r(null),
    _r46 = _slicedToArray(_r45, 2),
    s = _r46[0],
    o = _r46[1],
    l = n(null),
    d = ir(),
    p = function (e) {
      var t = Ut(),
        r = u(Bt);
      return i(function () {
        t && r && r.importLibrary(e);
      }, [t, r, e]), (null == r ? void 0 : r.loadedLibraries[e]) || null;
    }("marker"),
    m = e.children,
    f = e.className,
    g = e.style,
    h = e.onClick,
    b = e.onDrag,
    v = e.onDragStart,
    w = e.onDragEnd,
    y = e.collisionBehavior,
    S = e.clickable,
    x = e.draggable,
    E = e.position,
    T = e.title,
    k = e.zIndex,
    A = c.count(m);
  return i(function () {
    if (!d || !p) return;
    var e = new p.AdvancedMarkerElement();
    e.map = d, a(e);
    var t = null;
    return A > 0 && (t = document.createElement("div"), e.content = t, o(t)), function () {
      var r;
      e.map = null, null == (r = t) || r.remove(), a(null), o(null);
    };
  }, [d, p, A]), i(function () {
    t && t.content && (t.content.className = f || "");
  }, [t, f]), lr(s, "className", null != f ? f : ""), i(function () {
    s && (!function (e, t, r) {
      if (null != t && "object" != _typeof(t)) throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var n = e.style;
      if (null != r) {
        for (var _e99 in r) !r.hasOwnProperty(_e99) || null != t && t.hasOwnProperty(_e99) || (0 === _e99.indexOf("--") ? n.setProperty(_e99, "") : "float" === _e99 ? n.cssFloat = "" : n[_e99] = "");
        if (null != t) for (var _e100 in t) {
          var _i21 = t[_e100];
          t.hasOwnProperty(_e100) && r[_e100] !== _i21 && ar(n, _e100, _i21);
        }
      } else {
        if (null == t) return;
        for (var _e101 in t) t.hasOwnProperty(_e101) && ar(n, _e101, t[_e101]);
      }
    }(s, g || null, l.current), l.current = g || null);
  }, [s, f, g]), lr(t, "position", E), lr(t, "title", null != T ? T : ""), lr(t, "zIndex", k), lr(t, "collisionBehavior", y), i(function () {
    t && (t.gmpDraggable = void 0 !== x ? x : !!(b || v || w));
  }, [t, x, b, w, v]), i(function () {
    t && (t.gmpClickable = void 0 !== S ? S : !!h);
  }, [t, S, h]), or(t, "click", h), or(t, "drag", b), or(t, "dragstart", v), or(t, "dragend", w), [t, s];
}
var pr = /*#__PURE__*/t(function (t, r) {
    var n = t.children,
      _dr = dr(t),
      _dr2 = _slicedToArray(_dr, 2),
      i = _dr2[0],
      a = _dr2[1],
      s = o(function () {
        return i ? {
          marker: i
        } : null;
      }, [i]);
    return l(r, function () {
      return i;
    }, [i]), a ? /*#__PURE__*/e.createElement(cr.Provider, {
      value: s
    }, /*#__PURE__*/m(n, a)) : null;
  }),
  ur = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut"];
function mr(e) {
  return e.items ? e.items.map(function (t) {
    var r = x({}, t);
    r.settings.wrapperStyles = e.settings.testimonialWrapperStyles, r.settings.styles = e.settings.testimonialStyles, r.settings.titleStyles = e.settings.testimonialTitleStyles, r.settings.imageStyles = x(x({}, r.settings.imageStyles), e.settings.testimonialImageStyles), r.settings.borderStyles = e.settings.testimonialBorderStyles;
    return ["testimonialBackgroundType", "testimonialBackgroundTypeColor", "testimonialBackgroundTypeImage", "testimonialBackgroundTypeImageStyles", "testimonialBackgroundTypeOverlay"].forEach(function (t) {
      r.settings[t.replace("testimonialB", "b")] = e.settings[t];
    }), r;
  }) : [];
}
/*#__PURE__*/t(function (t, n) {
  var a = function (e) {
    var _r47 = r(null),
      _r48 = _slicedToArray(_r47, 2),
      t = _r48[0],
      n = _r48[1],
      a = ir(),
      s = e.onClick,
      o = e.onDrag,
      l = e.onDragStart,
      c = e.onDragEnd,
      d = e.onMouseOver,
      p = e.onMouseOut,
      u = Ct(e, ur),
      m = u.position,
      f = u.draggable;
    return i(function () {
      if (!a) return void (void 0 === a && console.error("<Marker> has to be inside a Map component."));
      var e = new google.maps.Marker(u);
      return e.setMap(a), n(e), function () {
        e.setMap(null), n(null);
      };
    }, [a]), i(function () {
      if (!t) return;
      var e = t,
        r = google.maps.event;
      return s && r.addListener(e, "click", s), o && r.addListener(e, "drag", o), l && r.addListener(e, "dragstart", l), c && r.addListener(e, "dragend", c), d && r.addListener(e, "mouseover", d), p && r.addListener(e, "mouseout", p), t.setDraggable(Boolean(f)), function () {
        r.clearInstanceListeners(e);
      };
    }, [t, f, s, o, l, c, d, p]), i(function () {
      t && u && t.setOptions(u);
    }, [t, u]), i(function () {
      !f && m && t && t.setPosition(m);
    }, [f, m, t]), t;
  }(t);
  return l(n, function () {
    return a;
  }, [a]), /*#__PURE__*/e.createElement(e.Fragment, null);
}), window.ThemeSettings = {};
var fr = {
  container: function container(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem;
    if (_(n, r.settings.visibility)) {
      var a = r.settings,
        s = a.id,
        o = a.classes,
        l = a.fullWidth,
        c = a.styles,
        d = O(a.wrapperStyles, n, {
          themeSettingsSeedData: [{
            themeSettingKey: "general"
          }]
        });
      return l && d && delete d.maxWidth, /*#__PURE__*/e.createElement("div", {
        id: s || null,
        className: "rb-container ".concat(o || ""),
        style: d
      }, /*#__PURE__*/e.createElement(F, {
        settings: a,
        deviceType: n,
        className: "flex" === c.display ? "flex-column" : ""
      }, r.items && r.items.map(function (e) {
        return i(e);
      })));
    }
    return !1;
  },
  columns: function columns(t) {
    var r,
      n = t.item,
      i = t.deviceType,
      a = t.renderItem;
    if (_(i, n.settings.visibility)) {
      var s = n.settings,
        o = s.id,
        l = s.classes,
        c = s.fullWidth,
        d = s.stack,
        p = s.spaceBetween,
        u = s.spaceBetweenUnit,
        m = s.newTab,
        f = (s.link || "").trim(),
        g = O(s.wrapperStyles, i, {
          themeSettingsSeedData: [{
            themeSettingKey: "general"
          }]
        });
      return c && g && delete g.maxWidth, /*#__PURE__*/e.createElement("div", {
        id: o || null,
        className: "rb-columns ".concat(f ? "rb-block-link" : "", " ").concat(l || ""),
        style: g,
        onClick: function onClick(e) {
          f && (e.stopPropagation(), window.open(f, m ? "_blank" : "_self"));
        }
      }, /*#__PURE__*/e.createElement(F, {
        settings: s,
        deviceType: i,
        style: {
          gap: "".concat(p).concat(u || "px")
        },
        className: "".concat(d && "mobile" === i ? "flex-column flex-wrap" : "", " flex-box")
      }, n.items && (r = n, r.items ? r.items.map(function (e, t) {
        var n = x({}, e);
        return n.settings.wrapperStyles || (n.settings.wrapperStyles = {}), n.settings.wrapperStyles = x(x(x({}, n.settings.wrapperStyles), r.settings.columnStyles), {}, {
          width: "".concat((100 / (12 / r.settings.columnsWidth[t])).toFixed(2), "%")
        }), n.settings.stack = r.settings.stack, n;
      }) : []).map(function (e) {
        return a(e);
      })));
    }
    return !1;
  },
  column: function column(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem,
      a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.wrapperStyles,
      c = a.stack,
      d = a.styles,
      p = a.newTab,
      u = (a.link || "").trim();
    return /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-column ".concat(u ? "rb-block-link" : "", " ").concat(c && "mobile" === n ? "stack" : "", " ").concat(o || ""),
      style: O(l, n),
      onClick: function onClick(e) {
        u && (e.stopPropagation(), window.open(u, p ? "_blank" : "_self"));
      }
    }, /*#__PURE__*/e.createElement(F, {
      settings: a,
      deviceType: n,
      className: "flex" === d.display ? "flex-column" : ""
    }, r.items && r.items.map(function (e) {
      return i(e);
    })));
  },
  slider: function slider(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem,
      a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.wrapperStyles;
    return /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-slider ".concat(o || ""),
      style: O(l, n)
    }, /*#__PURE__*/e.createElement(F, {
      settings: a,
      deviceType: n
    }, /*#__PURE__*/e.createElement(xt, {
      item: r,
      deviceType: n,
      renderItem: i,
      blockItemsParser: Et
    })));
  },
  slide: function slide(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem,
      a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.wrapperStyles,
      c = a.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-slide ".concat(o || ""),
      style: O(l, n)
    }, /*#__PURE__*/e.createElement(F, {
      settings: a,
      deviceType: n,
      className: "flex" === c.display ? "flex-column" : ""
    }, r.items && r.items.map(function (e) {
      return i(e);
    })));
  },
  tabs: function tabs(t) {
    var n = t.item,
      i = t.deviceType,
      a = t.renderItem,
      s = T(r(n.items && n.items.length ? n.items[0].id : null), 2),
      o = s[0],
      l = s[1],
      c = T(r(null), 2),
      d = c[0],
      p = c[1],
      u = n.settings,
      m = u.id,
      f = u.classes,
      g = u.styles;
    u.wrapperStyles;
    var h = u.panelStyles,
      b = u.panelHoverStyles;
    u.panelTitleStyles;
    var v = u.panelWrapperStyles,
      w = u.tabIconStyles,
      y = u.iconPosition,
      S = "fluid" === u.layout;
    function E(t) {
      return /*#__PURE__*/e.createElement("i", {
        style: O(w, i),
        className: "rb-tab-panel-icon ".concat(t.settings.iconType || "fal", " ").concat(t.settings.icon, " ").concat(y)
      });
    }
    function k(t) {
      var r = t.id === o,
        n = t.id === d,
        a = !!t.settings.icon,
        s = {
          color: "color",
          backgroundColor: "backgroundColor",
          borderColor: "borderColor"
        },
        c = O(h, i, {
          themeSettingsSeedData: [{
            themeSettingKey: "buttonHover",
            themeSettingObserver: s
          }, {
            themeSettingKey: "button",
            themeSettingObserver: {
              fontFamily: "fontFamily",
              fontSize: "fontSize",
              fontWeight: "fontWeight",
              letterSpacing: "letterSpacing",
              lineHeight: "lineHeight",
              textTransform: "textTransform"
            }
          }]
        }),
        u = "rb-tab-panel-wrapper";
      return S && (u += " flex-1"), (r || n) && (c = x(x({}, c), O(b, i, {
        themeSettingsSeedData: [{
          themeSettingKey: "button",
          themeSettingObserver: s
        }]
      }))), c.boxShadow = "rgb(from ".concat(c.borderColor, " r g b / 0.2) 1px 3px 3px 0px"), a && (u += " flex-box items-center content-center ", ["top", "bottom"].includes(y) && (u += " flex-column")), /*#__PURE__*/e.createElement("div", {
        key: t.id,
        style: c,
        className: u,
        onClick: function onClick(e) {
          return function (e) {
            e.stopPropagation(), l(t.id);
          }(e, t.id);
        },
        onMouseEnter: function onMouseEnter() {
          return p(t.id);
        },
        onMouseLeave: function onMouseLeave() {
          return p(null);
        }
      }, a && ["left", "top"].includes(y) && E(t), /*#__PURE__*/e.createElement("div", {
        className: "rb-tab-panel-title"
      }, t.settings.title), a && ["right", "bottom"].includes(y) && E(t));
    }
    return /*#__PURE__*/e.createElement("div", {
      id: m || null,
      className: "rb-tabs ".concat(f || ""),
      style: O(g, i)
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-tabs-panel-row flex-box items-center ".concat(S ? "flex-wrap" : ""),
      style: O(v, i)
    }, n.items && n.items.map(function (e) {
      return k(e);
    })), n.items && function (e, t) {
      return e.items ? e.items.map(function (r) {
        var n = x({}, r);
        return n.settings.styles = e.settings.tabStyles, n.settings.borderStyles = e.settings.tabBorderStyles, n.settings.isCurrentTab = r.id === t, ["tabBackgroundType", "tabBackgroundTypeColor", "tabBackgroundTypeImage", "tabBackgroundTypeImageStyles", "tabBackgroundTypeOverlay"].forEach(function (t) {
          n.settings[t.replace("tabB", "b")] = e.settings[t];
        }), n;
      }) : [];
    }(n, o).map(function (e) {
      return a(e);
    }));
  },
  tab: function tab(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem;
    r.items && r.items.length;
    var a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.wrapperStyles,
      c = a.styles,
      d = a.isCurrentTab;
    return /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-tab ".concat(o || ""),
      style: x(x({}, O(l, n)), d ? {} : {
        display: "none"
      })
    }, /*#__PURE__*/e.createElement(F, {
      settings: a,
      deviceType: n,
      className: "flex" === c.display ? "flex-column" : ""
    }, r.items && r.items.map(function (e) {
      return i(e);
    })));
  },
  flipCards: function flipCards(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem,
      a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-flip-cards flex-box flex-wrap ".concat(o || ""),
      style: O(l, n)
    }, r.items && function (e, t) {
      return e.items ? e.items.map(function (r) {
        var n = x({}, r),
          i = function (e, t, r) {
            if (t) {
              if ("laptop" === r && e > 4) return 4;
              if ("tablet" === r && e > 3) return 3;
              if ("mobile" === r && e > 1) return 1;
            }
            return e;
          }(e.settings.cardsPerRow, e.settings.autoCardsPerRow, t);
        return n.settings.styles = e.settings.flipCardStyles, n.settings.borderStyles = e.settings.flipCardBorderStyles, n.settings.iconStyles = e.settings.flipCardIconStyles, n.settings.flipEffect = e.settings.flipEffect, n.settings.frontTextStyles = e.settings.frontCardTextStyles, n.settings.backTextStyles = e.settings.backCardTextStyles, n.settings.wrapperStyles = {
          width: "calc(".concat((100 / i).toFixed(2), "% - ").concat(Math.ceil(e.settings.styles.gap * (i - 1) / i)).concat(e.settings.styles.gapUnit, ")"),
          height: n.settings.styles.height,
          heightUnit: n.settings.styles.heightUnit
        }, n.settings.frontCard = {}, n.settings.backCard = {}, ["frontCardBackgroundType", "frontCardBackgroundTypeColor", "frontCardBackgroundTypeImage", "frontCardBackgroundTypeImageStyles", "frontCardBackgroundTypeOverlay"].forEach(function (t) {
          n.settings.frontCard[t.replace("frontCardB", "b")] = e.settings[t];
        }), ["backCardBackgroundType", "backCardBackgroundTypeColor", "backCardBackgroundTypeImage", "backCardBackgroundTypeImageStyles", "backCardBackgroundTypeOverlay"].forEach(function (t) {
          n.settings[t.replace("backCardB", "b")] = e.settings[t];
        }), n;
      }) : [];
    }(r, n).map(function (e) {
      return i(e);
    }));
  },
  flipCard: function flipCard(t) {
    var n = t.item,
      a = t.deviceType,
      s = T(r(!1), 2),
      o = s[0],
      l = s[1],
      c = n.settings,
      d = c.id,
      p = c.classes,
      u = c.wrapperStyles,
      m = c.flipEffect,
      f = c.styles,
      g = c.icon,
      h = c.iconType,
      b = c.iconStyles,
      v = c.frontCard,
      w = c.frontText,
      y = c.backCard,
      S = c.backText,
      E = c.newTab,
      A = c.frontTextStyles,
      C = c.backTextStyles,
      P = (c.link || "").trim(),
      L = x({}, f);
    return delete L.minHeight, i(function () {
      var e = document.getElementById(n.id);
      e && (e.style.perspective = 2 * e.offsetWidth + "px");
    }, [u.width]), /*#__PURE__*/e.createElement("div", {
      id: d || null,
      className: "rb-flip-card ".concat(P ? "rb-block-link" : "", " ").concat(p || ""),
      onMouseEnter: function onMouseEnter() {
        return l(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return l(!1);
      },
      onClick: function onClick(e) {
        P && (e.stopPropagation(), window.open(P, E ? "_blank" : "_self"));
      },
      style: O(u, a)
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-flip-card-content-wrapper ".concat(o ? "rb-".concat(m) : "")
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-flip-card-front-card"
    }, /*#__PURE__*/e.createElement(F, {
      settings: x(x({}, c), v),
      deviceType: a,
      className: "flex" === f.display ? "flex-column" : ""
    }, g && /*#__PURE__*/e.createElement("i", {
      className: "".concat(h || "fal", " ").concat(g, " rb-flip-card-icon"),
      style: O(b, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "body",
          themeSettingObserver: {
            color: "color"
          }
        }]
      })
    }), /*#__PURE__*/e.createElement("div", {
      className: "rb-flip-card-content",
      style: O(A, a, {
        themeSettingsSeedData: M
      })
    }, w))), /*#__PURE__*/e.createElement("div", {
      className: "rb-flip-card-back-card ".concat("rb-".concat(m))
    }, /*#__PURE__*/e.createElement(F, {
      settings: x(x(x({}, c), y), {}, {
        styles: L
      }),
      deviceType: a,
      className: "flex" === f.display ? "flex-column" : "",
      backgroundColorThemeSettingKey: "button"
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-flip-card-content",
      style: O(C, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "button",
          themeSettingObserver: {
            color: "color"
          }
        }].concat(k(M))
      })
    }, S)))));
  },
  accordion: function accordion(t) {
    var r,
      n = t.item,
      i = t.deviceType,
      a = t.renderItem,
      s = n.settings,
      o = s.id,
      l = s.classes,
      c = s.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: o || null,
      className: "rb-accordion flex-box flex-column ".concat(l || ""),
      style: O(c, i)
    }, n.items && (r = n, r.items ? r.items.map(function (e) {
      var t = x({}, e);
      return t.settings.styles = r.settings.accordionItemStyles, t.settings.contentStyles = r.settings.accordionItemStyles, t.settings.headingStyles = r.settings.headingStyles, t.settings.headingHoverStyles = r.settings.headingHoverStyles, t.settings.iconStyles = r.settings.accordionItemIconStyles, t.settings.iconPosition = r.settings.iconPosition, ["accordionItemBackgroundType", "accordionItemBackgroundTypeColor", "accordionItemBackgroundTypeImage", "accordionItemBackgroundTypeImageStyles", "accordionItemBackgroundTypeOverlay"].forEach(function (e) {
        t.settings[e.replace("accordionItemB", "b")] = r.settings[e];
      }), t;
    }) : []).map(function (e) {
      return a(e);
    }));
  },
  accordionItem: function accordionItem(t) {
    var n = t.item,
      i = t.deviceType,
      a = T(r(n.settings.toggled), 2),
      s = a[0],
      o = a[1],
      l = T(r(!1), 2),
      c = l[0],
      d = l[1],
      p = n.settings,
      u = p.id,
      m = p.classes,
      f = p.headingStyles,
      g = p.headingHoverStyles;
    p.contentStyles;
    var h = p.icon,
      b = p.iconPosition,
      v = p.iconStyles,
      w = p.iconType,
      y = p.title,
      S = p.text,
      E = O(f, i, {
        themeSettingsSeedData: [{
          themeSettingKey: "button",
          themeSettingObserver: {
            fontFamily: "fontFamily",
            fontSize: "fontSize",
            fontWeight: "fontWeight",
            letterSpacing: "letterSpacing",
            lineHeight: "lineHeight",
            textTransform: "textTransform"
          }
        }]
      });
    function k() {
      return /*#__PURE__*/e.createElement("i", {
        style: O(v, i),
        className: "rb-accordion-item-icon ".concat(w || "fal", " ").concat(h, " ").concat(b)
      });
    }
    return (s || c) && (E = x(x({}, E), O(g, i))), /*#__PURE__*/e.createElement("div", {
      id: u || null,
      className: "rb-accordion-item ".concat(m || "")
    }, /*#__PURE__*/e.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation(), o(function (e) {
          return !e;
        });
      },
      onMouseEnter: function onMouseEnter() {
        return d(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return d(!1);
      },
      className: "rb-accordion-item-heading flex-box items-center content-space-between",
      style: E
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-accordion-item-heading-title-wrapper flex-box items-center content-center"
    }, h && "left" === b && k(), /*#__PURE__*/e.createElement("div", {
      className: "rb-accordion-item-heading-title"
    }, y), h && "right" === b && k()), /*#__PURE__*/e.createElement("i", {
      style: O(v, i),
      className: "fal ".concat(s ? "fa-angle-up" : "fa-angle-down")
    })), s && /*#__PURE__*/e.createElement("div", {
      className: "rb-accordion-item-content-wrapper"
    }, /*#__PURE__*/e.createElement(F, {
      settings: p,
      deviceType: i
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-accordion-item-content rb-text-content",
      style: O({}, i, {
        themeSettingsSeedData: P
      }),
      dangerouslySetInnerHTML: {
        __html: S
      }
    }))));
  },
  divider: function divider(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-divider ".concat(s || ""),
      style: O(o, n, {
        themeSettingsSeedData: [{
          themeSettingKey: "colors",
          themeSettingObserver: {
            backgroundColor: "separatorsColor"
          }
        }]
      })
    });
  },
  image: function image(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.dimensions,
      l = i.image,
      c = i.styles,
      d = i.aspectRatio,
      p = i.variant,
      u = i.alternativeName,
      m = i.newTab,
      f = (i.link || "").trim();
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-image ".concat(f ? "rb-block-link" : "", " ").concat(s || ""),
      style: O(o, n),
      onClick: function onClick(e) {
        f && (e.stopPropagation(), window.open(f, m ? "_blank" : "_self"));
      }
    }, l && /*#__PURE__*/e.createElement("img", {
      style: x(x({}, O(c, n)), {}, {
        aspectRatio: d
      }),
      src: p && l.variants ? l.variants[p].sourceUrl : l.sourceUrl,
      alt: u || ""
    }));
  },
  heading: function heading(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.text,
      l = i.headingType,
      c = i.styles,
      d = i.newTab,
      p = (i.link || "").trim(),
      u = {
        id: a || null,
        className: "rb-heading ".concat(p ? "rb-block-link" : "", " ").concat(s || ""),
        style: O(c, n, {
          themeSettingsSeedData: [{
            themeSettingKey: l
          }, {
            themeSettingKey: "body",
            themeSettingObserver: {
              color: "color"
            }
          }]
        }),
        onClick: function onClick(e) {
          p && (e.stopPropagation(), window.open(p, d ? "_blank" : "_self"));
        }
      };
    return "h1" === l ? /*#__PURE__*/e.createElement("h1", u, o) : "h2" === l ? /*#__PURE__*/e.createElement("h2", u, o) : "h3" === l ? /*#__PURE__*/e.createElement("h3", u, o) : "h4" === l ? /*#__PURE__*/e.createElement("h4", u, o) : "h5" === l ? /*#__PURE__*/e.createElement("h5", u, o) : "h6" === l ? /*#__PURE__*/e.createElement("h6", u, o) : /*#__PURE__*/e.createElement(e.Fragment, null, r.id);
  },
  text: function text(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.styles,
      l = i.text;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-text rb-text-content ".concat(s || ""),
      style: O(o, n, {
        themeSettingsSeedData: P
      }),
      dangerouslySetInnerHTML: {
        __html: l
      }
    });
  },
  button: function button(t) {
    var n = t.item,
      i = t.deviceType,
      a = T(r(!1), 2),
      s = a[0],
      o = a[1],
      l = n.settings,
      c = l.id,
      d = l.classes,
      p = l.fullWidth,
      u = l.text,
      m = l.styles,
      f = l.hoverStyles,
      g = l.newTab,
      h = (l.link || "").trim();
    return /*#__PURE__*/e.createElement("div", {
      id: c || null,
      className: "rb-button ".concat(h ? "rb-block-link" : "", " ").concat(d || ""),
      onMouseEnter: function onMouseEnter() {
        return o(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return o(!1);
      },
      onClick: function onClick(e) {
        h && (e.stopPropagation(), window.open(h, g ? "_blank" : "_self"));
      },
      style: x(x(x({}, O(m, i, {
        themeSettingsSeedData: [{
          themeSettingKey: "button"
        }]
      })), s ? O(f, i, {
        themeSettingsSeedData: [{
          themeSettingKey: "buttonHover"
        }]
      }) : {}), p ? {
        width: "100%"
      } : {})
    }, u);
  },
  icon: function icon(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.styles,
      l = i.icon,
      c = i.iconType,
      d = i.newTab,
      p = (i.link || "").trim();
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-icon ".concat(p ? "rb-block-link" : "", " ").concat(s || ""),
      style: O(o, n, {
        themeSettingsSeedData: [{
          themeSettingKey: "body",
          themeSettingObserver: {
            color: "color"
          }
        }]
      }),
      onClick: function onClick(e) {
        p && (e.stopPropagation(), window.open(p, d ? "_blank" : "_self"));
      }
    }, l && /*#__PURE__*/e.createElement("i", {
      className: "".concat(c || "fal", " ").concat(l)
    }));
  },
  audio: function audio(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.audio,
      l = i.autoplay,
      c = i.loop,
      d = i.mute,
      p = i.controls,
      u = i.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-audio flex-box items-center ".concat(s || ""),
      style: O(u, n)
    }, /*#__PURE__*/e.createElement("audio", {
      key: o ? [o.uid, l, c, d, p].map(function (e) {
        return String(e);
      }).join("-") : "",
      type: o ? o.mediaType : "",
      src: o ? o.sourceUrl : "",
      autoPlay: l,
      controls: p,
      muted: d,
      loop: c
    }));
  },
  video: function video(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.video,
      l = i.autoplay,
      c = i.loop,
      d = i.mute,
      p = i.controls,
      u = i.styles;
    return /*#__PURE__*/e.createElement("video", {
      id: a || null,
      className: "rb-video ".concat(s || ""),
      style: O(u, n),
      autoPlay: l,
      controls: p,
      muted: d,
      loop: c
    }, /*#__PURE__*/e.createElement("source", {
      src: o ? o.sourceUrl : "",
      type: o ? o.mediaType : ""
    }));
  },
  blockquote: function blockquote(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes;
    i.quoteSize, i.quoteSizeUnit, i.quoteWeight, i.quoteColor;
    var o = i.styles,
      l = i.quoteStyles,
      c = i.textStyles,
      d = i.text,
      p = i.newTab,
      u = (i.link || "").trim();
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-blockquote ".concat(u ? "rb-block-link" : "", " ").concat(s || ""),
      style: O(o, n, {
        themeSettingsSeedData: M
      }),
      onClick: function onClick(e) {
        u && (e.stopPropagation(), window.open(u, p ? "_blank" : "_self"));
      }
    }, /*#__PURE__*/e.createElement("i", {
      className: "fas fa-ditto",
      style: O(l, n, {
        themeSettingsSeedData: [{
          themeSettingKey: "body",
          themeSettingObserver: {
            color: "color"
          }
        }]
      })
    }), /*#__PURE__*/e.createElement("div", {
      className: "rb-blockquote-text rb-text-content",
      style: O(c, n, {
        themeSettingsSeedData: P
      }),
      dangerouslySetInnerHTML: {
        __html: d
      }
    }));
  },
  youtube: function youtube(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.styles,
      l = i.link,
      c = i.interactive;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-youtube ".concat(s || ""),
      style: O(o, n)
    }, /*#__PURE__*/e.createElement("iframe", {
      id: "video",
      width: "100%",
      height: "100%",
      src: N(l, i),
      title: "YouTube",
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: !0
    }), !c && /*#__PURE__*/e.createElement("div", {
      className: "rb-video-overlay"
    }));
  },
  vimeo: function vimeo(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.showFullscreen,
      l = i.styles,
      c = i.link;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-vimeo ".concat(s || ""),
      style: O(l, n)
    }, /*#__PURE__*/e.createElement("iframe", {
      key: o ? Math.random() : "",
      id: "video",
      width: "100%",
      height: "100%",
      src: D(c, i),
      title: "Vimeo",
      frameBorder: "0",
      allow: "autoplay; picture-in-picture; ".concat(o ? "fullscreen" : ""),
      allowFullScreen: o ? "allowfullscreen" : void 0,
      webkitallowfullscreen: o ? "webkitallowfullscreen" : void 0,
      mozallowfullscreen: o ? "mozallowfullscreen" : void 0,
      msallowfullscreen: o ? "msallowfullscreen" : void 0,
      oallowfullscreen: o ? "oallowfullscreen" : void 0
    }));
  },
  map: function map(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.address,
      l = i.styles;
    ir("".concat(r.id, "-instance"));
    var c = o ? o.location : null;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-map ".concat(s || ""),
      style: O(l, n)
    }, /*#__PURE__*/e.createElement(rr, {
      id: "".concat(r.id, "-instance"),
      mapId: "".concat(r.id, "-instance"),
      defaultCenter: c,
      defaultZoom: 13
    }, /*#__PURE__*/e.createElement(pr, {
      position: c
    })));
  },
  code: function code(t) {
    var r,
      n,
      a = t.item,
      s = a.settings,
      o = s.id,
      l = s.classes,
      c = s.code;
    return i(function () {
      var e = c.match(/<script[\s\S]*?>[\s\S]*?<\/script>/gi),
        t = "";
      e && e.forEach(function (e) {
        t += e.replace(/<script[\s\S]*?>/gi, "\n").replace("<\/script>", "\n");
      });
      var r = document.getElementById(o || a.id);
      if (r && t) {
        var n = document.createElement("script");
        n.type = "text/javascript", n.innerHTML = t, r.appendChild(n);
      }
    }, []), /*#__PURE__*/e.createElement("div", {
      id: o || a.id,
      className: "rb-code ".concat(l || ""),
      dangerouslySetInnerHTML: {
        __html: (r = c, n = c.match(/<script[\s\S]*?>[\s\S]*?<\/script>/gi), n && n.forEach(function (e) {
          r = r.replace(e, "");
        }), r)
      }
    });
  },
  checklist: function checklist(t) {
    var r,
      n = t.item,
      i = t.deviceType,
      a = t.renderItem,
      s = n.settings,
      o = s.id,
      l = s.classes,
      c = s.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: o || null,
      className: "rb-checklist flex-box flex-column ".concat(l || ""),
      style: O(c, i)
    }, n.items && (r = n, r.items ? r.items.map(function (e) {
      var t = x({}, e);
      return t.settings.styles = x(x({}, t.settings.styles), r.settings.checklistItemStyles), t.settings.iconStyles = x(x({}, t.settings.iconStyles), r.settings.checklistItemIconStyles), t.settings.iconType = r.settings.iconType, t;
    }) : []).map(function (e) {
      return a(e);
    }));
  },
  checklistItem: function checklistItem(t) {
    var r = t.item,
      n = t.deviceType,
      i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.styles,
      l = i.iconType,
      c = i.iconStyles,
      d = i.title;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-checklist-item flex-box items-center ".concat(s || ""),
      style: O(o, n, {
        themeSettingsSeedData: M
      })
    }, /*#__PURE__*/e.createElement("i", {
      className: "fal ".concat("plain" === l ? "fa-check" : "fa-check-circle"),
      style: O(c, n, {
        themeSettingsSeedData: [{
          themeSettingKey: "body",
          themeSettingObserver: {
            color: "color"
          }
        }]
      })
    }), /*#__PURE__*/e.createElement("div", {
      className: "rb-checklist-item-title"
    }, d));
  },
  skillBars: function skillBars(t) {
    var r,
      n = t.item,
      i = t.deviceType,
      a = t.renderItem,
      s = n.settings,
      o = s.id,
      l = s.classes,
      c = s.styles;
    return /*#__PURE__*/e.createElement("div", {
      id: o || null,
      className: "rb-skill-bars ".concat(l || ""),
      style: O(c, i)
    }, n.items && (r = n, r.items ? r.items.map(function (e) {
      var t = x({}, e);
      return t.settings.styles = r.settings.skillBarStyles, t.settings.textStyles = x(x({}, t.settings.textStyles), r.settings.skillBarTextStyles), t.settings.barStyles = r.settings.skillBarBarStyles, t;
    }) : []).map(function (e) {
      return a(e);
    }));
  },
  skillBar: function skillBar(t) {
    var n,
      i = t.item,
      a = t.deviceType,
      s = T(r(!1), 2),
      o = s[0],
      l = s[1],
      c = i.settings,
      d = c.id,
      p = c.classes,
      u = c.styles,
      m = c.textStyles,
      f = c.barStyles,
      g = c.percentage,
      h = c.title,
      b = c.barColor || (null === (n = ThemeSettings.colors) || void 0 === n ? void 0 : n.colorScheme);
    return /*#__PURE__*/e.createElement("div", {
      id: d || null,
      className: "rb-skill-bar ".concat(p || ""),
      style: O(u, a)
    }, /*#__PURE__*/e.createElement("div", {
      style: O(m, a, {
        themeSettingsSeedData: M
      })
    }, h), /*#__PURE__*/e.createElement("div", {
      className: "rb-bar",
      style: O(f, a),
      onMouseEnter: function onMouseEnter() {
        return l(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return l(!1);
      }
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-filled-bar",
      style: {
        backgroundColor: b,
        width: "".concat(g, "%")
      }
    }, o && /*#__PURE__*/e.createElement("div", {
      className: "rb-tooltip flex-box items-center",
      style: {
        backgroundColor: b
      }
    }, g, "%"))));
  },
  testimonials: function testimonials(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.renderItem,
      a = r.id,
      s = r.classes,
      o = r.settings;
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-testimonials ".concat(s || ""),
      style: O(o.styles, n)
    }, /*#__PURE__*/e.createElement(F, {
      settings: o,
      deviceType: n
    }, /*#__PURE__*/e.createElement(xt, {
      item: r,
      deviceType: n,
      renderItem: i,
      blockItemsParser: mr
    })));
  },
  testimonial: function testimonial(t) {
    var r = t.item,
      n = t.deviceType;
    t.renderItem;
    var i = r.settings,
      a = i.id,
      s = i.classes,
      o = i.wrapperStyles,
      l = i.imageStyles,
      c = i.titleStyles,
      d = i.title,
      p = i.text,
      u = i.newTab,
      m = i.styles,
      f = i.image,
      g = i.variant,
      h = i.alternativeName,
      b = (i.link || "").trim();
    return /*#__PURE__*/e.createElement("div", {
      id: a || null,
      className: "rb-testimonial ".concat(b ? "rb-block-link" : "", " ").concat(s || ""),
      style: O(o, n),
      onClick: function onClick(e) {
        b && (e.stopPropagation(), window.open(b, u ? "_blank" : "_self"));
      }
    }, /*#__PURE__*/e.createElement(F, {
      settings: i,
      deviceType: n,
      className: "flex" === m.display ? "flex-column" : ""
    }, f && /*#__PURE__*/e.createElement("img", {
      style: O(l, n),
      src: g && f.variants ? f.variants[g].sourceUrl : f.sourceUrl,
      alt: h || ""
    }), /*#__PURE__*/e.createElement("div", {
      className: "rb-testimonial-title",
      style: O(c, n, {
        themeSettingsSeedData: M
      })
    }, d), /*#__PURE__*/e.createElement("div", {
      className: "rb-testimonial-content rb-text-content",
      style: O({}, n, {
        themeSettingsSeedData: P
      }),
      dangerouslySetInnerHTML: {
        __html: p
      }
    })));
  },
  form: function form(t) {
    var a = t.item,
      s = t.deviceType,
      o = t.renderItem,
      l = t.extraData,
      c = T(r({}), 2),
      d = c[0],
      p = c[1],
      u = T(r(!1), 2),
      m = u[0],
      h = u[1],
      b = T(r(!1), 2),
      v = b[0],
      y = b[1],
      S = n(null);
    i(function () {
      if (l.reCaptchaSiteKey && !document.querySelector("script#google-captcha-script")) {
        var e = document.createElement("script");
        e.src = "//www.google.com/recaptcha/api.js?render=".concat(l.reCaptchaSiteKey), e.id = "google-captcha-script", document.body.appendChild(e);
      }
    }, []), a.items && a.items.length;
    var E = a.settings,
      k = E.id,
      A = E.classes,
      C = E.wrapperStyles,
      P = E.title,
      L = E.titleStyles;
    function I() {
      a.items.filter(function (e) {
        return e.settings.required;
      }).map(function (e) {
        return e.id;
      }).filter(function (e) {
        var t = d[e];
        if (!t) return !0;
        if (t instanceof Array) {
          if (0 === t.length || 0 === t.filter(function (e) {
            return !!e.value;
          }).length) return !0;
        } else {
          if (!("key" in t) && !("value" in t)) return !0;
          if ("key" in t) {
            if (!t.key || "" === t.key) return !0;
          } else if ("value" in t && (!t.value || "" === t.value)) return !0;
        }
        return !1;
      }).length > 0 ? S.current.show(l.translations.flash_messages.fill_all_required_fields, "error") : (h(!0), grecaptcha.ready(function () {
        grecaptcha.execute(l.reCaptchaSiteKey, {
          action: "submit"
        }).then(function (e) {
          var t = {
            success_message: a.settings.submitText,
            send_to: a.settings.bcc,
            title: a.settings.title,
            identifier: a.settings.identifier,
            send_email_to_customer: a.settings.sendEmail
          };
          t.fields = Object.keys(d).map(function (e) {
            var t = d[e],
              r = a.items.find(function (t) {
                return t.id === e;
              });
            if (t instanceof Array) return {
              identifier: r.settings.identifier || e,
              label: r.settings.label,
              value: t.filter(function (e) {
                return !!e.value;
              }).map(function (e) {
                var t = r.items.find(function (t) {
                  return t.id === e.key;
                });
                return t.settings.title || t.settings.label || t.settings.identifier || e.key;
              }).join(", ")
            };
            if (t.key) {
              var n = a.items.find(function (t) {
                  return t.id === e;
                }),
                i = n.items.find(function (e) {
                  return e.id === t.key;
                });
              return {
                identifier: n.settings.identifier || e,
                label: n.settings.label,
                value: i.settings.title || i.settings.label || i.settings.identifier || t.key
              };
            }
            return {
              identifier: r.settings.identifier || e,
              label: r.settings.label,
              value: t.value
            };
          }).filter(function (e) {
            return !!e.value && "" !== e.value;
          });
          var r = new FormData();
          r.append("contact_form", JSON.stringify(t)), r.append("v2", !0), r.append("recaptcha_token", e), Rails.ajax({
            type: "POST",
            url: l.builderSubmitFormPath,
            dataType: "json",
            data: r,
            success: function success(e) {
              h(!1), S.current.show(a.settings.submitText && "" !== a.settings.submitText ? a.settings.submitText : l.translations.flash_messages.form_submitted_successfully), y(!0), "redirect" === a.settings.submitAction && a.settings.redirectUrl && "" !== a.settings.redirectUrl && (location.href = a.settings.redirectUrl);
            },
            error: function error(e) {
              h(!1), S.current.show(l.translations.flash_messages.generic_error);
            }
          });
        });
      }));
    }
    function z(e, t) {
      p(arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? function (r) {
        var n = x({}, r);
        if (n[e]) {
          var i = t.key,
            a = n[e].find(function (e) {
              return e.key === i;
            });
          a ? a.value = t.value : n[e].push(t);
        } else n[e] = [t];
        return n;
      } : function (r) {
        return x(x({}, r), {}, w({}, e, t));
      });
    }
    return /*#__PURE__*/e.createElement(e.Fragment, null, /*#__PURE__*/e.createElement("div", {
      id: k || null,
      className: "rb-form ".concat(A || ""),
      style: O(C, s)
    }, /*#__PURE__*/e.createElement(F, {
      settings: E,
      deviceType: s,
      className: "flex-box flex-column"
    }, /*#__PURE__*/e.createElement("div", {
      style: O(L, s, {
        themeSettingsSeedData: M
      })
    }, P), a.items && a.items.map(function (e) {
      return o(e, "formSubmit" === e.blockType ? {
        onClick: I,
        hidden: m || v
      } : {
        onChange: z
      });
    })), m && /*#__PURE__*/e.createElement(f, {
      size: "medium",
      position: "center"
    })), /*#__PURE__*/e.createElement(g, {
      ref: S
    }));
  },
  formEmail: function formEmail(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.onChange,
      a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.styles,
      c = a.label,
      d = a.placeholder,
      p = a.required;
    return a.identifier, /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-form-email flex-box flex-column ".concat(o || ""),
      style: O(l, n)
    }, /*#__PURE__*/e.createElement("label", {
      className: "flex-box items-center",
      style: O({}, n, {
        themeSettingsSeedData: M
      })
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-label"
    }, c), p && /*#__PURE__*/e.createElement(e.Fragment, null, " *")), /*#__PURE__*/e.createElement("input", {
      type: "email",
      placeholder: d,
      style: O({}, n, {
        themeSettingsSeedData: [].concat(k(M), [{
          themeSettingKey: "input"
        }])
      }),
      onChange: function onChange(e) {
        i(r.id, {
          value: e.target.value
        });
      }
    }));
  },
  formInput: function formInput(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.onChange,
      a = r.settings,
      s = a.id,
      o = a.classes,
      l = a.styles,
      c = a.label,
      d = a.placeholder,
      p = a.required,
      u = a.inputType,
      m = M;
    return m = [].concat(k(m), "textArea" === u ? [{
      themeSettingKey: "textArea"
    }, {
      themeSettingKey: "input"
    }] : [{
      themeSettingKey: "input"
    }]), /*#__PURE__*/e.createElement("div", {
      id: s || null,
      className: "rb-form-input flex-box flex-column ".concat(o || ""),
      style: O(l, n)
    }, /*#__PURE__*/e.createElement("label", {
      className: "flex-box items-center",
      style: O({}, n, {
        themeSettingsSeedData: M
      })
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-label"
    }, c), p && /*#__PURE__*/e.createElement(e.Fragment, null, " *")), "input" === u && /*#__PURE__*/e.createElement("input", {
      type: "text",
      placeholder: d,
      style: O({}, n, {
        themeSettingsSeedData: m
      }),
      onChange: function onChange(e) {
        i(r.id, {
          value: e.target.value
        });
      }
    }), "textArea" === u && /*#__PURE__*/e.createElement("textarea", {
      placeholder: d,
      style: O({}, n, {
        themeSettingsSeedData: m
      }),
      onChange: function onChange(e) {
        i(r.id, {
          value: e.target.value
        });
      }
    }));
  },
  formDropdown: function formDropdown(t) {
    var n = t.item,
      a = t.deviceType,
      s = t.renderItem,
      o = t.onChange,
      l = T(r(!1), 2),
      c = l[0],
      d = l[1],
      p = T(r(n.settings.defaultItemId || null), 2),
      u = p[0],
      m = p[1],
      f = T(r(!1), 2),
      g = f[0],
      h = f[1],
      b = n.settings,
      v = b.id,
      w = b.classes;
    b.styles;
    var y = b.label;
    b.placeholder;
    var S = b.required,
      E = u ? n.items.find(function (e) {
        return e.id === u;
      }) : null;
    i(function () {
      u && o(n.id, {
        key: u
      });
    }, [u]);
    var k,
      A,
      C,
      P,
      L = O({}, a, {
        themeSettingsSeedData: M
      });
    function I(e, t) {
      e.stopPropagation(), m(t), d(!1);
    }
    return g && (L = x(x({}, L), {}, {
      color: null === (k = ThemeSettings.colors) || void 0 === k ? void 0 : k.colorScheme
    })), /*#__PURE__*/e.createElement("div", {
      id: v || null,
      className: "rb-form-dropdown ".concat(w || "")
    }, /*#__PURE__*/e.createElement("label", {
      className: "flex-box items-center",
      style: O({}, a, {
        themeSettingsSeedData: M
      })
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-label"
    }, y), S && /*#__PURE__*/e.createElement(e.Fragment, null, " *")), /*#__PURE__*/e.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation(), d(function (e) {
          return !e;
        });
      },
      className: "rb-form-dropdown-input flex-box items-center content-space-between",
      style: O({}, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "input"
        }]
      })
    }, /*#__PURE__*/e.createElement("div", {
      style: O({}, a, {
        themeSettingsSeedData: M
      })
    }, E ? (C = E.settings.title, P = 20, C.length <= P ? C : C.slice(0, P) + "...") : "-"), /*#__PURE__*/e.createElement("i", {
      className: "fal ".concat(c ? "fa-angle-up" : "fa-angle-down")
    })), c && /*#__PURE__*/e.createElement("div", {
      className: "rb-form-dropdown-menu-wrapper",
      style: O({}, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "input"
        }]
      })
    }, /*#__PURE__*/e.createElement("div", {
      onClick: function onClick(e) {
        return I(e, null);
      },
      onMouseEnter: function onMouseEnter() {
        return h(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return h(!1);
      },
      className: "rb-form-dropdown-item",
      style: L
    }, "-"), /*#__PURE__*/e.createElement("div", {
      className: "rb-form-dropdown-divider",
      style: O({}, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "input",
          themeSettingObserver: {
            background: "borderColor"
          }
        }]
      })
    }), n.items && (A = n, A.items ? A.items.map(function (e, t) {
      var r = x({}, e);
      return r.settings.isLast = A.items.length - 1 === t, r;
    }) : []).map(function (e) {
      return s(e, {
        setSelectedItemId: I
      });
    })));
  },
  formDropdownItem: function formDropdownItem(t) {
    var n,
      i = t.item,
      a = t.deviceType,
      s = t.setSelectedItemId,
      o = T(r(!1), 2),
      l = o[0],
      c = o[1],
      d = i.settings,
      p = d.title,
      u = d.isLast,
      m = O({}, a, {
        themeSettingsSeedData: M
      });
    return l && (m = x(x({}, m), {}, {
      color: null === (n = ThemeSettings.colors) || void 0 === n ? void 0 : n.colorScheme
    })), /*#__PURE__*/e.createElement(e.Fragment, null, /*#__PURE__*/e.createElement("div", {
      onClick: function onClick(e) {
        return s(e, i.id);
      },
      onMouseEnter: function onMouseEnter() {
        return c(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return c(!1);
      },
      className: "rb-form-dropdown-item flex-box items-center"
    }, /*#__PURE__*/e.createElement("div", {
      style: m
    }, p)), !u && /*#__PURE__*/e.createElement("div", {
      className: "rb-form-dropdown-divider",
      style: O({}, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "input",
          themeSettingObserver: {
            background: "borderColor"
          }
        }]
      })
    }));
  },
  formCheckbox: function formCheckbox(t) {
    var r = t.item,
      n = t.deviceType,
      a = t.renderItem,
      s = t.onChange,
      o = r.settings,
      l = o.id,
      c = o.classes,
      d = o.styles,
      p = o.label;
    o.placeholder;
    var u,
      m = o.required;
    function f(e, t) {
      s(r.id, {
        key: e,
        value: t
      }, !0);
    }
    return i(function () {
      r.settings.defaultItemId && s(r.id, {
        key: r.settings.defaultItemId,
        value: !0
      }, !0);
    }, []), /*#__PURE__*/e.createElement("div", {
      id: l || null,
      className: "rb-form-checkbox ".concat(c || "")
    }, /*#__PURE__*/e.createElement("label", {
      className: "flex-box items-center",
      style: O({}, n, {
        themeSettingsSeedData: M
      })
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-label"
    }, p), m && /*#__PURE__*/e.createElement(e.Fragment, null, " *")), /*#__PURE__*/e.createElement("div", {
      className: "flex-box flex-column",
      style: O(d, n)
    }, r.items && (u = r, u.items ? u.items.map(function (e) {
      var t = x({}, e);
      return t.settings.isChecked = t.id === u.settings.defaultItemId, t;
    }) : []).map(function (e) {
      return a(e, {
        onChange: f
      });
    })));
  },
  formCheckboxItem: function formCheckboxItem(t) {
    var n = t.item,
      a = t.deviceType,
      s = t.onChange,
      o = T(r(n.settings.isChecked), 2),
      l = o[0],
      c = o[1];
    i(function () {
      s(n.id, l);
    }, [l]);
    var d = n.settings.title,
      p = [{
        themeSettingKey: "button",
        themeSettingObserver: {
          borderColor: "borderColor"
        }
      }];
    return l && p.push({
      themeSettingKey: "button",
      themeSettingObserver: {
        backgroundColor: "backgroundColor"
      }
    }), /*#__PURE__*/e.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation(), c(function (e) {
          return !e;
        });
      },
      className: "rb-form-checkbox-item flex-box items-center"
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-checkbox-item-box-wrapper flex-box items-center content-center",
      style: O({}, a, {
        themeSettingsSeedData: p
      })
    }, l && /*#__PURE__*/e.createElement("i", {
      className: "fas fa-check",
      style: O({}, a, {
        themeSettingsSeedData: [{
          themeSettingKey: "button",
          themeSettingObserver: {
            color: "color"
          }
        }]
      })
    })), /*#__PURE__*/e.createElement("div", {
      style: O({}, a, {
        themeSettingsSeedData: M
      })
    }, d));
  },
  formRadio: function formRadio(t) {
    var n = t.item,
      a = t.deviceType,
      s = t.renderItem,
      o = t.onChange,
      l = T(r(n.settings.defaultItemId), 2),
      c = l[0],
      d = l[1],
      p = n.settings,
      u = p.id,
      m = p.classes,
      f = p.styles,
      g = p.label;
    p.placeholder;
    var h = p.required;
    return i(function () {
      c && o(n.id, {
        key: c
      });
    }, [c]), /*#__PURE__*/e.createElement("div", {
      id: u || null,
      className: "rb-form-radio ".concat(m || "")
    }, /*#__PURE__*/e.createElement("label", {
      className: "flex-box items-center",
      style: O({}, a, {
        themeSettingsSeedData: M
      })
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-label"
    }, g), h && /*#__PURE__*/e.createElement(e.Fragment, null, " *")), /*#__PURE__*/e.createElement("div", {
      className: "flex-box flex-column",
      style: O(f, a)
    }, n.items && function (e, t) {
      return e.items ? e.items.map(function (e) {
        var r = x({}, e);
        return r.settings.isChecked = r.id === t, r;
      }) : [];
    }(n, c).map(function (e) {
      return s(e, {
        setCheckedItemId: d
      });
    })));
  },
  formRadioItem: function formRadioItem(t) {
    var r = t.item,
      n = t.deviceType,
      i = t.setCheckedItemId,
      a = r.settings,
      s = a.title,
      o = a.isChecked,
      l = [{
        themeSettingKey: "button",
        themeSettingObserver: {
          borderColor: "borderColor"
        }
      }];
    return o && l.push({
      themeSettingKey: "button",
      themeSettingObserver: {
        backgroundColor: "backgroundColor"
      }
    }), /*#__PURE__*/e.createElement("div", {
      onClick: function onClick(e) {
        return function (e, t) {
          e.stopPropagation(), i(t);
        }(e, r.id);
      },
      className: "rb-form-radio-item flex-box items-center"
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-form-radio-item-outer-box flex-box items-center content-center",
      style: O({}, n, {
        themeSettingsSeedData: l
      })
    }, o && /*#__PURE__*/e.createElement("div", {
      className: "rb-form-radio-item-inner-box",
      style: O({}, n, {
        themeSettingsSeedData: [{
          themeSettingKey: "button",
          themeSettingObserver: {
            backgroundColor: "color"
          }
        }]
      })
    })), /*#__PURE__*/e.createElement("div", {
      style: O({}, n, {
        themeSettingsSeedData: M
      })
    }, s));
  },
  formSubmit: function formSubmit(t) {
    var n = t.item,
      i = t.deviceType,
      a = t.onClick,
      s = t.hidden,
      o = T(r(!1), 2),
      l = o[0],
      c = o[1],
      d = n.settings,
      p = d.id,
      u = d.classes,
      m = d.wrapperStyles,
      f = d.styles,
      g = d.hoverStyles,
      h = d.fullWidth,
      b = d.title;
    return /*#__PURE__*/e.createElement(e.Fragment, null, !s && /*#__PURE__*/e.createElement("div", {
      id: p || null,
      className: "rb-form-submit-wrapper flex-box ".concat(u || ""),
      style: O(m, i)
    }, /*#__PURE__*/e.createElement("div", {
      onMouseEnter: function onMouseEnter() {
        return c(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return c(!1);
      },
      onClick: a,
      className: "rb-form-submit flex-box",
      style: x(x(x({}, O(f, i, {
        themeSettingsSeedData: [{
          themeSettingKey: "button"
        }]
      })), l ? O(g, i, {
        themeSettingsSeedData: [{
          themeSettingKey: "buttonHover"
        }]
      }) : {}), h ? {
        width: "100%"
      } : {})
    }, /*#__PURE__*/e.createElement("div", {
      className: "rb-button-text flex-1"
    }, b))));
  }
};
function gr(t) {
  var a = t.contentUrl,
    s = t.googleCloudBucket,
    l = t.settings,
    c = t.extraData,
    d = T(r([]), 2),
    u = d[0],
    m = d[1],
    f = T(r(!1), 2),
    g = f[0],
    h = f[1],
    b = T(r("desktop"), 2),
    w = b[0],
    S = b[1],
    x = n(null),
    k = (l || {}).google_maps_key;
  i(function () {
    A(), function () {
      M.apply(this, arguments);
    }(), function () {
      C.apply(this, arguments);
    }(), window.addEventListener("resize", function () {
      x.current && clearTimeout(x.current), x.current = setTimeout(A, 100);
    });
  }, []);
  var A = p(function () {
    var e = window.innerWidth;
    S(e > 990 ? "desktop" : e > 768 ? "laptop" : e > 480 ? "tablet" : "mobile");
  }, []);
  function C() {
    return (C = v(E().mark(function e() {
      var t, r;
      return E().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!a) {
              e.next = 8;
              break;
            }
            return e.next = 3, fetch(a, {
              method: "GET"
            });
          case 3:
            return t = e.sent, e.next = 6, t.json();
          case 6:
            (r = e.sent) && m(r);
          case 8:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function M() {
    return (M = v(E().mark(function e() {
      var t, r;
      return E().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.prev = 0, e.next = 3, fetch("https://storage.googleapis.com/download/storage/v1/b/".concat(s, "/o/theme_settings.json?alt=media"), {
              method: "GET"
            });
          case 3:
            return t = e.sent, e.next = 6, t.json();
          case 6:
            (r = e.sent) && (window.ThemeSettings = r, h(!0)), e.next = 12;
            break;
          case 10:
            e.prev = 10, e.t0 = e.catch(0);
          case 12:
          case "end":
            return e.stop();
        }
      }, e, null, [[0, 10]]);
    }))).apply(this, arguments);
  }
  function P(t) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = fr[t.blockType];
    if (!n && c && c.dynamicBlocks && (n = c.dynamicBlocks[t.blockType]), n) {
      var i = null;
      return ["form", "product", "productList", "meal", "mealList", "rental", "rentalList", "service", "serviceList"].includes(t.blockType) && (i = c, "form" === t.blockType && c && l && l.google_recaptcha_site_key && (i.reCaptchaSiteKey = l.google_recaptcha_site_key)), /*#__PURE__*/e.createElement(n, y({}, r, {
        key: t.id,
        item: t,
        deviceType: w,
        renderItem: P,
        extraData: i
      }));
    }
  }
  var L = o(function () {
    return Object.keys(ThemeSettings).length ? /*#__PURE__*/e.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: "\n        .reactive-builder-wrapper { ".concat(B() || "", " }\n      ")
      }
    }) : null;
  }, [JSON.stringify(ThemeSettings)]);
  return o(function () {
    return /*#__PURE__*/e.createElement(e.Fragment, null, /*#__PURE__*/e.createElement("div", {
      className: "reactive-builder-wrapper flex-box flex-column items-center"
    }, u.length > 0 && /*#__PURE__*/e.createElement(Ft, {
      apiKey: k
    }, u.map(function (e) {
      return P(e);
    }))), L);
  }, [u, g, w]);
}
export { gr as default };